import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
};

export type ActionResponseMessageOutput = {
  __typename?: 'ActionResponseMessageOutput';
  /** Response code for an action that does not throw back an Object */
  code: MessageCodeOption;
  /** Response message */
  message: Scalars['String']['output'];
  /** Type of action response */
  responseType: ResponseType;
};

/** Represents an address entity with details about location for GraphQL output. */
export type AddressOutput = {
  __typename?: 'AddressOutput';
  /** Additional address line, if applicable. */
  addressLine?: Maybe<Scalars['String']['output']>;
  /** The building number of the address. */
  buildingNumber: Scalars['String']['output'];
  /** The city where the address is located. */
  city?: Maybe<CityOutput>;
  /** The country where the address is located. */
  country?: Maybe<CountryOutput>;
  /** Unique identifier for the address. */
  id: Scalars['ID']['output'];
  /** The state where the address is located. */
  state?: Maybe<StateOutput>;
  /** The street name of the address. */
  street: Scalars['String']['output'];
  /** The postal code of the address. */
  zipCode: Scalars['String']['output'];
};

export type AlertNoticeOutput = {
  __typename?: 'AlertNoticeOutput';
  /** When the alert/rent charge was created */
  createdAt: Scalars['DateTime']['output'];
  /** When the rent was due (for relative time display like "3 days ago") */
  dueDate: Scalars['DateTime']['output'];
  /** Unique identifier (rent charge id) */
  id: Scalars['ID']['output'];
  /** Full alert message e.g. "Andre Wright has not paid rent of February 2024" */
  message: Scalars['String']['output'];
  /** Period e.g. "February 2024" */
  period: Scalars['String']['output'];
  /** Rent charge id for navigation */
  rentChargeId?: Maybe<Scalars['ID']['output']>;
  /** Tenant full name */
  tenantName: Scalars['String']['output'];
};

/** Lista paginada de avisos de alquiler impago (rent charges). */
export type AlertNoticesPaginatedOutput = {
  __typename?: 'AlertNoticesPaginatedOutput';
  items: Array<AlertNoticeOutput>;
  pagination: PaginationMetaOutput;
};

/** Availability slot for incident appointment scheduling. */
export type AppointmentSlotOutput = {
  __typename?: 'AppointmentSlotOutput';
  createdAt: Scalars['DateTime']['output'];
  endAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  selectedAt?: Maybe<Scalars['DateTime']['output']>;
  startAt: Scalars['DateTime']['output'];
  status: AppointmentSlotStatusOption;
  updatedAt: Scalars['DateTime']['output'];
};

/** Lifecycle state for an appointment slot. */
export enum AppointmentSlotStatusOption {
  Available = 'AVAILABLE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Selected = 'SELECTED'
}

/** Represents a bank account with its details for GraphQL output. */
export type BankAccountOutput = {
  __typename?: 'BankAccountOutput';
  /** Account number of a bank account */
  accountNumber: Scalars['String']['output'];
  /** email of the holder of a Banck account */
  email: Scalars['String']['output'];
  /** Name of the bank holder */
  holderName: Scalars['String']['output'];
  /** Id of a Bank account */
  id: Scalars['ID']['output'];
  /** Name of the bank of a Banck account */
  name: Scalars['String']['output'];
  /** Phone number of the holder of a Banck account */
  phone: Scalars['String']['output'];
};

/** Size options available for describin bed size */
export enum BedSizeOption {
  Double = 'DOUBLE',
  King = 'KING',
  Queen = 'QUEEN',
  Twin = 'TWIN',
  TwinXl = 'TWIN_XL'
}

/** Represents a billing entity containing payment and address details for GraphQL output. */
export type BillingOutput = {
  __typename?: 'BillingOutput';
  /** Address associated with the billing. */
  address: AddressOutput;
  /** Bank Identifier Code (BIC) for the billing. */
  bic: Scalars['String']['output'];
  /** Firstname associated with the billing entity. */
  firstName: Scalars['String']['output'];
  /** Unique identifier for the billing entity. */
  id: Scalars['ID']['output'];
  /** Lastname associated with the billing entity. */
  lastName: Scalars['String']['output'];
  /** List of observations or notes related to the billing. */
  observations: Array<NoteOutput>;
  /** Payment method associated with the billing. */
  paymentMethodOption: PaymentMethodOption;
  /** Reference code for the billing entity. */
  reference: Scalars['String']['output'];
  /** Destination or purpose of the billing. */
  wereGoing: Scalars['String']['output'];
};

/** Represents a budget for a task or incident for GraphQL output. */
export type BudgetOutput = {
  __typename?: 'BudgetOutput';
  /** The cost associated with the budget. */
  budgetCost: Scalars['String']['output'];
  /** The earning or revenue associated with the budget. */
  budgetEarning: Scalars['String']['output'];
  /** The current status of the budget. */
  budgetStatusOption: BudgetStatusOption;
  /** Unique identifier for the budget. */
  id: Scalars['ID']['output'];
  notes: Array<NoteOutput>;
  /** Subject or title of the budget. */
  subject: Scalars['String']['output'];
  supplier: SupplierOutput;
};

/** Represent status of Budgets can have */
export enum BudgetStatusOption {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ChangePasswordInput = {
  /** The new password to replace the old one */
  newPassword: Scalars['String']['input'];
  /** The current password of the user */
  oldPassword: Scalars['String']['input'];
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  oldPasswordWrong: Scalars['Boolean']['output'];
  paswordWasUpdated: Scalars['Boolean']['output'];
};

/** Represents a city, including its name, coordinates, and administrative divisions for GraphQL output. */
export type CityOutput = {
  __typename?: 'CityOutput';
  country: CountryOutput;
  /** Unique GeoNames ID for the city (e.g., geonameid from cities500.txt). */
  geonamesId: Scalars['String']['output'];
  /** Latitude coordinate of the city. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Longitude coordinate of the city. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Name of the city (e.g., "New York City", "Mar del Plata") dependent on preferred user language. */
  name: Scalars['String']['output'];
  state: StateOutput;
};

/** Defines the types of client applications, such as user-facing and manager-facing apps. */
export enum ClientAppTypeOption {
  Manager = 'MANAGER',
  User = 'USER'
}

/** Status of a communication for a specific recipient (sent, read, archived) */
export enum CommunicationRecipientStatusOption {
  Archived = 'ARCHIVED',
  Read = 'READ',
  Sent = 'SENT'
}

export type ConfirmPropertyFileUploadInput = {
  fileIds: Array<Scalars['String']['input']>;
  propertyId: Scalars['String']['input'];
};

/** Contact information */
export type ContactOutput = {
  __typename?: 'ContactOutput';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

/** Contract filter input params */
export type ContractFilterInput = {
  /** Dirección de la propiedad: ciudad (geonamesId). */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Dirección de la propiedad: país ISO2 (ej. AR). */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** Contratos creados desde esta fecha (inicio del día). No combinar con year/month. */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Contratos creados hasta esta fecha (fin del día). */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  endMonth?: InputMaybe<Scalars['String']['input']>;
  leaseTerm?: InputMaybe<LeaseTermOption>;
  /** Mes 1–12; si falta year se usa el año actual. */
  month?: InputMaybe<Scalars['Int']['input']>;
  orderDirection?: InputMaybe<OrderDirectionOption>;
  page?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<PageSizeOption>;
  /** Filtrar por propiedad (ID). Opcional; compatible con listados existentes. */
  propertyId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
  /** Dirección de la propiedad: estado GeoNames admin1 (ej. AR.01). */
  stateId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContractStatusOption>;
  /** Contratos creados en este año calendario (con month, ese mes). No combinar con dateFrom/dateTo. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractNotificationData = {
  __typename?: 'ContractNotificationData';
  contractId: Scalars['ID']['output'];
  propertyName?: Maybe<Scalars['String']['output']>;
  tenantName?: Maybe<Scalars['String']['output']>;
};

/** Represents a rental contract for a unity for GraphQL output. */
export type ContractOutput = {
  __typename?: 'ContractOutput';
  /** The date when the contract was created */
  createdAt: Scalars['DateTime']['output'];
  /** Day of th month when rent charges will be executed */
  dayForExecuteCharges: Scalars['String']['output'];
  /** The date when the contract ends, if applicable */
  finishDate?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the contract. */
  id: Scalars['ID']['output'];
  incidents: Array<IncidentOutput>;
  /** Indicates whether the contract is auto-generated */
  isAutoGenerateRentCharges: Scalars['Boolean']['output'];
  /** Date and time when the keys were delivered to the tenant */
  keysDelivered?: Maybe<Scalars['DateTime']['output']>;
  /** Date and time when the keys were received back */
  keysReceived?: Maybe<Scalars['DateTime']['output']>;
  /** Number of days after which late fees are applied */
  lateFeeDays: Scalars['Int']['output'];
  /** The lease term option associated with the contract */
  leaseTermOption: LeaseTermOption;
  /** The total monthly charge amount for the contract as a string */
  monthlyChargeAmount?: Maybe<Scalars['String']['output']>;
  notes: Array<NoteOutput>;
  owner?: Maybe<OwnerOutput>;
  property?: Maybe<PropertyOutput>;
  /** The total rent amount for the contract as a string */
  rentAmount?: Maybe<Scalars['String']['output']>;
  rentCharges: Array<RentChargeOutput>;
  /** Indicates whether the contract has been signed */
  signed: Scalars['Boolean']['output'];
  /** The date when charges start for the contract */
  startDate: Scalars['DateTime']['output'];
  /** The current status of the contract */
  statusOption: ContractStatusOption;
  tenant?: Maybe<TenantOutput>;
  unities: Array<UnityOutput>;
};

/** Represents the various statuses a contract can have during its lifecycle. */
export enum ContractStatusOption {
  Booking = 'BOOKING',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Initiated = 'INITIATED',
  NotIssued = 'NOT_ISSUED'
}

export type ContractsByStatusOutput = {
  __typename?: 'ContractsByStatusOutput';
  /** Count of contracts */
  count: Scalars['String']['output'];
  /** Status of the contract */
  status: ContractStatusOption;
};

/** Respuesta paginada de contracts */
export type ContractsPaginatedOutput = {
  __typename?: 'ContractsPaginatedOutput';
  /** Lista de contracts */
  items: Array<ContractOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

/** Represents a country, including its codes, name, and phone code for GraphQL output. */
export type CountryOutput = {
  __typename?: 'CountryOutput';
  /** ISO 3166-1 alpha-2 code (e.g., "US", "AR"). Primary identifier for the country. */
  iso2: Scalars['String']['output'];
  /** ISO 3166-1 alpha-3 code (e.g., "USA", "ARG"). */
  iso3: Scalars['String']['output'];
  /** Full name of the country (e.g., "United States", "Argentina") dependent on preferred user language. */
  name: Scalars['String']['output'];
  /** International dialing code for the country (e.g., "1", "54"). */
  phoneCode?: Maybe<Scalars['String']['output']>;
  states: Array<StateOutput>;
};

/** Single availability window proposed by tenant. */
export type CreateAppointmentSlotInput = {
  /** End datetime for this available slot. */
  endAt: Scalars['DateTime']['input'];
  /** Start datetime for this available slot. */
  startAt: Scalars['DateTime']['input'];
};

/** Batch payload to create availability slots. */
export type CreateAppointmentSlotsInput = {
  /** Availability slots proposed by the tenant. */
  slots: Array<CreateAppointmentSlotInput>;
};

/** Input type for creating a new budget */
export type CreateBudgetInput = {
  /** The total cost associated with the budget */
  budgetCost: Scalars['String']['input'];
  /** The expected earning or revenue from the budget */
  budgetEarning?: InputMaybe<Scalars['String']['input']>;
  /** Additional observations or notes about the budget */
  observation: Scalars['String']['input'];
  /** The subject or title of the budget */
  subject: Scalars['String']['input'];
  /** The ID of the supplier associated with the budget */
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

/** Create a contact */
export type CreateContactInput = {
  /** Email of a contact */
  email: Scalars['String']['input'];
  /** Firstname of a contact */
  firstName: Scalars['String']['input'];
  /** Lastname of a contact */
  lastName: Scalars['String']['input'];
  /** Phone number of a contact */
  phoneNumber: Scalars['String']['input'];
};

/** Input type for creating a new contract */
export type CreateContractInput = {
  /** Day of the month for executing charges */
  dayForExecuteCharges: Scalars['String']['input'];
  /** Amount of the security deposit */
  depositAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Date when the security deposit was received */
  depositReceivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Fixed fiat amount applied as late fees */
  fiatAmountFees?: InputMaybe<Scalars['Float']['input']>;
  /** Optional finish date for the contract */
  finishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indicates whether the rent charge is auto-generated */
  isAutoGenerateRentCharge: Scalars['Boolean']['input'];
  /** Number of days after which late fees are applied */
  lateFeeDays?: InputMaybe<Scalars['Float']['input']>;
  /** Lease term option for the contract */
  leaseTermOption: LeaseTermOption;
  /** Monthly amount for the contract */
  monthlyChargeAmount: Scalars['String']['input'];
  /** Percentage of rent fees applied as late fees */
  percentageOfRentFees?: InputMaybe<Scalars['Float']['input']>;
  /** Id of the property associated with the contract */
  propertyId: Scalars['String']['input'];
  /** List of rent charges associated with the contract */
  rentCharges: Array<CreateRentChargeInput>;
  /** Indicates whether the contract is signed */
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start date for this contract */
  startDate: Scalars['DateTime']['input'];
  /** ID of the tenant involved in the contract */
  tenantId: Scalars['String']['input'];
  /** ID of the unity associated with the contract */
  unitiesIds: Array<Scalars['String']['input']>;
};

export type CreateDepositInput = {
  /** Amount of a new deposit */
  amount: Scalars['String']['input'];
  operationDate: Scalars['DateTime']['input'];
  /** Owner account name of the deposit */
  ownerAccountName: Scalars['String']['input'];
  /** Reference of the deposit */
  reference: Scalars['String']['input'];
};

export type CreateExpenseInput = {
  category: IncidentCategoryOption;
  contractId?: InputMaybe<Scalars['String']['input']>;
  /** Moneda en la que se registra el gasto */
  currency: CurrencyOption;
  /** Fecha del gasto en formato YYYY-MM-DD */
  date: Scalars['String']['input'];
  description: Scalars['String']['input'];
  expenseCost: Scalars['String']['input'];
  incidentId?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: Scalars['String']['input'];
  origin?: InputMaybe<ExpenseOriginInput>;
  title: Scalars['String']['input'];
};

export type CreateIncidentExpenseInput = {
  amount: Scalars['String']['input'];
  description: Scalars['String']['input'];
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumber: Scalars['String']['input'];
  uploadedFileId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIncidentForTenantResponseUnion = ActionResponseMessageOutput | IncidentOutput;

/** Input type for creating a new incident from tenant account */
export type CreateIncidentFromTenantInput = {
  /** The category of the incident */
  incidentCategory: IncidentCategoryOption;
  /** A note or description of the incident */
  incidentNote: Scalars['String']['input'];
  /** The start date of the incident (optional) */
  startDate: Scalars['DateTime']['input'];
  /** Subject of the incident */
  subject: Scalars['String']['input'];
  /** The unity id associated with the incident */
  unityId: Scalars['String']['input'];
  /** Ids of files that was uploaded for incident */
  uploadedFilesIds: Array<Scalars['String']['input']>;
  /** The type of user reporting or associated with the incident */
  userType: UserTypeOption;
};

/** Input type for creating a new incident */
export type CreateIncidentInput = {
  /** The end date of the incident (optional) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The category of the incident */
  incidentCategory: IncidentCategoryOption;
  /** A note or description of the incident */
  incidentNote: Scalars['String']['input'];
  /** The priority level of the incident (optional) */
  incidentPriority: PriorityOption;
  /** The type of the incident (optional) */
  incidentType: IncidentTypeOption;
  /** The ID of the Property associated with the incident */
  propertyId: Scalars['String']['input'];
  /** The start date of the incident (optional) */
  startDate: Scalars['DateTime']['input'];
  /** Subject of the incident */
  subject: Scalars['String']['input'];
  /** The ID of the supplier associated with the incident (optional) */
  supplierId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Unity associated with the incident */
  unityId?: InputMaybe<Scalars['String']['input']>;
  /** Ids of files that was uploaded for incident */
  uploadedFilesIds: Array<Scalars['String']['input']>;
  /** The type of user reporting or associated with the incident */
  userType: UserTypeOption;
};

export type CreateIncidentReportInput = {
  fileUploadsIds: Array<Scalars['String']['input']>;
  note: CreateNoteInput;
  subject: Scalars['String']['input'];
};

/** Información para crear un registro de seguro */
export type CreateInsuranceInput = {
  /** Documento del titular del seguro (dni_titular_seguro) */
  holderDocument?: InputMaybe<Scalars['String']['input']>;
  /** Corredor del seguro (corredor_seguro) */
  insuranceBroker?: InputMaybe<Scalars['String']['input']>;
  /** Email del corredor del seguro */
  insuranceBrokerEmail?: InputMaybe<Scalars['String']['input']>;
  /** Teléfono del corredor del seguro (telf_corredor_seguro) */
  insuranceBrokerPhone?: InputMaybe<Scalars['String']['input']>;
  /** Nombre de la compañía de seguros (seguro) */
  insuranceCompany: Scalars['String']['input'];
  /** Titular del seguro (titular_seguro) */
  insuranceHolder?: InputMaybe<Scalars['String']['input']>;
  /** Teléfono de la compañía de seguros (telf_seguro) */
  insurancePhone: Scalars['String']['input'];
  /** Número de póliza (poliza) */
  policyNumber: Scalars['String']['input'];
  /** Plan de la póliza (policyPlan) */
  policyPlan?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating a new inventory for a property. */
export type CreateInventoryInput = {
  /** Description of the inventory. */
  description: Scalars['String']['input'];
};

/** Input for creating a new inventory inspection. */
export type CreateInventoryInspectionInput = {
  /** Optional contract ID if the inspection is tied to a contract. */
  contractId?: InputMaybe<Scalars['ID']['input']>;
  /** General notes of the inspection. */
  generalNotes?: InputMaybe<Scalars['String']['input']>;
  /** Date when the inspection took place. */
  inspectionDate: Scalars['DateTime']['input'];
  /** Name of the inspector. */
  inspectorName: Scalars['String']['input'];
  /** Name of the receiver. */
  receiverName: Scalars['String']['input'];
  /** Type of inspection: INITIAL or FINAL. */
  type: InventoryInspectionTypeOption;
};

/** Input type for creating a new inventory item. */
export type CreateInventoryItemInput = {
  /** Description of the inventory item. */
  description: Scalars['String']['input'];
  /** Quantity of this item. */
  quantity: Scalars['String']['input'];
};

/** Input type for creating a new manager */
export type CreateManagerInput = {
  /** The email address of the manager */
  email: Scalars['String']['input'];
  /** The first name of the manager */
  firstName: Scalars['String']['input'];
  /** The last name of the manager */
  lastName: Scalars['String']['input'];
  /** The password for the manager account */
  password: Scalars['String']['input'];
  /** The phone number of the manager */
  phoneNumber: Scalars['String']['input'];
  /** Manager preferred currency for operation */
  preferredCurrency: CurrencyOption;
  /** Preffered user language option */
  userLanguageOption: UserLanguageOption;
};

export type CreateMassiveCommunicationInput = {
  content: Scalars['String']['input'];
  /** Opcional. IDs de usuario que no deben recibir el envío (se quitan del conjunto resuelto). */
  excludeRecipientUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Opcional. Si solo usás recipientUserTypes o propertyIds sin lista explícita, filtra por estas propiedades. Si enviás recipientUserIds, esas personas se envían igual (el filtro por propiedad no las excluye); propertyIds solo valida que el manager gestione esas propiedades. */
  propertyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientUserTypes?: InputMaybe<Array<UserTypeOption>>;
  title: Scalars['String']['input'];
  uploadedFilesIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateMassiveCommunicationTemplateInput = {
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Create a new Message for ending to other user */
export type CreateMessageFromIncidentInput = {
  content: Scalars['String']['input'];
  fileUploadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  messageTransactionId: Scalars['String']['input'];
  userTypeOptionDestiny?: InputMaybe<UserTypeOption>;
};

export type CreateMessageFromIncidentResponseUnion = ActionResponseMessageOutput | CreateMessageOutput;

export type CreateMessageOutput = {
  __typename?: 'CreateMessageOutput';
  messageSent: Scalars['Boolean']['output'];
};

/** Input type for creating a new note */
export type CreateNoteInput = {
  /** The description of the note */
  description: Scalars['String']['input'];
};

/** Input type for creating a new owner contract (Manager → Owner). Uses reference IDs instead of enums. */
export type CreateOwnerContractInput = {
  /** Total contract amount agreed with the owner as string. Will be stored as integer (cents). */
  contractAmount: Scalars['String']['input'];
  /** Finish date of the owner contract. */
  finishDate: Scalars['DateTime']['input'];
  /** Optional ID of the insurance associated with the property and this contract. */
  insuranceId?: InputMaybe<Scalars['ID']['input']>;
  /** Lease term option for this owner contract (backed by LeaseTerm reference table). */
  ownerContractLeaseTypeOption: OwnerContractLeaseTypeOption;
  /** ID of the owner involved in the contract (Owner user ID). */
  ownerId: Scalars['ID']['input'];
  /** Payment frequency option for this owner contract (backed by PaymentFrequency reference table). */
  paymentFrequencyOption: PaymentFrequencyOption;
  /** ID of the property associated with the contract. */
  propertyId: Scalars['ID']['input'];
  /** Start date of the owner contract. */
  startDate: Scalars['DateTime']['input'];
};

/** Input type for creating a new owner */
export type CreateOwnerInput = {
  /** Additional address line for the owner */
  addressLine?: InputMaybe<Scalars['String']['input']>;
  /** Email associated with the owner's bank account */
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  /** Holder name of the owner's bank account */
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  /** Name of the owner's bank account */
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  /** Number of the owner's bank account */
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Phone number associated with the owner's bank account */
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
  /** Birth date of the owner */
  birthDate: Scalars['DateTime']['input'];
  /** Building number of the owner's address */
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  /** City of the owner's address */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Country of the owner's address */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** Document ID of the owner (e.g., passport or ID card) */
  documentId: Scalars['String']['input'];
  /** Email address of the owner */
  email: Scalars['String']['input'];
  /** First name of the owner */
  firstName: Scalars['String']['input'];
  /** Gender option of the owner */
  genderOption: UserGenderTypeOption;
  /** Last name of the owner */
  lastName: Scalars['String']['input'];
  /** Nationality of the owner */
  nationality: Scalars['String']['input'];
  /** Primary phone number of the owner */
  phoneNumber: Scalars['String']['input'];
  /** Secondary phone number of the owner */
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  /** State of the owner's address */
  stateId?: InputMaybe<Scalars['String']['input']>;
  /** Street address of the owner */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Zip code of the owner's address */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating a new property */
export type CreatePropertyInput = {
  /** Additional address information, if any */
  addressLine?: InputMaybe<Scalars['String']['input']>;
  /** Porperty has Balcony */
  balcony: Scalars['Boolean']['input'];
  /** The building number of the property */
  buildingNumber: Scalars['String']['input'];
  /** The city where the property is located */
  cityId: Scalars['String']['input'];
  /** Property has common air conditioner */
  commonAirConditioner: Scalars['Boolean']['input'];
  /** Property has common bathrrom */
  commonBathroom: Scalars['Boolean']['input'];
  /** Property has Fan in common areas */
  commonFan: Scalars['Boolean']['input'];
  /** The country where the property is located */
  countryId: Scalars['String']['input'];
  /** Property has elevator */
  elevator: Scalars['Boolean']['input'];
  /** Property has kitchen */
  kitchen: Scalars['Boolean']['input'];
  /** The name of the property */
  name: Scalars['String']['input'];
  /** The ID of the owner of the property */
  ownerId: Scalars['String']['input'];
  /** Property has patio  */
  patio: Scalars['Boolean']['input'];
  /** The type of the property (e.g., apartment, house, etc.) */
  propertyType: PropertyTypeOption;
  /** The state where the property is located */
  stateId: Scalars['String']['input'];
  /** The street where the property is located */
  street: Scalars['String']['input'];
  /** A list of unities associated with the property */
  unities?: InputMaybe<Array<CreateUnityInput>>;
  /** IDs of uploaded files (images/videos) to associate with the property */
  uploadedFilesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The zip code of the property location */
  zipCode: Scalars['String']['input'];
};

export type CreateRatingInput = {
  /** Optional comment associated with the rating. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Rating value, typically from 1 to 5. */
  value: Scalars['Int']['input'];
};

export type CreateReceiptAggregationInput = {
  charges: Array<ReceiptAggregationItemInput>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReceiptAggregationResponseUnion = ActionResponseMessageOutput | ReceiptAggregationOutput;

/** Input type for creating a new rent charge */
export type CreateRentChargeInput = {
  /** Amount for the rent charge */
  amountValue: Scalars['String']['input'];
  /** Description of the rent charge */
  description: Scalars['String']['input'];
  /** Day that payment have to be excecuted */
  executionDate: Scalars['DateTime']['input'];
  /** Type of the rent charge */
  rentChargeType: RentChargeTypeOption;
};

/** Input data required to create a new supplier */
export type CreateSupplierInput = {
  /** An optional additional address line for the supplier */
  addressLine?: InputMaybe<Scalars['String']['input']>;
  /** Email associated with the supplier's bank account */
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  /** Holder name of the supplier's bank account */
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  /** Name of the supplier's bank account */
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  /** Number of the supplier's bank account */
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Phone number associated with the supplier's bank account */
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
  /** The birth date of the supplier */
  birthDate: Scalars['DateTime']['input'];
  /** The building number of the supplier */
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  /** The city where the supplier is located */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** The country where the supplier is located */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** The document ID of the supplier */
  documentId: Scalars['String']['input'];
  /** The email address of the supplier */
  email: Scalars['String']['input'];
  /** The firstname of the supplier */
  firstName: Scalars['String']['input'];
  /** The gender option of the supplier */
  genderOption: UserGenderTypeOption;
  /** The lastname of the supplier */
  lastName: Scalars['String']['input'];
  /** The nationality of the supplier */
  nationality: Scalars['String']['input'];
  /** The primary phone number of the supplier */
  phoneNumber: Scalars['String']['input'];
  /** An optional secondary phone number for the supplier */
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  /** The state where the supplier is located */
  stateId?: InputMaybe<Scalars['String']['input']>;
  /** The street address of the supplier */
  street?: InputMaybe<Scalars['String']['input']>;
  /** The zip code of the supplier's address */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating a new tenant */
export type CreateTenantInput = {
  /** Additional address line for the tenant (optional) */
  addressLine?: InputMaybe<Scalars['String']['input']>;
  /** Email associated with the tenant's bank account */
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  /** Holder name of the tenant's bank account */
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  /** Name of the tenant's bank */
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  /** Account number of the tenant's bank account */
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Phone associated with the tenant's bank account */
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
  billingAddres1?: InputMaybe<Scalars['String']['input']>;
  billingBic?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingFirstName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingWereGoing?: InputMaybe<Scalars['String']['input']>;
  billingZipCode?: InputMaybe<Scalars['String']['input']>;
  billinglastName?: InputMaybe<Scalars['String']['input']>;
  /** Birth date of the tenant */
  birthDate: Scalars['DateTime']['input'];
  /** Building number of the tenant */
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  /** City of residence of the tenant */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Country of residence of the tenant */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** Document ID of the tenant */
  documentId: Scalars['String']['input'];
  /** Email address of the tenant */
  email: Scalars['String']['input'];
  /** First name of the tenant */
  firstName: Scalars['String']['input'];
  /** Gender option of the tenant */
  genderOption: UserGenderTypeOption;
  /** Last name of the tenant */
  lastName: Scalars['String']['input'];
  /** Nationality of the tenant */
  nationality: Scalars['String']['input'];
  /** Primary phone number of the tenant */
  phoneNumber: Scalars['String']['input'];
  /** Secondary phone number of the tenant (optional) */
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  /** State of residence of the tenant */
  stateId?: InputMaybe<Scalars['String']['input']>;
  /** Street address of the tenant */
  street?: InputMaybe<Scalars['String']['input']>;
  /** ZIP code of the tenant's address */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating a new unity */
export type CreateUnityInput = {
  /** Set if unity has air conditioner */
  airConditioner: Scalars['Boolean']['input'];
  /** The number of bedrooms in the unity */
  bedSizeOption: BedSizeOption;
  /** The current status of the unity */
  currentStatus: UnityStatusOption;
  /** Set if unity has a fan */
  fan: Scalars['Boolean']['input'];
  /** The name of the unity */
  name: Scalars['String']['input'];
  /** Set if unity has a private bathroom */
  privateBathroom: Scalars['Boolean']['input'];
};

/** Currency option available */
export enum CurrencyOption {
  Eur = 'EUR',
  Usd = 'USD'
}

/** Filtro del dashboard: propiedad, ubicación y/o período. Período: usar year (± month) **o** dateFrom/dateTo, no ambos. */
export type DashboardFilterInput = {
  /** Filtrar por ciudad (GeoNames city id). */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar propiedades por país (ISO 3166-1 alpha-2, ej. AR, ES). Compatible con Reports. */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** Inicio del rango de fechas (inclusive, inicio del día). No combinar con year/month. */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Fin del rango de fechas (inclusive, fin del día). No combinar con year/month. */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Mes 1–12. Si se envía sin year, se usa el año actual. Requiere year para períodos explícitos. */
  month?: InputMaybe<Scalars['Int']['input']>;
  /** Limitar métricas a una propiedad del manager (ID). */
  propertyId?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar por provincia/estado (GeoNames admin1 code, ej. AR.01). */
  stateId?: InputMaybe<Scalars['String']['input']>;
  /** Año calendario (p. ej. 2024). Con month, filtra ese mes; sin month, todo el año. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardOutput = {
  __typename?: 'DashboardOutput';
  alertNotices: Array<AlertNoticeOutput>;
  contractsByStatus: Array<ContractsByStatusOutput>;
  incidentsByStatus: Array<IncidentsByStatusOutput>;
  incomeAndExpenses: IncomeAndExpensesOutput;
  occupation: OccupationDataOutput;
  stats: StatsDataOutput;
};


export type DashboardOutputAlertNoticesArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type DashboardOutputContractsByStatusArgs = {
  month?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents a deposit for GraphQL output. */
export type DepositOutput = {
  __typename?: 'DepositOutput';
  /** The amount of the deposit. */
  amount: Scalars['String']['output'];
  /** The creation date of the deposit. */
  createdAt: Scalars['DateTime']['output'];
  /** The currency option of the deposit. */
  currencyOption: CurrencyOption;
  /** The status option of the deposit. */
  depositStatusOption: DepositStatusOption;
  /** Unique identifier for the deposit. */
  id: Scalars['ID']['output'];
  /** The operation date of the deposit. */
  operationDate: Scalars['DateTime']['output'];
  /** The owner account name of the deposit. */
  ownerAccountName: Scalars['String']['output'];
  payment: PaymentOutput;
  /** The reference of the deposit. */
  reference: Scalars['String']['output'];
};

export type DepositPaymentReportOutput = {
  __typename?: 'DepositPaymentReportOutput';
  amount: Scalars['String']['output'];
  operationDate: Scalars['DateTime']['output'];
  ownerAccountName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type DepositReportOutput = {
  __typename?: 'DepositReportOutput';
  /** The amount of the deposit. */
  amount: Scalars['String']['output'];
  contract?: Maybe<ContractOutput>;
  /** The creation date of the deposit. */
  createdAt: Scalars['DateTime']['output'];
  /** The currency option of the deposit. */
  currencyOption: CurrencyOption;
  /** The status option of the deposit. */
  depositStatusOption: DepositStatusOption;
  /** Unique identifier for the deposit. */
  id: Scalars['ID']['output'];
  /** The operation date of the deposit. */
  operationDate: Scalars['DateTime']['output'];
  /** The owner account name of the deposit. */
  ownerAccountName: Scalars['String']['output'];
  payment?: Maybe<PaymentReportOutput>;
  /** The reference of the deposit. */
  reference: Scalars['String']['output'];
};

/** Represents the various statuses a deposit can have during its lifecycle. */
export enum DepositStatusOption {
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Received = 'RECEIVED',
  Returned = 'RETURNED'
}

/** Respuesta paginada de deposits para Reports */
export type DepositsPaginatedOutput = {
  __typename?: 'DepositsPaginatedOutput';
  /** Lista de deposits del manager */
  items: Array<DepositReportOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

/** Parámetros de filtro para listar deposits del manager en Reports */
export type DepositsReportFilterInput = {
  /** Filtrar por fecha de creación desde (inclusive) */
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar por fecha de creación hasta (inclusive) */
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Dirección de ordenamiento por fecha de creación (ASC o DESC, por defecto DESC) */
  orderDirection?: InputMaybe<OrderDirectionOption>;
  /** Número de página (como string) */
  page?: InputMaybe<Scalars['String']['input']>;
  /** Cantidad de elementos por página */
  pageSize?: InputMaybe<PageSizeOption>;
  /** Buscar por texto en el campo reference del deposit */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar por estado del deposit */
  statusOption?: InputMaybe<DepositStatusOption>;
};

export type ExpenseOriginInput = {
  expenseOriginOption: ExpenseOriginOption;
  originEntityId: Scalars['String']['input'];
};

/** Define si el gasto se origina desde un incidente, contrato o propiedad */
export enum ExpenseOriginOption {
  Contract = 'CONTRACT',
  Incident = 'INCIDENT',
  Property = 'PROPERTY'
}

/** Represents an expense for GraphQL output. */
export type ExpenseOutput = {
  __typename?: 'ExpenseOutput';
  /** The status of the charge associated with the expense. */
  chargeStatus: RentChargeStatusOption;
  /** Indicates if the amount has been collected from the designated payer/responsible. */
  collectedFromPayer: Scalars['Boolean']['output'];
  contractId?: Maybe<Scalars['String']['output']>;
  /** Charge currency type */
  currencyOption: CurrencyOption;
  /** Fecha del gasto (GraphQLISODateTime). */
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** The total cost of the expense as a formatted string. */
  expenseCost: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  incidentId?: Maybe<Scalars['String']['output']>;
  /** Asunto o título corto del incidente asociado al gasto, si existe. */
  incidentSubject?: Maybe<Scalars['String']['output']>;
  invoiceNumber: Scalars['String']['output'];
  /** Indicates if the expense has been paid to the supplier / external party. */
  paidToSupplier: Scalars['Boolean']['output'];
  /** Human readable label for the main payment responsible (e.g. Manager, Owner, Tenant, Supplier). */
  payerLabel?: Maybe<Scalars['String']['output']>;
  /** User type that is the main payment responsible for this expense. */
  payerUserType?: Maybe<UserTypeOption>;
  /** Nombre de la propiedad o unidad asociada al gasto (piso). */
  propertyName?: Maybe<Scalars['String']['output']>;
  /** Nombre completo del proveedor asociado al incidente del gasto, si existe. */
  supplierName?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  typeOption: IncidentCategoryOption;
};

export type ExpensesFilterInput = {
  categoryOption?: InputMaybe<IncidentCategoryOption>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  incidentId?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<OrderDirectionOption>;
  page?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<PageSizeOption>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

/** Respuesta paginada de expenses para Reports */
export type ExpensesPaginatedOutput = {
  __typename?: 'ExpensesPaginatedOutput';
  /** Lista de expenses del manager */
  items: Array<ExpenseOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

/** Respuesta paginada de expenses (módulo expenses) */
export type ExpensesPaginatedResult = {
  __typename?: 'ExpensesPaginatedResult';
  /** Lista de expenses */
  items: Array<ExpenseOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

/** Parámetros de filtro para listar expenses del manager en Reports */
export type ExpensesReportFilterInput = {
  /** Filtrar por categoría/tipo de expense */
  categoryOption?: InputMaybe<IncidentCategoryOption>;
  /** Filtrar por contrato (ID de contract) */
  contractId?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar por fecha de creación desde (inclusive) */
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar por fecha de creación hasta (inclusive) */
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar por incidente (ID de incident) */
  incidentId?: InputMaybe<Scalars['String']['input']>;
  /** Dirección de ordenamiento por fecha de creación (ASC o DESC, por defecto DESC) */
  orderDirection?: InputMaybe<OrderDirectionOption>;
  /** Número de página (como string) */
  page?: InputMaybe<Scalars['String']['input']>;
  /** Cantidad de elementos por página */
  pageSize?: InputMaybe<PageSizeOption>;
  /** Filtrar por propiedad (ID de property) */
  propertyId?: InputMaybe<Scalars['String']['input']>;
};

export type ExpensesSummaryOutput = {
  __typename?: 'ExpensesSummaryOutput';
  /** Total expenses not paid (pending) */
  notPaid: Scalars['String']['output'];
  /** Total expenses paid */
  paid: Scalars['String']['output'];
  /** Percentage of expenses paid (0-100) */
  paidPercentage: Scalars['Float']['output'];
  /** Total expenses (paid + not paid) */
  total: Scalars['String']['output'];
};

/** Options thtas describe origin of a File Upload request */
export enum FileOriginOption {
  Contract = 'CONTRACT',
  Incident = 'INCIDENT',
  IncidentReport = 'INCIDENT_REPORT',
  Property = 'PROPERTY'
}

/** File status options available */
export enum FileStatusOption {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Uploaded = 'UPLOADED'
}

/** Type of a file to upload */
export enum FileTypeOption {
  Doc = 'DOC',
  Picture = 'PICTURE',
  Video = 'VIDEO'
}

/** Object that contains information about a presignedUrl request for file Upload */
export type FileUploadOutput = {
  __typename?: 'FileUploadOutput';
  /** Name of teh file to opload */
  fileName: Scalars['String']['output'];
  /** Status of the file upload operation */
  fileStatusOption: FileStatusOption;
  /** Type of the file (picture, video, doc) */
  fileTypeOption?: Maybe<FileTypeOption>;
  /** ID of the operation */
  id: Scalars['String']['output'];
  /** Presigned Url for file Uploading */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** Signed URL for downloading the file */
  urlToDownload?: Maybe<Scalars['String']['output']>;
};

export type FileUrlDownloadOutput = {
  __typename?: 'FileUrlDownloadOutput';
  fileTypeOption: FileTypeOption;
  id: Scalars['ID']['output'];
  urlToDownload: Scalars['String']['output'];
};

export type ForgotPasswordInput = {
  /** The email address of the user requesting a password reset. */
  email: Scalars['String']['input'];
};

/** Client finder generator response */
export type GenerateClientFinderSecretKeyOutput = {
  __typename?: 'GenerateClientFinderSecretKeyOutput';
  key: Scalars['String']['output'];
};

/** Information needed to perform a Upload File request */
export type GenerateFileUploadInput = {
  /** Content-Type or MIME for the file to upload */
  contentType: Scalars['String']['input'];
  /** extension of the file to UploadPartCommand, ex: webp */
  fileExtension: Scalars['String']['input'];
  /** Origin of the file */
  fileOriginOption: FileOriginOption;
  /** Filesize expressed in bytes */
  fileSize: Scalars['String']['input'];
  /** File type */
  fileTypeOption: FileTypeOption;
};

export type IncidentAssignedNotificationData = {
  __typename?: 'IncidentAssignedNotificationData';
  incidentId: Scalars['ID']['output'];
  incidentSubject: Scalars['String']['output'];
  propertyName: Scalars['String']['output'];
};

/** Defines the various categories of incidents that can be reported. */
export enum IncidentCategoryOption {
  Checkout = 'CHECKOUT',
  Cleaning = 'CLEANING',
  Construction = 'CONSTRUCTION',
  Electricity = 'ELECTRICITY',
  Gardering = 'GARDERING',
  Gas = 'GAS',
  Internet = 'INTERNET',
  Lock = 'LOCK',
  MetalCarpentry = 'METAL_CARPENTRY',
  Other = 'OTHER',
  Water = 'WATER',
  WoodCarpentry = 'WOOD_CARPENTRY'
}

export type IncidentCreatedNotificationData = {
  __typename?: 'IncidentCreatedNotificationData';
  incidentId: Scalars['ID']['output'];
  propertyName: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
};

export type IncidentExpenseOutput = {
  __typename?: 'IncidentExpenseOutput';
  amount: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceNumber: Scalars['String']['output'];
  uploadedFileId?: Maybe<Scalars['String']['output']>;
};

/** Parameters to filter incidents */
export type IncidentFilterInput = {
  categoryOption?: InputMaybe<IncidentCategoryOption>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  cityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeStatusOption?: InputMaybe<IncidentStatusOption>;
  excludeStatusOptions?: InputMaybe<Array<IncidentStatusOption>>;
  includeStatusOption?: InputMaybe<IncidentStatusOption>;
  includeStatusOptions?: InputMaybe<Array<IncidentStatusOption>>;
  orderDirection?: InputMaybe<OrderDirectionOption>;
  page?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<PageSizeOption>;
  priorityOption?: InputMaybe<PriorityOption>;
  search?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  stateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  typeOption?: InputMaybe<IncidentTypeOption>;
};

export type IncidentFollowUpNotificationData = {
  __typename?: 'IncidentFollowUpNotificationData';
  daysSinceCreation: Scalars['Float']['output'];
  incidentId: Scalars['ID']['output'];
  incidentSubject: Scalars['String']['output'];
  propertyName: Scalars['String']['output'];
};

/** Represents an incident for GraphQL output. */
export type IncidentOutput = {
  __typename?: 'IncidentOutput';
  budgets?: Maybe<Array<BudgetOutput>>;
  /** Creation timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** End date of the incident, if applicable. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fileUploads: Array<FileUrlDownloadOutput>;
  /** Data for downloading files related to an inciden */
  fileUrlsForDownload: Array<FileUrlDownloadOutput>;
  /** Unique identifier for the incident. */
  id: Scalars['ID']['output'];
  /** Category of the incident. */
  incidentCategoryOption: IncidentCategoryOption;
  incidentExpenses: Array<IncidentExpenseOutput>;
  /** Rating associated with the incident, if any. */
  incidentRating?: Maybe<RatingOutput>;
  incidentReports: Array<IncidentReportOutput>;
  incidentResponsabilities: Array<IncidentResponsabilityOutput>;
  /** Type of the incident. */
  incidentTypeOption: IncidentTypeOption;
  manager: ManagerOutput;
  notes: Array<NoteOutput>;
  /** Priority level of the incident. */
  priorityOption: PriorityOption;
  property?: Maybe<PropertyOutput>;
  rating?: Maybe<RatingOutput>;
  /** Selected budget for the incident, if any. */
  selectedBudget?: Maybe<BudgetOutput>;
  /** Start date of the incident, if applicable. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Current status of the incident. */
  statusOption: IncidentStatusOption;
  /** Subject of the incident */
  subject: Scalars['String']['output'];
  supplier?: Maybe<SupplierOutput>;
  tenant?: Maybe<TenantOutput>;
  unity?: Maybe<UnityOutput>;
  /** Creation timestamp. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Incident report output information */
export type IncidentReportOutput = {
  __typename?: 'IncidentReportOutput';
  /** Date of creation of an incident report */
  createdAt: Scalars['DateTime']['output'];
  fileUploads: Array<FileUrlDownloadOutput>;
  /** Id of an incident report */
  id: Scalars['String']['output'];
  notes: Array<NoteOutput>;
  /** Subject of an incident report */
  subject: Scalars['String']['output'];
  /** Supplier owner of an incident report */
  supplier: SupplierOutput;
  /** Date of last uptating of an incident report */
  updatedAt: Scalars['DateTime']['output'];
};

export type IncidentReportSubmittedNotificationData = {
  __typename?: 'IncidentReportSubmittedNotificationData';
  incidentId: Scalars['ID']['output'];
  incidentReportId: Scalars['ID']['output'];
  incidentSubject: Scalars['String']['output'];
  supplierName: Scalars['String']['output'];
};

export type IncidentResponsabilityOutput = {
  __typename?: 'IncidentResponsabilityOutput';
  amount: Scalars['String']['output'];
  responsabilityPercentage: Scalars['String']['output'];
  userTypeOption: UserTypeOption;
};

/** incident status options available */
export enum IncidentStatusOption {
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  New = 'NEW',
  Pending = 'PENDING',
  Resolved = 'RESOLVED',
  Scheduled = 'SCHEDULED'
}

/** Defines the types of incidents, such as faults or maintenance tasks. */
export enum IncidentTypeOption {
  Fault = 'FAULT',
  Maintenance = 'MAINTENANCE'
}

export type IncidentsByStatusOutput = {
  __typename?: 'IncidentsByStatusOutput';
  /** Count of incidents */
  count: Scalars['String']['output'];
  /** Status of the incident */
  status: IncidentStatusOption;
};

export type IncidentsForTenantResponseUnion = ActionResponseMessageOutput | IncidentsPaginatedOutput;

/** Respuesta paginada de incidents */
export type IncidentsPaginatedOutput = {
  __typename?: 'IncidentsPaginatedOutput';
  /** Lista de incidents */
  items: Array<IncidentOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

export type IncomeAndExpensesOutput = {
  __typename?: 'IncomeAndExpensesOutput';
  /** Expenses summary (paid vs not paid) */
  expenses: ExpensesSummaryOutput;
  /** Income summary (rent charges: collected vs not collected) */
  income: IncomeSummaryOutput;
};

export type IncomeSummaryOutput = {
  __typename?: 'IncomeSummaryOutput';
  /** Total collected (revenue received) */
  collected: Scalars['String']['output'];
  /** Percentage of income collected (0-100) */
  collectedPercentage: Scalars['Float']['output'];
  /** Total not collected (pending/overdue) */
  notCollected: Scalars['String']['output'];
  /** Total income (collected + not collected) */
  total: Scalars['String']['output'];
};

export type InsuranceOutput = {
  __typename?: 'InsuranceOutput';
  /** Documento del titular del seguro (dni_titular_seguro) */
  holderDocument?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Corredor del seguro (corredor_seguro) */
  insuranceBroker?: Maybe<Scalars['String']['output']>;
  /** Email del corredor del seguro */
  insuranceBrokerEmail?: Maybe<Scalars['String']['output']>;
  /** Teléfono del corredor del seguro (telf_corredor_seguro) */
  insuranceBrokerPhone?: Maybe<Scalars['String']['output']>;
  /** Nombre de la compañía de seguros (seguro) */
  insuranceCompany: Scalars['String']['output'];
  /** Titular del seguro (titular_seguro) */
  insuranceHolder?: Maybe<Scalars['String']['output']>;
  /** Teléfono de la compañía de seguros (telf_seguro) */
  insurancePhone: Scalars['String']['output'];
  /** Número de póliza (poliza) */
  policyNumber: Scalars['String']['output'];
  /** Plan de la póliza (policyPlan) */
  policyPlan?: Maybe<Scalars['String']['output']>;
};

/** Represents an attached file (photo) for an inventory inspection item. */
export type InventoryInspectionItemFileOutput = {
  __typename?: 'InventoryInspectionItemFileOutput';
  id: Scalars['ID']['output'];
  /** Public URL of the uploaded file. */
  url: Scalars['String']['output'];
};

/** Represents an item inside an inventory inspection section. */
export type InventoryInspectionItemOutput = {
  __typename?: 'InventoryInspectionItemOutput';
  files: Array<InventoryInspectionItemFileOutput>;
  id: Scalars['ID']['output'];
  /** Optional notes for the item. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Ordering index of the item inside its section. */
  order: Scalars['Int']['output'];
  /** Quantity of this item (string for flexibility). */
  quantity?: Maybe<Scalars['String']['output']>;
  /** Status of the item. */
  status: InventoryInspectionItemStatusOption;
  /** Title/label of the item (e.g. "Microwave", "General cleaning"). */
  title: Scalars['String']['output'];
};

/** Represents the status of an inventory inspection item (excellent, good, regular, bad, missing, not evaluated). */
export enum InventoryInspectionItemStatusOption {
  Bad = 'BAD',
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Missing = 'MISSING',
  NotEvaluated = 'NOT_EVALUATED',
  Regular = 'REGULAR'
}

/** Represents a detailed inventory inspection for a property (with sections and items). */
export type InventoryInspectionOutput = {
  __typename?: 'InventoryInspectionOutput';
  contractId?: Maybe<Scalars['ID']['output']>;
  /** General notes for the inspection. */
  generalNotes?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Date when the inspection took place. */
  inspectionDate: Scalars['DateTime']['output'];
  /** Name of the person who performed the inspection. */
  inspectorName: Scalars['String']['output'];
  propertyId: Scalars['ID']['output'];
  /** Name of the person who received the inspection. */
  receiverName: Scalars['String']['output'];
  sections: Array<InventoryInspectionSectionOutput>;
  /** Type of inspection: INITIAL or FINAL. */
  type: InventoryInspectionTypeOption;
};

/** Download information for a generated inventory inspection PDF. */
export type InventoryInspectionPdfOutput = {
  __typename?: 'InventoryInspectionPdfOutput';
  /** MIME type of the file. */
  contentType: Scalars['String']['output'];
  /** Suggested file name for the PDF. */
  fileName: Scalars['String']['output'];
  /** Presigned URL to download the PDF. */
  url: Scalars['String']['output'];
};

/** Represents a section/tab inside an inventory inspection. */
export type InventoryInspectionSectionOutput = {
  __typename?: 'InventoryInspectionSectionOutput';
  id: Scalars['ID']['output'];
  /** True if section is system-generated (based on property flags). */
  isSystem: Scalars['Boolean']['output'];
  items: Array<InventoryInspectionItemOutput>;
  /** Stable key/slug of the section (e.g. kitchen, patio, custom-XXX). */
  key: Scalars['String']['output'];
  /** Order of the section in the UI tabs. */
  order: Scalars['Float']['output'];
  /** Human-readable title of the section. */
  title: Scalars['String']['output'];
};

/** Represents the inventory inspection type, either initial or final. */
export enum InventoryInspectionTypeOption {
  Final = 'FINAL',
  Initial = 'INITIAL'
}

/** Represents an item inside an inventory. */
export type InventoryItemOutput = {
  __typename?: 'InventoryItemOutput';
  /** Description of the inventory item. */
  description: Scalars['String']['output'];
  /** Unique identifier for the inventory item. */
  id: Scalars['ID']['output'];
  /** Quantity of this item in the inventory. */
  quantity: Scalars['String']['output'];
};

/** Represents an inventory associated to a property. */
export type InventoryOutput = {
  __typename?: 'InventoryOutput';
  /** Description of the inventory. */
  description: Scalars['String']['output'];
  /** Unique identifier for the inventory. */
  id: Scalars['ID']['output'];
  /** Items that belongs to this inventory. */
  items: Array<InventoryItemOutput>;
};

/** Represents the different lease term options available, such as fixed-term, month-to-month, or yearly-term. */
export enum LeaseTermOption {
  FixedTerm = 'FIXED_TERM',
  MonthToMonth = 'MONTH_TO_MONTH',
  YearlyTerm = 'YEARLY_TERM'
}

export type LoginInput = {
  /** The type of client application making the request. */
  clientType: ClientAppTypeOption;
  /** The email address of the user. */
  email: Scalars['String']['input'];
  /** The password of the user. */
  password: Scalars['String']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  token: Scalars['String']['output'];
  userType: UserTypeOption;
  username: Scalars['String']['output'];
};

export type LoginResponseUnion = ActionResponseMessageOutput | LoginResponse;

export type ManagerCommunicationOutput = {
  __typename?: 'ManagerCommunicationOutput';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  recipientCount: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

/** Represents a manager entity with its details for GraphQL output. */
export type ManagerOutput = {
  __typename?: 'ManagerOutput';
  /** The first name of the manager. */
  firstName: Scalars['String']['output'];
  /** Unique identifier for the manager. */
  id: Scalars['ID']['output'];
  /** The last name of the manager. */
  lastName: Scalars['String']['output'];
  /** The phone number of the manager. */
  phoneNumber: Scalars['String']['output'];
  user: UserOutput;
};

/** Fila de desglose por valor de calificación (1-5) */
export type ManagerRatingBreakdownRowOutput = {
  __typename?: 'ManagerRatingBreakdownRowOutput';
  /** Cantidad de calificaciones para este valor */
  count: Scalars['Int']['output'];
  /** Porcentaje de este valor sobre el total de calificaciones */
  percentage: Scalars['Float']['output'];
  /** Valor de la calificación (1 a 5) */
  ratingValue: Scalars['Int']['output'];
};

/** Fila de detalle de una calificación registrada por un inquilino */
export type ManagerRatingReportRowOutput = {
  __typename?: 'ManagerRatingReportRowOutput';
  /** Comentario registrado por el inquilino */
  comment?: Maybe<Scalars['String']['output']>;
  /** Fecha de creación de la calificación */
  createdAt: Scalars['DateTime']['output'];
  /** Identificador de la calificación */
  id: Scalars['ID']['output'];
  /** ID del incidente relacionado */
  incidentId: Scalars['String']['output'];
  /** Nombre de la propiedad relacionada */
  propertyName?: Maybe<Scalars['String']['output']>;
  /** Valor de la calificación (1 a 5) */
  ratingValue: Scalars['Int']['output'];
  /** Nombre del inquilino relacionado */
  tenantName?: Maybe<Scalars['String']['output']>;
  /** Nombre/unidad relacionada */
  unityName?: Maybe<Scalars['String']['output']>;
};

/** Respuesta paginada del reporte detallado de calificaciones */
export type ManagerRatingsPaginatedOutput = {
  __typename?: 'ManagerRatingsPaginatedOutput';
  /** Lista de calificaciones registradas */
  items: Array<ManagerRatingReportRowOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

/** Parámetros de filtro para listar calificaciones registradas por inquilinos */
export type ManagerRatingsReportFilterInput = {
  /** Mes de creación de la calificación (1-12) */
  month?: InputMaybe<Scalars['Int']['input']>;
  /** Dirección de ordenamiento por fecha de creación (ASC o DESC, por defecto DESC) */
  orderDirection?: InputMaybe<OrderDirectionOption>;
  /** Número de página (como string) */
  page?: InputMaybe<Scalars['String']['input']>;
  /** Cantidad de elementos por página */
  pageSize?: InputMaybe<PageSizeOption>;
  /** Filtrar por valor de calificación (1-5) */
  ratingValue?: InputMaybe<Scalars['Int']['input']>;
  /** Búsqueda por nombre de inquilino o propiedad */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Resumen de calificaciones de incidentes cerrados para un manager */
export type ManagerRatingsSummaryOutput = {
  __typename?: 'ManagerRatingsSummaryOutput';
  /** Promedio general de calificaciones */
  averageRating: Scalars['Float']['output'];
  /** Desglose por cada valor de calificación (1 a 5) */
  breakdown: Array<ManagerRatingBreakdownRowOutput>;
  /** Cantidad total de calificaciones */
  totalRatings: Scalars['Int']['output'];
};

export type MassiveCommunicationOutput = {
  __typename?: 'MassiveCommunicationOutput';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type MassiveCommunicationTemplateOutput = {
  __typename?: 'MassiveCommunicationTemplateOutput';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Messages codes available */
export enum MessageCodeOption {
  ChargeAlreadyPayed = 'CHARGE_ALREADY_PAYED',
  ChatMessageNotDeliveredByInternalFail = 'CHAT_MESSAGE_NOT_DELIVERED_BY_INTERNAL_FAIL',
  ChatMessageNotDeliveredByRelationNotFound = 'CHAT_MESSAGE_NOT_DELIVERED_BY_RELATION_NOT_FOUND',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  OtpCodeNotFound = 'OTP_CODE_NOT_FOUND',
  OtpValidatedSuccessfully = 'OTP_VALIDATED_SUCCESSFULLY',
  OtpValidatedUnsuccessfully = 'OTP_VALIDATED_UNSUCCESSFULLY',
  PaymentAlreadyProcessed = 'PAYMENT_ALREADY_PROCESSED',
  RedsysConfigurationNotFound = 'REDSYS_CONFIGURATION_NOT_FOUND',
  ResetPasswordSuccessful = 'RESET_PASSWORD_SUCCESSFUL',
  ResetPasswordUnsuccessful = 'RESET_PASSWORD_UNSUCCESSFUL',
  TenantHasNotInitiatedContract = 'TENANT_HAS_NOT_INITIATED_CONTRACT',
  TokenWithoutUserInformation = 'TOKEN_WITHOUT_USER_INFORMATION',
  UnauthorizedUser = 'UNAUTHORIZED_USER',
  UnityNotFound = 'UNITY_NOT_FOUND',
  UserExist = 'USER_EXIST',
  UserIsNotSignedIn = 'USER_IS_NOT_SIGNED_IN',
  UserIsSignedIn = 'USER_IS_SIGNED_IN',
  UserNotFound = 'USER_NOT_FOUND',
  UserSignupSuccessful = 'USER_SIGNUP_SUCCESSFUL',
  UserSignupUnsuccessful = 'USER_SIGNUP_UNSUCCESSFUL',
  WrongPrivileges = 'WRONG_PRIVILEGES'
}

export type MessageCreatedNotificationData = {
  __typename?: 'MessageCreatedNotificationData';
  incidentId: Scalars['ID']['output'];
  messageId: Scalars['ID']['output'];
  senderName: Scalars['String']['output'];
};

/** Message object */
export type MessageOutput = {
  __typename?: 'MessageOutput';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  messageOwnerOption?: Maybe<MessageOwnerOption>;
  messageStatusOption: MessageStatusOption;
  messageTransactionId?: Maybe<Scalars['String']['output']>;
  receiverUserTypeOption?: Maybe<UserTypeOption>;
  senderUserTypeOption?: Maybe<UserTypeOption>;
};

export enum MessageOwnerOption {
  Me = 'ME',
  Other = 'OTHER'
}

export enum MessageStatusOption {
  Delivered = 'DELIVERED',
  Pending = 'PENDING',
  Read = 'READ'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Allows a user to change their password. */
  changePassword: ChangePasswordResponse;
  /** Confirm property file uploads and link them to the property */
  confirmPropertyFileUpload: Array<FileUploadOutput>;
  /** Create a Budget from an Incident */
  createBudgetFromIncident: BudgetOutput;
  /** Create a Contact from a Property */
  createContactFromProperty: ContactOutput;
  /** Create a new contract. Requires a valid token and MANAGER role. */
  createContract: ContractOutput;
  /** Create a new expense. */
  createExpense: ExpenseOutput;
  /** Create a new incident. Requires a valid token and user type MANAGER. */
  createIncident: IncidentOutput;
  /** Create an Incident Expense */
  createIncidentExpense: IncidentExpenseOutput;
  /** Create a new incident. Requires a valid token and user type MANAGER. */
  createIncidentFromTenant: CreateIncidentForTenantResponseUnion;
  /** Create a incident report from incident */
  createIncidentReportFromSupplier: IncidentReportOutput;
  /** Create an Insurance from a Property */
  createInsuranceFromProperty: InsuranceOutput;
  /** Create a new inventory for a given property. Requires MANAGER role. */
  createInventory: InventoryOutput;
  /** Crea una nueva inspección/inventario para una propiedad (solo cabecera). */
  createInventoryInspection: InventoryInspectionOutput;
  /** Create a new inventory item for a given inventory. Requires MANAGER role. */
  createInventoryItem: InventoryItemOutput;
  /** Create a new manager. Does not require authentication. */
  createManager: Scalars['Boolean']['output'];
  createMassiveCommunicationTemplate: MassiveCommunicationTemplateOutput;
  createMessageFromIncident: CreateMessageFromIncidentResponseUnion;
  /** Create a note from a Contract */
  createNoteFromContract: NoteOutput;
  /** Create a note from an Incident */
  createNoteFromIncident: NoteOutput;
  /** Create a Note from a Property */
  createNoteFromProperty: NoteOutput;
  /** Create a new owner. Requires a valid token. User must be MANAGER. */
  createOwner: OwnerResponse;
  /** Create a new owner contract. Requires a valid token and MANAGER role. */
  createOwnerContract: OwnerContractOutput;
  createPayment: PaymentResponseUnion;
  /** Create a new property. Requires a valid token and MANAGER role. */
  createProperty: PropertyOutput;
  /** Create a new Receipt Aggregation for doing a Payment */
  createReceipt: CreateReceiptAggregationResponseUnion;
  /** Create a rent charge from a Contract */
  createRentChargeFromContract: RentChargeOutput;
  /** Create a new supplier. Requires a valid token and user type MANAGER. */
  createSupplier: SupplierResponse;
  /** Create a new tenant. Requires a valid token and user type MANAGER. */
  createTenant: TenantResponse;
  /** Create an Unity from a Property ID */
  createUnityFromProperty: PropertyOutput;
  /** Delete a budget by its ID. Requires a valid token and user type MANAGER. */
  deleteBudget: BudgetOutput;
  /** Delete a contract by ID. Requires a valid token and MANAGER role. */
  deleteContract: ContractOutput;
  /** Delete an incident by its ID. Requires a valid token and user type MANAGER. */
  deleteIncident: IncidentOutput;
  /** Delete a manager by ID. Requires a valid token and MANAGER role. */
  deleteManager: ManagerOutput;
  deleteMassiveCommunicationTemplate: Scalars['Boolean']['output'];
  /** Delete a note by ID. Requires a valid token and user type MANAGER. */
  deleteNote: NoteOutput;
  /** Delete an owner. Requires a valid token. User must be MANAGER. */
  deleteOwner: OwnerOutput;
  /** Delete a property by its ID. */
  deleteProperty: PropertyOutput;
  /** Create a rent charge from a Contract */
  deleteRentChargeFromContract: RentChargeOutput;
  /** Delete a supplier by ID. Requires a valid token and user type MANAGER. */
  deleteSupplier: SupplierOutput;
  /** Delete a tenant by ID. Requires a valid token and user type MANAGER. */
  deleteTenant: TenantOutput;
  /** Update an Unity from a Property ID */
  deleteUnityFromProperty: UnityOutput;
  /** Initiates the forgot password process by sending a reset link. */
  forgotPassword: ActionResponseMessageOutput;
  /** Genera el PDF (A4) de una inspección/inventario y retorna una URL de descarga. */
  generateInventoryInspectionPdf: InventoryInspectionPdfOutput;
  generateNewClientFinderSecretKey: GenerateClientFinderSecretKeyOutput;
  /** Mutation that allow to user request a url to upload docs */
  getUploadUrl: FileUploadOutput;
  /** Mutation that allow to user request a url to upload docs */
  getUploadUrls: Array<FileUploadOutput>;
  /** Logs in a user and returns an authentication token. */
  login: LoginResponseUnion;
  /** Marca un anuncio como leído para el usuario actual. El id es el communicationId. */
  markMassiveCommunicationAsRead: UserCommunicationOutput;
  markNotificationAsRead: NotificationOutput;
  rateIncidentFromTenant: RatingOutput;
  /** Resets the user password using a valid reset token. */
  resetPassword: ActionResponseMessageOutput;
  /** Crea o actualiza la configuración Redsys para el usuario autenticado */
  saveRedsysConfiguration: RedsysUserConfigOutput;
  /** Crea un anuncio y lo envía a los destinatarios. Una sola fila por anuncio. */
  sendMassiveCommunication: MassiveCommunicationOutput;
  /** Set selected budget to incident attendance */
  setSelectedBudgetToIncident: IncidentOutput;
  /** Set selected budget to incident attendance */
  setSupplierToIncident: IncidentOutput;
  /** Sign up a new user as a Manager. */
  signup: ActionResponseMessageOutput;
  /** Supplier selects one slot and confirms the visit. */
  supplierSelectIncidentAppointmentSlot: AppointmentSlotOutput;
  /** Tenant publishes availability slots for an incident. */
  tenantCreateIncidentAppointmentSlots: Array<AppointmentSlotOutput>;
  /** Update an existing budget by its ID. Requires a valid token and user type MANAGER or OWNER. */
  updateBudget: BudgetOutput;
  /** Actualiza el status de un anuncio para el usuario (read, archived). */
  updateCommunicationStatus: UserCommunicationOutput;
  /** Create an Insurance from a Property */
  updateContactFromProperty: ContactOutput;
  /** Update an existing contract by ID. Requires a valid token and MANAGER role. */
  updateContract?: Maybe<ContractOutput>;
  updateDeposit: DepositOutput;
  /** Update an existing expense. */
  updateExpense: ExpenseOutput;
  /** Update payment flags (paid to supplier / collected from payer) for an expense. */
  updateExpensePaymentFlags: ExpenseOutput;
  /** Update only charge status for an expense. */
  updateExpenseStatus: ExpenseOutput;
  /** Update an existing incident by its ID. Requires a valid token and user type MANAGER or OWNER. */
  updateIncident: IncidentOutput;
  updateIncidentReport: IncidentReportOutput;
  /** Create an Insurance from a Property */
  updateInsuranceFromProperty: InsuranceOutput;
  /** Update an existing inventory for a given property. Requires MANAGER role. */
  updateInventory: InventoryOutput;
  /** Actualiza la cabecera de una inspección/inventario. */
  updateInventoryInspection: InventoryInspectionOutput;
  /** Update an inventory item for a given inventory. Requires MANAGER role. */
  updateInventoryItem: InventoryItemOutput;
  /** Update a manager by ID. Requires a valid token and MANAGER role. */
  updateManager: ManagerOutput;
  updateMassiveCommunication: MassiveCommunicationOutput;
  updateMassiveCommunicationTemplate: MassiveCommunicationTemplateOutput;
  /** Update an existing owner. Requires a valid token. User must be MANAGER or OWNER. */
  updateOwner: OwnerOutput;
  /** Update an existing owner contract by ID. Requires a valid token and MANAGER role. */
  updateOwnerContract: OwnerContractOutput;
  /** Update an existing property by its ID. */
  updateProperty: PropertyOutput;
  /** Update an existing rent charge by its ID. Requires a valid token and user type MANAGER. */
  updateRentCharge: RentChargeOutput;
  /** Create a rent charge from a Contract */
  updateRentChargeFromContract: RentChargeOutput;
  /** Update an existing supplier by ID. Requires a valid token and user type MANAGER. */
  updateSupplier: SupplierOutput;
  /** Update an existing tenant by ID or the current user's tenant. Requires a valid token and user type MANAGER or TENANT. */
  updateTenant: TenantOutput;
  /** Update an Unity from a Property ID */
  updateUnityFromProperty: PropertyOutput;
  /** Crea o actualiza un ítem dentro de una sección de inspección/inventario. */
  upsertInventoryInspectionItem: InventoryInspectionOutput;
  /** Crea o actualiza una sección (tab) dentro de una inspección/inventario. */
  upsertInventoryInspectionSection: InventoryInspectionOutput;
  /** Validates the provided OTP. If for registration, specify isForRegistration as true. */
  validateOtp: ActionResponseMessageOutput;
};


export type MutationChangePasswordArgs = {
  changePasswordInput: ChangePasswordInput;
};


export type MutationConfirmPropertyFileUploadArgs = {
  input: ConfirmPropertyFileUploadInput;
};


export type MutationCreateBudgetFromIncidentArgs = {
  budgetInput: CreateBudgetInput;
  incidentId: Scalars['String']['input'];
};


export type MutationCreateContactFromPropertyArgs = {
  contactInput: CreateContactInput;
  propertyId: Scalars['String']['input'];
};


export type MutationCreateContractArgs = {
  createContractInput: CreateContractInput;
};


export type MutationCreateExpenseArgs = {
  createExpenseInput: CreateExpenseInput;
  originInput?: InputMaybe<ExpenseOriginInput>;
};


export type MutationCreateIncidentArgs = {
  createIncidentInput: CreateIncidentInput;
};


export type MutationCreateIncidentExpenseArgs = {
  incidentExpenseInput: CreateIncidentExpenseInput;
  incidentId: Scalars['ID']['input'];
};


export type MutationCreateIncidentFromTenantArgs = {
  createIncidentInput: CreateIncidentFromTenantInput;
};


export type MutationCreateIncidentReportFromSupplierArgs = {
  incidentId: Scalars['String']['input'];
  incidentReportInput: CreateIncidentReportInput;
};


export type MutationCreateInsuranceFromPropertyArgs = {
  insuranceInput: CreateInsuranceInput;
  propertyId: Scalars['String']['input'];
};


export type MutationCreateInventoryArgs = {
  createInventoryInput: CreateInventoryInput;
  propertyId: Scalars['String']['input'];
};


export type MutationCreateInventoryInspectionArgs = {
  input: CreateInventoryInspectionInput;
  propertyId: Scalars['ID']['input'];
};


export type MutationCreateInventoryItemArgs = {
  createInventoryItemInput: CreateInventoryItemInput;
  inventoryId: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
};


export type MutationCreateManagerArgs = {
  createManagerInput: CreateManagerInput;
};


export type MutationCreateMassiveCommunicationTemplateArgs = {
  input: CreateMassiveCommunicationTemplateInput;
};


export type MutationCreateMessageFromIncidentArgs = {
  incidentId: Scalars['String']['input'];
  input: CreateMessageFromIncidentInput;
};


export type MutationCreateNoteFromContractArgs = {
  contractId: Scalars['String']['input'];
  noteInput: CreateNoteInput;
};


export type MutationCreateNoteFromIncidentArgs = {
  incidentId: Scalars['String']['input'];
  noteInput: CreateNoteInput;
};


export type MutationCreateNoteFromPropertyArgs = {
  noteInput: CreateNoteInput;
  propertyId: Scalars['String']['input'];
};


export type MutationCreateOwnerArgs = {
  createOwnerInput: CreateOwnerInput;
};


export type MutationCreateOwnerContractArgs = {
  input: CreateOwnerContractInput;
};


export type MutationCreatePaymentArgs = {
  paymentInput: PaymentDataInput;
};


export type MutationCreatePropertyArgs = {
  createPropertyInput: CreatePropertyInput;
};


export type MutationCreateReceiptArgs = {
  receiptAggregationInput: CreateReceiptAggregationInput;
};


export type MutationCreateRentChargeFromContractArgs = {
  contractId: Scalars['String']['input'];
  createRentChargeInput: CreateRentChargeInput;
};


export type MutationCreateSupplierArgs = {
  createSupplierInput: CreateSupplierInput;
};


export type MutationCreateTenantArgs = {
  createTenantInput: CreateTenantInput;
};


export type MutationCreateUnityFromPropertyArgs = {
  createUnityInput: CreateUnityInput;
  propertyId: Scalars['String']['input'];
};


export type MutationDeleteBudgetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteContractArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteIncidentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteManagerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMassiveCommunicationTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOwnerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePropertyArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRentChargeFromContractArgs = {
  contractId: Scalars['String']['input'];
  rentChargeId: Scalars['String']['input'];
};


export type MutationDeleteSupplierArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTenantArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUnityFromPropertyArgs = {
  propertyId: Scalars['String']['input'];
  unityId: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  forgotPasswordInput: ForgotPasswordInput;
};


export type MutationGenerateInventoryInspectionPdfArgs = {
  inspectionId: Scalars['ID']['input'];
  propertyId: Scalars['ID']['input'];
};


export type MutationGetUploadUrlArgs = {
  input: GenerateFileUploadInput;
};


export type MutationGetUploadUrlsArgs = {
  inputs: Array<GenerateFileUploadInput>;
};


export type MutationLoginArgs = {
  loginInput: LoginInput;
};


export type MutationMarkMassiveCommunicationAsReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRateIncidentFromTenantArgs = {
  incidentId: Scalars['String']['input'];
  input: CreateRatingInput;
};


export type MutationResetPasswordArgs = {
  resetPasswordInput: ResetPasswordInput;
};


export type MutationSaveRedsysConfigurationArgs = {
  data: RedsysUserConfigInput;
};


export type MutationSendMassiveCommunicationArgs = {
  input: CreateMassiveCommunicationInput;
};


export type MutationSetSelectedBudgetToIncidentArgs = {
  incidentId: Scalars['String']['input'];
  incidentInput: SetBudgetToIncidentInput;
};


export type MutationSetSupplierToIncidentArgs = {
  incidentId: Scalars['String']['input'];
  incidentInput: SetSuppliertToIncidentInput;
};


export type MutationSignupArgs = {
  signupDataInput: SignupUserInput;
};


export type MutationSupplierSelectIncidentAppointmentSlotArgs = {
  incidentId: Scalars['ID']['input'];
  slotId: Scalars['ID']['input'];
};


export type MutationTenantCreateIncidentAppointmentSlotsArgs = {
  incidentId: Scalars['ID']['input'];
  input: CreateAppointmentSlotsInput;
};


export type MutationUpdateBudgetArgs = {
  id: Scalars['String']['input'];
  updateBudgetInput: UpdateBudgetInput;
};


export type MutationUpdateCommunicationStatusArgs = {
  input: UpdateCommunicationStatusInput;
};


export type MutationUpdateContactFromPropertyArgs = {
  contactId: Scalars['String']['input'];
  contactInput: UpdateContactInput;
  propertyId: Scalars['String']['input'];
};


export type MutationUpdateContractArgs = {
  id: Scalars['String']['input'];
  updateContractInput: UpdateContractInput;
};


export type MutationUpdateDepositArgs = {
  id: Scalars['String']['input'];
  input: UpdateDepositInput;
};


export type MutationUpdateExpenseArgs = {
  id: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
  updateExpenseInput: UpdateExpenseInput;
};


export type MutationUpdateExpensePaymentFlagsArgs = {
  collectedFromPayer: Scalars['Boolean']['input'];
  expenseId: Scalars['String']['input'];
  paidToSupplier: Scalars['Boolean']['input'];
};


export type MutationUpdateExpenseStatusArgs = {
  updateExpenseStatusInput: UpdateExpenseStatusInput;
};


export type MutationUpdateIncidentArgs = {
  id: Scalars['String']['input'];
  updateIncidentInput: UpdateIncidentInput;
};


export type MutationUpdateIncidentReportArgs = {
  id: Scalars['String']['input'];
  input: UpdateIncidentReportInput;
};


export type MutationUpdateInsuranceFromPropertyArgs = {
  insuranceId: Scalars['String']['input'];
  insuranceInput: UpdateInsuranceInput;
  propertyId: Scalars['String']['input'];
};


export type MutationUpdateInventoryArgs = {
  id: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
  updateInventoryInput: UpdateInventoryInput;
};


export type MutationUpdateInventoryInspectionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInventoryInspectionInput;
  propertyId: Scalars['ID']['input'];
};


export type MutationUpdateInventoryItemArgs = {
  id: Scalars['String']['input'];
  inventoryId: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
  updateInventoryItemInput: UpdateInventoryItemInput;
};


export type MutationUpdateManagerArgs = {
  updateManagerInput: UpdateManagerInput;
};


export type MutationUpdateMassiveCommunicationArgs = {
  input: UpdateMassiveCommunicationInput;
};


export type MutationUpdateMassiveCommunicationTemplateArgs = {
  input: UpdateMassiveCommunicationTemplateInput;
};


export type MutationUpdateOwnerArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  updateOwnerInput: UpdateOwnerInput;
};


export type MutationUpdateOwnerContractArgs = {
  id: Scalars['String']['input'];
  updateOwnerContractInput: UpdateOwnerContractInput;
};


export type MutationUpdatePropertyArgs = {
  id: Scalars['String']['input'];
  updatePropertyInput: UpdatePropertyInput;
};


export type MutationUpdateRentChargeArgs = {
  id: Scalars['String']['input'];
  updateRentChargeInput: UpdateRentChargeInput;
};


export type MutationUpdateRentChargeFromContractArgs = {
  contractId: Scalars['String']['input'];
  rentChargeId: Scalars['String']['input'];
  updateRentChargeInput: UpdateRentChargeInput;
};


export type MutationUpdateSupplierArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  updateSupplierInput: UpdateSupplierInput;
};


export type MutationUpdateTenantArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  updateTenantInput: UpdateTenantInput;
};


export type MutationUpdateUnityFromPropertyArgs = {
  propertyId: Scalars['String']['input'];
  unityId: Scalars['String']['input'];
  updateUnityInput: UpdateUnityInput;
};


export type MutationUpsertInventoryInspectionItemArgs = {
  input: UpsertInventoryInspectionItemInput;
  propertyId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationUpsertInventoryInspectionSectionArgs = {
  input: UpsertInventoryInspectionSectionInput;
  inspectionId: Scalars['ID']['input'];
  propertyId: Scalars['ID']['input'];
};


export type MutationValidateOtpArgs = {
  validateOtpInput: ValidateOtpInput;
};

/** Represents a note for GraphQL output. */
export type NoteOutput = {
  __typename?: 'NoteOutput';
  /** Creation timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the note. */
  id: Scalars['ID']['output'];
  ownerFirstName?: Maybe<Scalars['String']['output']>;
  ownerLastName?: Maybe<Scalars['String']['output']>;
  /** The content/description of the note. */
  text: Scalars['String']['output'];
  /** Last update timestamp. */
  updatedAt: Scalars['DateTime']['output'];
  user: UserOutput;
};

export type NotificationAdditionalDataUnion = ContractNotificationData | IncidentAssignedNotificationData | IncidentCreatedNotificationData | IncidentFollowUpNotificationData | IncidentReportSubmittedNotificationData | MessageCreatedNotificationData | PaymentDeadlineNotificationData;

export type NotificationOutput = {
  __typename?: 'NotificationOutput';
  additionalData?: Maybe<NotificationAdditionalDataUnion>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  read: Scalars['Boolean']['output'];
  type: NotificationTypeOption;
};

/** Type notifications available in the system */
export enum NotificationTypeOption {
  ContractExpirationSoon = 'CONTRACT_EXPIRATION_SOON',
  ContractExpired = 'CONTRACT_EXPIRED',
  ContractStarted = 'CONTRACT_STARTED',
  IncidentAssigned = 'INCIDENT_ASSIGNED',
  IncidentCreated = 'INCIDENT_CREATED',
  IncidentFollowUp = 'INCIDENT_FOLLOW_UP',
  IncidentRatingRequest = 'INCIDENT_RATING_REQUEST',
  IncidentReportSubmitted = 'INCIDENT_REPORT_SUBMITTED',
  IncidentResponsibilityRequired = 'INCIDENT_RESPONSIBILITY_REQUIRED',
  NewChatMessage = 'NEW_CHAT_MESSAGE',
  PaymentDeadlineNotification = 'PAYMENT_DEADLINE_NOTIFICATION',
  RentChargePaid = 'RENT_CHARGE_PAID'
}

export type OccupationDataOutput = {
  __typename?: 'OccupationDataOutput';
  /** Hasta 12 meses de ocupación histórica por contrato (orden cronológico ascendente). */
  monthlyTrend: Array<OccupationMonthPointOutput>;
  /** Unidades ocupadas ahora (estado actual de la unidad), mismo criterio que antes. */
  occupied: Scalars['String']['output'];
  /** Ocupación del mes calendario anterior al de referencia (contratos que solapan ese mes). Referencia: fin del filtro de período si existe, si no hoy. */
  previousMonth: OccupationSnapshotOutput;
  /** Total de unidades en el alcance del filtro */
  total: Scalars['String']['output'];
};

/** Ocupación histórica en un mes (unidades con contrato activo que solapa el mes, sobre el mismo total de unidades que el snapshot actual). */
export type OccupationMonthPointOutput = {
  __typename?: 'OccupationMonthPointOutput';
  /** Mes calendario 1 a 12 */
  month: Scalars['Int']['output'];
  /** Unidades ocupadas según contratos (excluye canceled / notIssued). */
  occupied: Scalars['String']['output'];
  /** Total de unidades en el alcance del filtro */
  total: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

/** Snapshot de ocupación (misma métrica que occupied/total del periodo indicado). */
export type OccupationSnapshotOutput = {
  __typename?: 'OccupationSnapshotOutput';
  /** Mes calendario 1–12 */
  month?: Maybe<Scalars['Int']['output']>;
  occupied: Scalars['String']['output'];
  total: Scalars['String']['output'];
  /** Año calendario del snapshot */
  year?: Maybe<Scalars['Int']['output']>;
};

/** Order direction options available */
export enum OrderDirectionOption {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Owner contract filter input params */
export type OwnerContractFilterInput = {
  endMonth?: InputMaybe<Scalars['String']['input']>;
  leaseType?: InputMaybe<OwnerContractLeaseTypeOption>;
  orderDirection?: InputMaybe<OrderDirectionOption>;
  page?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<PageSizeOption>;
  paymentFrequency?: InputMaybe<PaymentFrequencyOption>;
  search?: InputMaybe<Scalars['String']['input']>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContractStatusOption>;
};

/** Owner contract lease type options available */
export enum OwnerContractLeaseTypeOption {
  AssuredPayment = 'ASSURED_PAYMENT',
  LeaseSublet = 'LEASE_SUBLET',
  OccupationManagment = 'OCCUPATION_MANAGMENT'
}

/** Represents an owner contract (Manager → Owner) with relational references. */
export type OwnerContractOutput = {
  __typename?: 'OwnerContractOutput';
  /** Total amount agreed with the owner for this contract (string representation). */
  contractAmount: Scalars['String']['output'];
  /** Status option representing the current status of the owner contract. */
  contractStatusOption: ContractStatusOption;
  /** Date when the owner contract was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Currency option representing the reference currency used for the contract. */
  currencyOption: CurrencyOption;
  /** Finish date of the owner contract. */
  finishDate: Scalars['DateTime']['output'];
  /** Unique identifier for the owner contract. */
  id: Scalars['ID']['output'];
  insurance?: Maybe<InsuranceOutput>;
  owner: OwnerOutput;
  /** Owner contract lease type option representing the reference owner contract lease type for the contract. */
  ownerContractLeaseTypeOption: OwnerContractLeaseTypeOption;
  /** Payment frequency option representing the reference payment frequency for the contract. */
  paymentFrequencyOption: PaymentFrequencyOption;
  property: PropertyOutput;
  /** Start date of the owner contract. */
  startDate: Scalars['DateTime']['output'];
  /** Date when the owner contract was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Respuesta paginada de owner contracts */
export type OwnerContractsPaginatedOutput = {
  __typename?: 'OwnerContractsPaginatedOutput';
  /** Lista de owner contracts */
  items: Array<OwnerContractOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

/** Parámetros de filtro para listar owners */
export type OwnerFilterInput = {
  orderDirection?: InputMaybe<OrderDirectionOption>;
  page?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<PageSizeOption>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an owner with their details for GraphQL output. */
export type OwnerOutput = {
  __typename?: 'OwnerOutput';
  address: AddressOutput;
  bankAccount: BankAccountOutput;
  /** The birth date of the owner. */
  birthDate: Scalars['DateTime']['output'];
  /** The unique document ID of the owner. */
  documentId: Scalars['String']['output'];
  /** The first name of the owner. */
  firstName: Scalars['String']['output'];
  /** The gender of the owner. */
  genderOption: UserGenderTypeOption;
  /** Id of the owner */
  id: Scalars['ID']['output'];
  /** Indicates whether the owner is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last name of the owner. */
  lastName: Scalars['String']['output'];
  /** The nationality of the owner. */
  nationality: Scalars['String']['output'];
  /** The primary phone number of the owner. */
  phoneNumber: Scalars['String']['output'];
  /** The secondary phone number of the owner, if available. */
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  properties: Array<PropertyOutput>;
  user: UserOutput;
};

export type OwnerResponse = ActionResponseMessageOutput | OwnerOutput;

/** Respuesta paginada de owners */
export type OwnersPaginatedOutput = {
  __typename?: 'OwnersPaginatedOutput';
  /** Lista de owners */
  items: Array<OwnerOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

/** Page size options available for pagination */
export enum PageSizeOption {
  Fifty = 'FIFTY',
  OneHundred = 'ONE_HUNDRED',
  SeventyFive = 'SEVENTY_FIVE',
  TwentyFive = 'TWENTY_FIVE'
}

/** Metadata de paginación para respuestas de listas */
export type PaginationMetaOutput = {
  __typename?: 'PaginationMetaOutput';
  /** Página actual */
  currentPage: Scalars['Int']['output'];
  /** Indica si hay una página siguiente */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indica si hay una página anterior */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Cantidad de items por página */
  pageSize: Scalars['Int']['output'];
  /** Total de items en la base de datos */
  totalItems: Scalars['Int']['output'];
  /** Total de páginas disponibles */
  totalPages: Scalars['Int']['output'];
};

export type PaymentComplementaryDataUnion = RedsysPaymentComplementaryDataOutput | StripePaymentComplementaryDataOutput;

/** Data required for make a payment checkout sesion */
export type PaymentDataInput = {
  depositData?: InputMaybe<CreateDepositInput>;
  isRecurringPayment?: InputMaybe<Scalars['Boolean']['input']>;
  receiptId: Scalars['String']['input'];
  selectedPaymentProvider: PaymentProviderOption;
};

export type PaymentDeadlineNotificationData = {
  __typename?: 'PaymentDeadlineNotificationData';
  ownerUserId: Scalars['ID']['output'];
  rentCharge: RentChargeOutput;
};

/** Payment frequency option for describing origin of a payment */
export enum PaymentFrequencyOption {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY',
  Yearly = 'YEARLY'
}

/** Defines the available payment methods for transactions. */
export enum PaymentMethodOption {
  Auto = 'AUTO',
  Platform = 'PLATFORM',
  Transfer = 'TRANSFER'
}

/** Payment information */
export type PaymentOutput = {
  __typename?: 'PaymentOutput';
  /** Amount of the payment as a string */
  amountValue: Scalars['String']['output'];
  complementaryData?: Maybe<PaymentComplementaryDataUnion>;
  /** Date when the payment was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the payment */
  id: Scalars['ID']['output'];
  /** Status of the payment */
  paymentStatusOption: PaymentStatusOption;
};

export type PaymentProviderDataUnion = DepositPaymentReportOutput | RedsysPaymentReportOutput | StripePaymentReportOutput;

/** Defines the available payment providers for transactions. */
export enum PaymentProviderOption {
  Deposit = 'DEPOSIT',
  Redsys = 'REDSYS',
  Stripe = 'STRIPE'
}

/** Payment information for deposit reports */
export type PaymentReportOutput = {
  __typename?: 'PaymentReportOutput';
  /** Amount of the payment as a string */
  amountValue: Scalars['String']['output'];
  /** Date when the payment was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the payment */
  id: Scalars['ID']['output'];
  /** Status of the payment */
  paymentStatusOption: PaymentStatusOption;
  providerData?: Maybe<PaymentProviderDataUnion>;
};

export type PaymentResponseUnion = ActionResponseMessageOutput | DepositOutput | RedsysPaymentDataOutput | StripePaymentDataOutput;

/** Payment status of a payment */
export enum PaymentStatusOption {
  Abandoned = 'ABANDONED',
  Aborted = 'ABORTED',
  Confirmed = 'CONFIRMED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Payment type option for describing origin of a payment */
export enum PaymentTypeOption {
  Expense = 'EXPENSE',
  RentCharge = 'RENT_CHARGE'
}

export type PaymentsSystemAvailabilityOutput = {
  __typename?: 'PaymentsSystemAvailabilityOutput';
  /** Indicates if Redsys is available. */
  isRedsysAvailable: Scalars['Boolean']['output'];
  /** Indicates if Stripe is available. */
  isStripeAvailable: Scalars['Boolean']['output'];
};

/** Enumeration for priority levels, such as Low, Medium, and High */
export enum PriorityOption {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Respuesta paginada de properties */
export type PropertiesPaginatedOutput = {
  __typename?: 'PropertiesPaginatedOutput';
  /** Lista de properties */
  items: Array<PropertyOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

export type PropertyFilterInput = {
  balcony?: InputMaybe<Scalars['Boolean']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  commonAirConditioner?: InputMaybe<Scalars['Boolean']['input']>;
  commonBathroom?: InputMaybe<Scalars['Boolean']['input']>;
  commonFan?: InputMaybe<Scalars['Boolean']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  elevator?: InputMaybe<Scalars['Boolean']['input']>;
  kitchen?: InputMaybe<Scalars['Boolean']['input']>;
  occupancyStatus?: InputMaybe<UnityStatusOption>;
  orderDirection?: InputMaybe<OrderDirectionOption>;
  /** Número de página (1-based), como string. Si no se envía, se usa la página 1. */
  page?: InputMaybe<Scalars['String']['input']>;
  /** Tamaño de página (items por página). Si no se envía, se usa 25. */
  pageSize?: InputMaybe<PageSizeOption>;
  patio?: InputMaybe<Scalars['Boolean']['input']>;
  /** Texto libre en una sola búsqueda (como contratos/incidentes): coincide si el término aparece en nombre de la propiedad, dirección, ciudad, provincia o nombre completo del propietario. */
  search?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PropertyTypeOption>;
};

/** Represents a property with its details for GraphQL output. */
export type PropertyOutput = {
  __typename?: 'PropertyOutput';
  address: AddressOutput;
  /** Porperty has Balcony */
  balcony: Scalars['Boolean']['output'];
  /** Property has common air conditioner */
  commonAirConditioner: Scalars['Boolean']['output'];
  /** Property has common bathrrom */
  commonBathroom: Scalars['Boolean']['output'];
  /** Property has Fan in common areas */
  commonFan: Scalars['Boolean']['output'];
  contacts: Array<ContactOutput>;
  contracts: Array<ContractOutput>;
  /** Property has elevator */
  elevator: Scalars['Boolean']['output'];
  fileUploads: Array<FileUploadOutput>;
  /** Unique identifier for the property. */
  id: Scalars['ID']['output'];
  incidents: Array<IncidentOutput>;
  insurances: Array<InsuranceOutput>;
  /** Property will be rented entire */
  isForRentWhole: Scalars['Boolean']['output'];
  /** Property has kitchen */
  kitchen: Scalars['Boolean']['output'];
  manager: ManagerOutput;
  /** Name of the property. */
  name: Scalars['String']['output'];
  notes: Array<NoteOutput>;
  /** Occupancy status of the property */
  occupancyStatusOption: UnityStatusOption;
  owner?: Maybe<OwnerOutput>;
  /** Property has patio  */
  patio: Scalars['Boolean']['output'];
  /** Type of the property, e.g., residential or commercial. */
  typeOption: PropertyTypeOption;
  unities: Array<UnityOutput>;
};

/** Enumeration of possible property types, such as unique, multi-family, apartment, etc. */
export enum PropertyTypeOption {
  Apartment = 'APARTMENT',
  MultiFamily = 'MULTI_FAMILY',
  Other = 'OTHER',
  TownHouse = 'TOWN_HOUSE',
  Unique = 'UNIQUE'
}

export type Query = {
  __typename?: 'Query';
  /** Lista paginada de avisos de alquiler impago. Mismo filtro opcional que el dashboard (propiedad, geo, período). */
  alertNotices: AlertNoticesPaginatedOutput;
  billing: BillingOutput;
  /** Retrieve a single budget by its ID. Requires a valid token and user type MANAGER or OWNER. */
  budget: BudgetOutput;
  /** Retrieve all budgets for the authenticated user. Requires a valid token and user type MANAGER. */
  budgets: Array<BudgetOutput>;
  /** Returns a list of cities for a given state id. */
  cities: Array<CityOutput>;
  /** Returns a city by its unique numeric id. */
  city: CityOutput;
  /** Find a city by name within a state. Returns null if not found. */
  cityByName?: Maybe<CityOutput>;
  /** Retrieve a specific contract by ID. Requires a valid token and MANAGER role. */
  contract: ContractOutput;
  /** Retrieve all contracts. Requires a valid token and MANAGER role. */
  contracts: ContractsPaginatedOutput;
  /** Returns a list of all available countries. */
  countries: Array<CountryOutput>;
  /** Returns a country by its ISO code (e.g., "AR" for Argentina). */
  country: CountryOutput;
  /** Retrieve a manager's dashboard data. Requires a valid token and user type MANAGER or TENANT. */
  dashboardData: DashboardOutput;
  /** Retrieve a paginated list of deposits for the current manager (Reports module). */
  depositsReport: DepositsPaginatedOutput;
  /** Retrieve a single expense by its ID. */
  expense: ExpenseOutput;
  /** Retrieve all expenses for the current property. */
  expenses: Array<ExpenseOutput>;
  /** Listar expenses con filtros y paginación. */
  expensesPaginated: ExpensesPaginatedResult;
  /** Retrieve a paginated list of expenses for the current manager (Reports module). */
  expensesReport: ExpensesPaginatedOutput;
  /** Retrieves contract information from Customer App for tenant */
  getContractsForTenant: Array<ContractOutput>;
  /** Retrieve a manager's dashboard data. Requires a valid token and user type MANAGER or TENANT. */
  getDashboradForOwnerUIData: DashboardOutput;
  getDeposit: DepositOutput;
  /** Retrieves detailed information of an incident for a supplier request */
  getIncidentForSupplier: IncidentOutput;
  /** Retrieves detailed information of an incident for a supplier request */
  getIncidentForTenant: IncidentOutput;
  getIncidentReport: IncidentReportOutput;
  /** Retrieve incidents for the current supplier. */
  getIncidentsForSupplier: IncidentsPaginatedOutput;
  /** Retrieve incidents from a tenant account */
  getIncidentsForTenant: IncidentsPaginatedOutput;
  getMessagesByIncident: Array<MessageOutput>;
  getMyReceipts: Array<ReceiptAggregationOutput>;
  /** Retrieve all payments related to a rent charge by its ID. Requires a valid token and user type MANAGER. */
  getPaymentsByRentChargeId: Array<PaymentOutput>;
  /** Retrieve all properties for authenticated OWNER with all data needed for Owner UI. */
  getPropertiesForOwner: Array<PropertyOutput>;
  /** Obtiene la configuración de Redsys del usuario autenticado */
  getRedsysConfiguration: RedsysUserConfigurationResponseUnion;
  /** Return an array with rentcharges related to user that is requesting information */
  getRentCharges: Array<RentChargeOutput>;
  /** Retrieves supplier information for customer App */
  getSupplierForSupplier: SupplierOutput;
  /** Retrieves Tenant information for Tenant Client App */
  getTenantForTenant: TenantOutput;
  /** Retrieve a single incident by its ID. Requires a valid token and user type MANAGER or OWNER. */
  incident: IncidentOutput;
  /** Retrieve all incidents for the current user. Requires a valid token and user type MANAGER. */
  incidents: IncidentsForTenantResponseUnion;
  /** Retrieve incidents for the current owner. */
  incidentsForOwner: Array<IncidentOutput>;
  /** Retrieve all inventories for a given property. Requires MANAGER role. */
  inventories: Array<InventoryOutput>;
  /** Retrieve a single inventory by ID for a given property. Requires MANAGER role. */
  inventory: InventoryOutput;
  /** Obtiene una inspección/inventario por ID (incluye secciones e ítems). */
  inventoryInspection: InventoryInspectionOutput;
  /** Lista de inspecciones/inventarios para una propiedad (con secciones e ítems). */
  inventoryInspections: Array<InventoryInspectionOutput>;
  /** Checks if the user is currently logged in. */
  isLogged: ActionResponseMessageOutput;
  /** Retrieve a manager by ID. Requires a valid token and MANAGER role. */
  manager: ManagerOutput;
  /** Manager reads availability slots for one incident. */
  managerIncidentAppointmentSlots: Array<AppointmentSlotOutput>;
  /** Lista de anuncios enviados por el manager. */
  managerMassiveCommunications: Array<ManagerCommunicationOutput>;
  /** Retrieve a paginated list of incident ratings for the current manager. */
  managerRatingsReport: ManagerRatingsPaginatedOutput;
  /** Resumen de calificaciones del manager (promedio y desglose). Filtro opcional: propiedad, ubicación y/o período (mismos criterios que el dashboard). */
  managerRatingsSummary: ManagerRatingsSummaryOutput;
  /** Retrieve a list of all managers. Requires a valid token and MANAGER role. */
  managers: Array<ManagerOutput>;
  massiveCommunicationTemplates: Array<MassiveCommunicationTemplateOutput>;
  /** Retrieve a single note by ID. Requires a valid token and user type MANAGER or OWNER. */
  note: NoteOutput;
  /** Retrieve all notes. Requires a valid token and user type MANAGER. */
  notes: Array<NoteOutput>;
  /** Retrieve the authenticated manager's details. Requires a valid token and MANAGER role. */
  ownManager: ManagerOutput;
  /** Retrieve a specific owner. Requires a valid token. User must be MANAGER. */
  owner: OwnerOutput;
  /** Global search for an owner by email or documentId, ignoring manager. Returns null if not found. */
  ownerAnyByEmailOrDocument?: Maybe<OwnerOutput>;
  /** Find an owner by email or documentId. Returns null if not found. Requires MANAGER role. */
  ownerByEmailOrDocument?: Maybe<OwnerOutput>;
  /** Retrieve a specific owner contract by ID. Requires a valid token and MANAGER role. */
  ownerContract: OwnerContractOutput;
  /** Retrieve all owner contracts. Requires a valid token and MANAGER role. */
  ownerContracts: OwnerContractsPaginatedOutput;
  /** Retrieve all owners. Requires a valid token. User must be MANAGER. */
  owners: OwnersPaginatedOutput;
  /** Lista paginada de propiedades del manager. Usar `filterInput.page` (1-based) y `filterInput.pageSize` (`PageSizeOption`). Requiere token y rol MANAGER. */
  properties: PropertiesPaginatedOutput;
  /** Retrieve all properties. Requires a valid token and MANAGER role. */
  propertiesByOwner: Array<PropertyOutput>;
  /** Retrieve a property by its ID. */
  property?: Maybe<PropertyOutput>;
  /** Retrieve a single rent charge by its ID. Requires a valid token and user type MANAGER. */
  rentCharge: RentChargeOutput;
  /** Retrieve a paginated list of rent charges for the current manager (Reports module). */
  rentChargesReport: RentChargesPaginatedOutput;
  /** Returns a state by its composite id. The id must be the country code concatenated with the state number, separated by a dot (e.g., "AR.01" or "VE.15"). */
  state: StateOutput;
  /** Find a state by name within a country. Returns null if not found. */
  stateByName?: Maybe<StateOutput>;
  /** Returns a list of states for a given country code. */
  states: Array<StateOutput>;
  /** Retrieve a single supplier by ID. Requires a valid token and user type MANAGER or SUPPLIER. */
  supplier: SupplierOutput;
  /** Supplier reads availability slots for one assigned incident. */
  supplierIncidentAppointmentSlots: Array<AppointmentSlotOutput>;
  /** Retrieve all suppliers. Requires a valid token and user type MANAGER. */
  suppliers: SuppliersPaginatedOutput;
  /** Retrieve a tenant by ID or the current user's tenant. Requires a valid token and user type MANAGER or TENANT. */
  tenant: TenantOutput;
  /** Global search for a tenant by email or documentId, ignoring manager. Returns null if not found. */
  tenantAnyByEmailOrDocument?: Maybe<TenantOutput>;
  /** Tenant reads availability slots for one incident. */
  tenantIncidentAppointmentSlots: Array<AppointmentSlotOutput>;
  /** Retrieve all tenants. Requires a valid token and user type MANAGER. */
  tenants: TenantsPaginatedOutput;
  /** Obtiene la configuración del usuario autenticado */
  userConfiguration: UserConfigurationOutput;
  /** Obtiene la configuración del usuario autenticado */
  userMainConfigurationFromCustomer: UserConfigurationOutput;
  /** Lista de anuncios para el usuario actual (tenant/owner/supplier). Excluye archivados. */
  userMassiveCommunications: Array<UserCommunicationOutput>;
  userNotifications: Array<NotificationOutput>;
};


export type QueryAlertNoticesArgs = {
  filter?: InputMaybe<DashboardFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingArgs = {
  id: Scalars['String']['input'];
};


export type QueryBudgetArgs = {
  id: Scalars['String']['input'];
};


export type QueryCitiesArgs = {
  stateId: Scalars['String']['input'];
};


export type QueryCityArgs = {
  cityId: Scalars['String']['input'];
};


export type QueryCityByNameArgs = {
  name: Scalars['String']['input'];
  stateId: Scalars['String']['input'];
};


export type QueryContractArgs = {
  id: Scalars['String']['input'];
};


export type QueryContractsArgs = {
  filterInput?: InputMaybe<ContractFilterInput>;
};


export type QueryCountryArgs = {
  code: Scalars['String']['input'];
};


export type QueryDashboardDataArgs = {
  filter?: InputMaybe<DashboardFilterInput>;
};


export type QueryDepositsReportArgs = {
  filterInput?: InputMaybe<DepositsReportFilterInput>;
};


export type QueryExpenseArgs = {
  id: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
};


export type QueryExpensesArgs = {
  id: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
};


export type QueryExpensesPaginatedArgs = {
  filters?: InputMaybe<ExpensesFilterInput>;
};


export type QueryExpensesReportArgs = {
  filterInput?: InputMaybe<ExpensesReportFilterInput>;
};


export type QueryGetDashboradForOwnerUiDataArgs = {
  filter?: InputMaybe<DashboardFilterInput>;
};


export type QueryGetDepositArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIncidentForSupplierArgs = {
  incidentId: Scalars['String']['input'];
};


export type QueryGetIncidentForTenantArgs = {
  incidentId: Scalars['String']['input'];
};


export type QueryGetIncidentReportArgs = {
  incidentId: Scalars['String']['input'];
  incidentReportId: Scalars['String']['input'];
};


export type QueryGetIncidentsForSupplierArgs = {
  filterInput?: InputMaybe<IncidentFilterInput>;
};


export type QueryGetIncidentsForTenantArgs = {
  filterInput?: InputMaybe<IncidentFilterInput>;
};


export type QueryGetMessagesByIncidentArgs = {
  incidentId: Scalars['String']['input'];
};


export type QueryGetPaymentsByRentChargeIdArgs = {
  rentChargeId: Scalars['String']['input'];
};


export type QueryIncidentArgs = {
  id: Scalars['String']['input'];
};


export type QueryIncidentsArgs = {
  filterInput?: InputMaybe<IncidentFilterInput>;
};


export type QueryInventoriesArgs = {
  propertyId: Scalars['String']['input'];
};


export type QueryInventoryArgs = {
  id: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
};


export type QueryInventoryInspectionArgs = {
  id: Scalars['ID']['input'];
  propertyId: Scalars['ID']['input'];
};


export type QueryInventoryInspectionsArgs = {
  propertyId: Scalars['ID']['input'];
};


export type QueryManagerIncidentAppointmentSlotsArgs = {
  incidentId: Scalars['ID']['input'];
};


export type QueryManagerRatingsReportArgs = {
  filterInput?: InputMaybe<ManagerRatingsReportFilterInput>;
};


export type QueryManagerRatingsSummaryArgs = {
  filter?: InputMaybe<DashboardFilterInput>;
};


export type QueryNoteArgs = {
  id: Scalars['String']['input'];
};


export type QueryOwnerArgs = {
  id: Scalars['String']['input'];
};


export type QueryOwnerAnyByEmailOrDocumentArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOwnerByEmailOrDocumentArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOwnerContractArgs = {
  id: Scalars['String']['input'];
};


export type QueryOwnerContractsArgs = {
  filterInput?: InputMaybe<OwnerContractFilterInput>;
};


export type QueryOwnersArgs = {
  filterInput?: InputMaybe<OwnerFilterInput>;
};


export type QueryPropertiesArgs = {
  filterInput?: InputMaybe<PropertyFilterInput>;
};


export type QueryPropertiesByOwnerArgs = {
  ownerId: Scalars['String']['input'];
};


export type QueryPropertyArgs = {
  id: Scalars['String']['input'];
};


export type QueryRentChargeArgs = {
  id: Scalars['String']['input'];
};


export type QueryRentChargesReportArgs = {
  filterInput?: InputMaybe<RentChargesReportFilterInput>;
};


export type QueryStateArgs = {
  code: Scalars['String']['input'];
};


export type QueryStateByNameArgs = {
  countryIso2: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type QueryStatesArgs = {
  countryId: Scalars['String']['input'];
};


export type QuerySupplierArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierIncidentAppointmentSlotsArgs = {
  incidentId: Scalars['ID']['input'];
};


export type QuerySuppliersArgs = {
  filterInput?: InputMaybe<SupplierFilterInput>;
};


export type QueryTenantArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantAnyByEmailOrDocumentArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantIncidentAppointmentSlotsArgs = {
  incidentId: Scalars['ID']['input'];
};


export type QueryTenantsArgs = {
  filterInput?: InputMaybe<TenantFilterInput>;
};

/** Represents a rating entity. */
export type RatingOutput = {
  __typename?: 'RatingOutput';
  /** Comment associated with the rating. */
  comment: Scalars['String']['output'];
  /** Creation timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the rating. */
  id: Scalars['ID']['output'];
  /** Rating value, typically from 1 to 5. */
  value: Scalars['String']['output'];
};

export type ReceiptAggregationItemInput = {
  chargeId: Scalars['String']['input'];
  chargeTypeOption: PaymentTypeOption;
};

/** An item of a Receipt Aggregation */
export type ReceiptAggregationItemOutput = {
  __typename?: 'ReceiptAggregationItemOutput';
  amount: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

/** Receipt made to proccess to pay */
export type ReceiptAggregationOutput = {
  __typename?: 'ReceiptAggregationOutput';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Array<ReceiptAggregationItemOutput>;
  /** Status of this Receipt Aggregation */
  statusOption: ReceiptAggregationStatusOption;
  totalAmount: Scalars['String']['output'];
};

/** Available status for receipt aggregation option */
export enum ReceiptAggregationStatusOption {
  Abandoned = 'ABANDONED',
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type RedsysPaymentComplementaryDataOutput = {
  __typename?: 'RedsysPaymentComplementaryDataOutput';
  /** Order number from Redsys payment */
  order?: Maybe<Scalars['String']['output']>;
};

export type RedsysPaymentDataOutput = {
  __typename?: 'RedsysPaymentDataOutput';
  paymentFormParameters: Array<RedsysPaymentFormFields>;
};

export type RedsysPaymentFormFields = {
  __typename?: 'RedsysPaymentFormFields';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RedsysPaymentReportOutput = {
  __typename?: 'RedsysPaymentReportOutput';
  amount: Scalars['String']['output'];
  order: Scalars['String']['output'];
  sign: Scalars['String']['output'];
};

/** Parámetros para configurar Redsys */
export type RedsysUserConfigInput = {
  /** Código de comercio (FUC) de Redsys */
  merchantCode: Scalars['String']['input'];
  /** Clave secreta del comercio */
  merchantKey: Scalars['String']['input'];
  /** Terminal asignado por Redsys */
  terminal: Scalars['String']['input'];
};

/** Configuración Redsys asociada al usuario */
export type RedsysUserConfigOutput = {
  __typename?: 'RedsysUserConfigOutput';
  /** Código de comercio (FUC) de Redsys */
  merchantCode: Scalars['String']['output'];
  /** Terminal configurado en Redsys */
  terminal: Scalars['String']['output'];
};

export type RedsysUserConfigurationResponseUnion = ActionResponseMessageOutput | RedsysUserConfigOutput;

/** Represents a charge associated with a rental contract for GraphQL output. */
export type RentChargeOutput = {
  __typename?: 'RentChargeOutput';
  /** The monetary amount of the rent charge as a string. */
  amountValue: Scalars['String']['output'];
  /** Charge currency type. */
  currencyOption: CurrencyOption;
  /** A brief description of the rent charge. */
  description: Scalars['String']['output'];
  /** Date of execution of the related rent charge. */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Date of execution of the related rent charge. */
  executionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the rent charge. */
  id: Scalars['ID']['output'];
  /** The status of the rent charge. */
  rentChargeStatusOption: RentChargeStatusOption;
  /** The type/category of the rent charge. */
  rentChargeTypeOption: RentChargeTypeOption;
};

export type RentChargeReportOutput = {
  __typename?: 'RentChargeReportOutput';
  /** The monetary amount of the rent charge as a string. */
  amountValue: Scalars['String']['output'];
  /** Charge currency type. */
  currencyOption: CurrencyOption;
  /** A brief description of the rent charge. */
  description: Scalars['String']['output'];
  /** Date of execution of the related rent charge. */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Date of execution of the related rent charge. */
  executionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the rent charge. */
  id: Scalars['ID']['output'];
  payments: Array<PaymentReportOutput>;
  /** The status of the rent charge. */
  rentChargeStatusOption: RentChargeStatusOption;
  /** The type/category of the rent charge. */
  rentChargeTypeOption: RentChargeTypeOption;
  tenant: TenantOutput;
};

/** Enumerations of possibles Rent-Charges status options */
export enum RentChargeStatusOption {
  NotReceived = 'NOT_RECEIVED',
  Overdue = 'OVERDUE',
  Pending = 'PENDING',
  Received = 'RECEIVED'
}

/** Options for categorizing different types of rent charges, such as income or deposits */
export enum RentChargeTypeOption {
  PetDeposit = 'PET_DEPOSIT',
  RentIncome = 'RENT_INCOME',
  SecurityDeposit = 'SECURITY_DEPOSIT'
}

/** Respuesta paginada de rent charges para Reports */
export type RentChargesPaginatedOutput = {
  __typename?: 'RentChargesPaginatedOutput';
  /** Lista de rent charges del manager */
  items: Array<RentChargeReportOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

/** Parámetros de filtro para listar rent charges del manager en Reports */
export type RentChargesReportFilterInput = {
  /** Filtrar por ciudad (ID) */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar por país (ID) */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar por fecha de creación desde (inclusive) */
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtrar por fecha de creación hasta (inclusive) */
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Dirección de ordenamiento por fecha de creación (ASC o DESC, por defecto DESC) */
  orderDirection?: InputMaybe<OrderDirectionOption>;
  /** Número de página (como string) */
  page?: InputMaybe<Scalars['String']['input']>;
  /** Cantidad de elementos por página */
  pageSize?: InputMaybe<PageSizeOption>;
  /** Buscar por nombre del tenant o descripción del cargo */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar por estado/provincia (ID) */
  stateId?: InputMaybe<Scalars['String']['input']>;
  /** Filtrar por estado del rent charge */
  statusOption?: InputMaybe<RentChargeStatusOption>;
  /** Filtrar por tipo de rent charge */
  typeOption?: InputMaybe<RentChargeTypeOption>;
};

/** Input type for resetting a user password */
export type ResetPasswordInput = {
  /** The new password to set for the user */
  newPassword: Scalars['String']['input'];
  /** The OTP code sent to the user for verification */
  otpCode: Scalars['Int']['input'];
};

/** Type options of an action response */
export enum ResponseType {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export type SetBudgetToIncidentInput = {
  budgetId: Scalars['String']['input'];
};

export type SetSuppliertToIncidentInput = {
  supplierId: Scalars['String']['input'];
};

/** Input type for creating a new user */
export type SignupUserInput = {
  /** The email address of the user */
  email: Scalars['String']['input'];
  /** The first name of the user */
  firstName: Scalars['String']['input'];
  /** The last name of the user */
  lastName: Scalars['String']['input'];
  /** The password for the user account */
  password: Scalars['String']['input'];
  /** The phone number of the user */
  phoneNumber: Scalars['String']['input'];
  /** user preferred currency for operation */
  preferredCurrency: CurrencyOption;
  /** Preffered user language option */
  userLanguageOption: UserLanguageOption;
};

/** Represents a state or province, including its name, codes, country, and related cities for GraphQL output. */
export type StateOutput = {
  __typename?: 'StateOutput';
  cities: Array<CityOutput>;
  /** Unique identifier for the state/province in the format "CC.NN" (e.g., "US.NY", "AR.01"). */
  geonamesAdmin1Code: Scalars['String']['output'];
  /** GeoNames ID for the admin1 division (from admin1CodesASCII.txt). */
  geonamesId?: Maybe<Scalars['Int']['output']>;
  /** Name of the state or province (e.g., "New York", "Buenos Aires") dependent on preferred language. */
  name: Scalars['String']['output'];
};

export type StatsDataOutput = {
  __typename?: 'StatsDataOutput';
  /** Total of incidents related to a Manager fro DashBoard */
  incidents: Scalars['String']['output'];
  /** Total of owners related to a Manager fro DashBoard */
  owners: Scalars['String']['output'];
  /** Total of properties related to a Manager fro DashBoard */
  properties: Scalars['String']['output'];
  /** Total of tenants related to a Manager for Dashboard */
  tenants: Scalars['String']['output'];
};

export type StripePaymentComplementaryDataOutput = {
  __typename?: 'StripePaymentComplementaryDataOutput';
  /** Stripe payment complementary data */
  sessionId?: Maybe<Scalars['String']['output']>;
};

export type StripePaymentDataOutput = {
  __typename?: 'StripePaymentDataOutput';
  checkoutURL: Scalars['String']['output'];
};

export type StripePaymentReportOutput = {
  __typename?: 'StripePaymentReportOutput';
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  operationId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  newMessageInIncident: MessageOutput;
  newNotification: NotificationOutput;
};


export type SubscriptionNewMessageInIncidentArgs = {
  incidentId: Scalars['String']['input'];
};

/** Parámetros de filtro para listar suppliers */
export type SupplierFilterInput = {
  orderDirection?: InputMaybe<OrderDirectionOption>;
  page?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<PageSizeOption>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a supplier with their details for GraphQL output. */
export type SupplierOutput = {
  __typename?: 'SupplierOutput';
  address: AddressOutput;
  bankAccount: BankAccountOutput;
  /** The birth date of the supplier. */
  birthDate: Scalars['DateTime']['output'];
  budgets: Array<BudgetOutput>;
  /** The unique document ID of the supplier. */
  documentId: Scalars['String']['output'];
  /** The first name of the supplier. */
  firstName: Scalars['String']['output'];
  /** The gender of the supplier. */
  genderOption: UserGenderTypeOption;
  /** Unique identifier for the supplier. */
  id: Scalars['ID']['output'];
  /** Indicates whether the supplier is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last name of the supplier. */
  lastName: Scalars['String']['output'];
  /** The nationality of the supplier. */
  nationality: Scalars['String']['output'];
  /** The primary phone number of the supplier. */
  phoneNumber: Scalars['String']['output'];
  /** The secondary phone number of the supplier, if available. */
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  user: UserOutput;
};

export type SupplierResponse = ActionResponseMessageOutput | SupplierOutput;

/** Respuesta paginada de suppliers */
export type SuppliersPaginatedOutput = {
  __typename?: 'SuppliersPaginatedOutput';
  /** Lista de suppliers */
  items: Array<SupplierOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

/** Parámetros de filtro para listar tenants */
export type TenantFilterInput = {
  /** Si es true, retorna solo los tenants que tienen al menos un contrato activo (status: initiated). */
  hasActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
  orderDirection?: InputMaybe<OrderDirectionOption>;
  page?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<PageSizeOption>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a tenant in the system */
export type TenantOutput = {
  __typename?: 'TenantOutput';
  address: AddressOutput;
  bankAccount?: Maybe<BankAccountOutput>;
  /** The birth date of the tenant */
  birthDate: Scalars['DateTime']['output'];
  /** A List of Contracts related to a tenant */
  contracts: Array<ContractOutput>;
  /** The unique document ID of the tenant */
  documentId: Scalars['String']['output'];
  /** The first name of the tenant */
  firstName: Scalars['String']['output'];
  /** The gender option of the tenant */
  genderOption: UserGenderTypeOption;
  /** Indicates if the tenant has pending debts (unpaid rent charges) */
  hasDebt?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the tenant */
  id: Scalars['ID']['output'];
  /** The last name of the tenant */
  lastName: Scalars['String']['output'];
  /** The nationality of the tenant */
  nationality: Scalars['String']['output'];
  /** The primary phone number of the tenant */
  phoneNumber: Scalars['String']['output'];
  /** An optional secondary phone number for the tenant */
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  user: UserOutput;
};

export type TenantResponse = ActionResponseMessageOutput | TenantOutput;

/** Respuesta paginada de tenants */
export type TenantsPaginatedOutput = {
  __typename?: 'TenantsPaginatedOutput';
  /** Lista de tenants */
  items: Array<TenantOutput>;
  /** Metadata de paginación */
  pagination: PaginationMetaOutput;
};

/** Represents a unity (unit) within a property, such as an apartment or room, for GraphQL output. */
export type UnityOutput = {
  __typename?: 'UnityOutput';
  /** Unity has air conditioner device */
  airConditioner: Scalars['Boolean']['output'];
  /** Bed size related to a unity */
  bedSizeOption: BedSizeOption;
  contracts: Array<ContractOutput>;
  /** Current status option of the unity */
  currentStatusOption: UnityStatusOption;
  /** Unity has fan */
  fan: Scalars['Boolean']['output'];
  /** Unique identifier for the unity */
  id: Scalars['ID']['output'];
  /** Name of the unity */
  name: Scalars['String']['output'];
  /** Unity has a private bathroom */
  privateBathroom: Scalars['Boolean']['output'];
  property: PropertyOutput;
};

/** Defines the possible statuses for a unity, such as vacant or occupied. */
export enum UnityStatusOption {
  NotAvailable = 'NOT_AVAILABLE',
  Occupied = 'OCCUPIED',
  Vacant = 'VACANT'
}

/** Input type for updating budget details */
export type UpdateBudgetInput = {
  /** The status option of the budget item */
  budgetStatusOption?: InputMaybe<BudgetStatusOption>;
};

export type UpdateCommunicationStatusInput = {
  communicationId: Scalars['ID']['input'];
  status?: InputMaybe<CommunicationRecipientStatusOption>;
};

/** Update contact information */
export type UpdateContactInput = {
  /** Email of a contact */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Firstname of a contact */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Lastname of a contact */
  lasttName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of a contact */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating a contract */
export type UpdateContractInput = {
  /** The auto generate rent charges of the item in the contract */
  isAutoGenerateRentCharges?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date and time when the keys were delivered to the tenant */
  keysDelivered?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date and time when the keys were received back */
  keysReceived?: InputMaybe<Scalars['DateTime']['input']>;
  /** The monthly charge amount of the item in the contract */
  monthlyChargeAmount?: InputMaybe<Scalars['String']['input']>;
  /** The status of the item in the contract */
  statusOption?: InputMaybe<ContractStatusOption>;
};

export type UpdateDepositInput = {
  /** The new status for the deposit */
  depositStatusOption: DepositStatusOption;
};

export type UpdateExpenseInput = {
  category?: InputMaybe<IncidentCategoryOption>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  /** Fecha del gasto en formato YYYY-MM-DD */
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expenseCost?: InputMaybe<Scalars['String']['input']>;
  incidentId?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExpenseStatusInput = {
  chargeStatus: RentChargeStatusOption;
  id: Scalars['String']['input'];
};

/** Input type for updating an incident */
export type UpdateIncidentInput = {
  /** Budget selected for doing the work about incident */
  budgetId?: InputMaybe<Scalars['String']['input']>;
  /** End date of the incident */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Percentage of incident charges that manager has to pay */
  managerPaymentResponsability?: InputMaybe<Scalars['String']['input']>;
  /** Percentage of incident charges that owner has to pay */
  ownerPaymentResponsability?: InputMaybe<Scalars['String']['input']>;
  /** Priority level of the incident */
  priorityOption?: InputMaybe<PriorityOption>;
  /** Start date of the incident */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Current status of the incident */
  statusOption?: InputMaybe<IncidentStatusOption>;
  /** Subject of the incident */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Percentage of incident charges that supplier has to pay */
  supplierPaymentResponsability?: InputMaybe<Scalars['String']['input']>;
  /** Percentage of incident charges that tenant has to pay */
  tenantPaymentResponsability?: InputMaybe<Scalars['String']['input']>;
  /** Ids of files that was uploaded for incident */
  uploadedFilesIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateIncidentReportInput = {
  fileUploadsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  note?: InputMaybe<CreateNoteInput>;
};

/** Información para actualizar un registro de seguro */
export type UpdateInsuranceInput = {
  /** Documento del titular del seguro (dni_titular_seguro) */
  holderDocument?: InputMaybe<Scalars['String']['input']>;
  /** Corredor del seguro (corredor_seguro) */
  insuranceBroker?: InputMaybe<Scalars['String']['input']>;
  /** Email del corredor del seguro */
  insuranceBrokerEmail?: InputMaybe<Scalars['String']['input']>;
  /** Teléfono del corredor del seguro (telf_corredor_seguro) */
  insuranceBrokerPhone?: InputMaybe<Scalars['String']['input']>;
  /** Nombre de la compañía de seguros (seguro) */
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  /** Titular del seguro (titular_seguro) */
  insuranceHolder?: InputMaybe<Scalars['String']['input']>;
  /** Teléfono de la compañía de seguros (telf_seguro) */
  insurancePhone?: InputMaybe<Scalars['String']['input']>;
  /** Número de póliza (poliza) */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  /** Plan de la póliza (policyPlan) */
  policyPlan?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an inventory. */
export type UpdateInventoryInput = {
  /** New description of the inventory. */
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing inventory inspection header. */
export type UpdateInventoryInspectionInput = {
  /** Optional contract ID if the inspection is tied to a contract. */
  contractId?: InputMaybe<Scalars['ID']['input']>;
  /** General notes of the inspection. */
  generalNotes?: InputMaybe<Scalars['String']['input']>;
  /** Date when the inspection took place. */
  inspectionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Name of the inspector. */
  inspectorName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the receiver. */
  receiverName?: InputMaybe<Scalars['String']['input']>;
  /** Type of inspection: INITIAL or FINAL. */
  type?: InputMaybe<InventoryInspectionTypeOption>;
};

/** Input type for updating an inventory item. */
export type UpdateInventoryItemInput = {
  /** New description of the item. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** New quantity of this item. */
  quantity?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating manager details */
export type UpdateManagerInput = {
  /** The new email address for the manager */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The new first name of the manager */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The new last name of the manager */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The new password for the manager */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The new phone number of the manager */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Preffered user language option */
  userLanguageOption?: InputMaybe<UserLanguageOption>;
};

export type UpdateMassiveCommunicationInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMassiveCommunicationTemplateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an existing owner contract. All fields are optional. */
export type UpdateOwnerContractInput = {
  /** Updated contract amount of the contract. */
  contractAmount?: InputMaybe<Scalars['String']['input']>;
  /** Updated contract status of the contract. */
  contractStatusOption?: InputMaybe<ContractStatusOption>;
  /** Updated finish date of the contract. */
  finishDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updated lease type of the contract. */
  ownerContractLeaseTypeOption?: InputMaybe<OwnerContractLeaseTypeOption>;
  /** Updated payment frequency of the contract. */
  paymentFrequencyOption?: InputMaybe<PaymentFrequencyOption>;
  /** Updated start date of the contract. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input type for updating owner details */
export type UpdateOwnerInput = {
  /** Additional address line of the owner */
  addressLine?: InputMaybe<Scalars['String']['input']>;
  /** Email associated with the owner's bank account */
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  /** Holder of the owner's bank account */
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  /** Name of the owner's bank account */
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  /** Number of the owner's bank account */
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Phone number associated with the owner's bank account */
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
  /** Birth date of the owner */
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Building number of the owner's address */
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  /** City of the owner's address */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Country of the owner's address */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** Document ID of the owner */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the owner */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the owner */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender option of the owner */
  genderOption?: InputMaybe<UserGenderTypeOption>;
  /** Indicates if the owner is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name of the owner */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Nationality of the owner */
  nationality?: InputMaybe<Scalars['String']['input']>;
  /** Primary phone number of the owner */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Secondary phone number of the owner */
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  /** State of the owner's address */
  stateId?: InputMaybe<Scalars['String']['input']>;
  /** Street address of the owner */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Prefered language of the Owner */
  userLanguageOption?: InputMaybe<UserLanguageOption>;
  /** Zip code of the owner's address */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating property details */
export type UpdatePropertyInput = {
  /** Additional address line for the property */
  addressLine?: InputMaybe<Scalars['String']['input']>;
  /** Porperty has Balcony */
  balcony?: InputMaybe<Scalars['Boolean']['input']>;
  /** Building number of the property */
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  /** City where the property is located */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Property has common air conditioner */
  commonAirConditioner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Property has common bathrrom */
  commonBathroom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Property has Fan in common areas */
  commonFan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Country where the property is located */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** Property has elevator */
  elevator?: InputMaybe<Scalars['Boolean']['input']>;
  /** Property has kitchen */
  kitchen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the property */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Occupancy status of the property */
  occupancyStatusOption?: InputMaybe<UnityStatusOption>;
  /** ID of the property owner */
  ownerId?: InputMaybe<Scalars['String']['input']>;
  /** Property has patio  */
  patio?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of the property (e.g., residential, commercial) */
  propertyTypeOption?: InputMaybe<PropertyTypeOption>;
  /** State where the property is located */
  stateId?: InputMaybe<Scalars['String']['input']>;
  /** Street address of the property */
  street?: InputMaybe<Scalars['String']['input']>;
  /** IDs of files (images/videos) that were uploaded for the property */
  uploadedFilesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ZIP code of the property location */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating rent charge details */
export type UpdateRentChargeInput = {
  /** Optional amount for the rent charge */
  amountValue?: InputMaybe<Scalars['String']['input']>;
  /** Optional description of the rent charge */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional day that payment have to be excecuted */
  executionDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional Status of the rent charge */
  rentChargeStatus?: InputMaybe<RentChargeStatusOption>;
  /** Optional type of the rent charge */
  rentChargeType?: InputMaybe<RentChargeTypeOption>;
};

/** Input type for updating supplier details */
export type UpdateSupplierInput = {
  /** Additional address line for the supplier */
  addressLine?: InputMaybe<Scalars['String']['input']>;
  /** Email associated with the supplier's bank account */
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  /** Holder of the supplier's bank account */
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  /** Name of the supplier's bank account */
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  /** Number of the supplier's bank account */
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Phone number associated with the supplier's bank account */
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
  /** Birth date of the supplier */
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Building number of the supplier address */
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  /** City of the supplier address */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Country of the supplier address */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** Document ID of the supplier */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the supplier */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Firstname of the supplier */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender option of the supplier */
  genderOption?: InputMaybe<UserGenderTypeOption>;
  /** Indicates if the supplier is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lastname of the supplier */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Nationality of the supplier */
  nationality?: InputMaybe<Scalars['String']['input']>;
  /** Primary phone number of the supplier */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Secondary phone number of the supplier */
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  /** State of the supplier address */
  stateId?: InputMaybe<Scalars['String']['input']>;
  /** Street address of the supplier */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Prefered language of the Owner */
  userLanguageOption?: InputMaybe<UserGenderTypeOption>;
  /** Zip code of the supplier address */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating tenant details */
export type UpdateTenantInput = {
  /** Additional address line for the tenant */
  addressLine?: InputMaybe<Scalars['String']['input']>;
  /** Email associated with the tenant's bank account */
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  /** Holder name of the tenant's bank account */
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  /** Name of the tenant's bank */
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  /** Account number of the tenant's bank account */
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Phone associated with the tenant's bank account */
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
  billingAddres1?: InputMaybe<Scalars['String']['input']>;
  billingBic?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingFirstName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingWereGoing?: InputMaybe<Scalars['String']['input']>;
  billingZipCode?: InputMaybe<Scalars['String']['input']>;
  billinglastName?: InputMaybe<Scalars['String']['input']>;
  /** Birth date of the tenant */
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Building number of the tenant's address */
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  /** City of the tenant's address */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Country of the tenant's address */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** Document ID of the tenant */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the tenant */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the tenant */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender option of the tenant */
  genderOption?: InputMaybe<UserGenderTypeOption>;
  /** Indicates if the tenant is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name of the tenant */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Nationality of the tenant */
  nationality?: InputMaybe<Scalars['String']['input']>;
  /** Primary phone number of the tenant */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Secondary phone number of the tenant */
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  /** State of the tenant's address */
  stateId?: InputMaybe<Scalars['String']['input']>;
  /** Street address of the tenant */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Prefered language of the Owner */
  userLanguageOption?: InputMaybe<UserLanguageOption>;
  /** Zip code of the tenant's address */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating unity details */
export type UpdateUnityInput = {
  /** Set if unity has air conditioner */
  airConditioner?: InputMaybe<Scalars['Boolean']['input']>;
  /** The number of bedrooms in the unity */
  bedSizeOption?: InputMaybe<BedSizeOption>;
  /** The current status of the unity */
  currentStatus?: InputMaybe<UnityStatusOption>;
  /** Set if unity has a fan */
  fan?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the unity */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Set if unity has a private bathroom */
  privateBathroom?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for creating or updating an item inside an inventory inspection section. */
export type UpsertInventoryInspectionItemInput = {
  /** Item ID if updating; omit for creation. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional notes of the item. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Order index of the item inside the section. */
  order: Scalars['Float']['input'];
  /** Quantity of the item (string for flexibility). */
  quantity?: InputMaybe<Scalars['String']['input']>;
  /** Status of the item. */
  status?: InputMaybe<InventoryInspectionItemStatusOption>;
  /** Title/label of the item. */
  title: Scalars['String']['input'];
  /** Optional uploaded file IDs associated to this item. When updating, this replaces the files list. */
  uploadedFilesIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for creating or updating a section (tab) in an inventory inspection. */
export type UpsertInventoryInspectionSectionInput = {
  /** Section ID if updating an existing one; omit for creation. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** True if section is system-generated (based on property flags). Defaults to false. */
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stable key for the section (e.g. kitchen, patio, custom-XXX). */
  key: Scalars['String']['input'];
  /** Order index of the section in the tabs. */
  order: Scalars['Int']['input'];
  /** Human-readable title for the section. */
  title: Scalars['String']['input'];
};

export type UserCommunicationOutput = {
  __typename?: 'UserCommunicationOutput';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  status: CommunicationRecipientStatusOption;
  title: Scalars['String']['output'];
};

/** Represents a user's configuration settings for GraphQL output. */
export type UserConfigurationOutput = {
  __typename?: 'UserConfigurationOutput';
  /** Unique identifier for the configuration. */
  id: Scalars['ID']['output'];
  /** The user's selected language. */
  languageOption: UserLanguageOption;
  /** Payments system availability. */
  paymentsSystemAvailability: PaymentsSystemAvailabilityOutput;
  /** The user's preferred currency for display. */
  preferredCurrencyOption: CurrencyOption;
};

/** Enumeration for user gender types, including male, female, non-binary (x), and other */
export enum UserGenderTypeOption {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  X = 'X'
}

/** Eser prefered language */
export enum UserLanguageOption {
  En = 'EN',
  Es = 'ES'
}

/** Represents a user in the system for GraphQL output. */
export type UserOutput = {
  __typename?: 'UserOutput';
  /** Unique email address of the user. */
  email: Scalars['String']['output'];
  /** Unique identifier for the user. */
  id: Scalars['ID']['output'];
  /** Resolves the user's configuration. */
  userConfiguration: UserConfigurationOutput;
  /** Type of the user. */
  userTypeOption: UserTypeOption;
};

/** Defines the various user types in the system, such as manager, tenant, owner, and supplier. */
export enum UserTypeOption {
  Manager = 'MANAGER',
  Owner = 'OWNER',
  Supplier = 'SUPPLIER',
  Tenant = 'TENANT'
}

/** Input type for validating an OTP code */
export type ValidateOtpInput = {
  /** The OTP code to validate, must be a 6-digit number */
  code: Scalars['Int']['input'];
  /** Indicates if the OTP is for registration purposes */
  isForRegistration?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'ChangePasswordResponse', oldPasswordWrong: boolean, paswordWasUpdated: boolean } };

export type CreateBudgetFromIncidentMutationVariables = Exact<{
  incidentId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  budgetCost: Scalars['String']['input'];
  budgetEarning: Scalars['String']['input'];
  observation: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateBudgetFromIncidentMutation = { __typename?: 'Mutation', createBudgetFromIncident: { __typename?: 'BudgetOutput', id: string } };

export type CreateContactFromPropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  contactInput: CreateContactInput;
}>;


export type CreateContactFromPropertyMutation = { __typename?: 'Mutation', createContactFromProperty: { __typename?: 'ContactOutput', firstName: string, lastName: string } };

export type CreateContractMutationVariables = Exact<{
  input: CreateContractInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract: { __typename?: 'ContractOutput', id: string } };

export type CreateExpenseMutationVariables = Exact<{
  createExpenseInput: CreateExpenseInput;
  originInput?: InputMaybe<ExpenseOriginInput>;
}>;


export type CreateExpenseMutation = { __typename?: 'Mutation', createExpense: { __typename?: 'ExpenseOutput', id: string, title: string } };

export type CreateIncidentMutationVariables = Exact<{
  input: CreateIncidentInput;
}>;


export type CreateIncidentMutation = { __typename?: 'Mutation', createIncident: { __typename?: 'IncidentOutput', id: string } };

export type CreateIncidentExpenseMutationVariables = Exact<{
  incidentExpenseInput: CreateIncidentExpenseInput;
  incidentId: Scalars['ID']['input'];
}>;


export type CreateIncidentExpenseMutation = { __typename?: 'Mutation', createIncidentExpense: { __typename?: 'IncidentExpenseOutput', id: string } };

export type CreateIncidentReportFromSupplierMutationVariables = Exact<{
  incidentId: Scalars['String']['input'];
  input: CreateIncidentReportInput;
}>;


export type CreateIncidentReportFromSupplierMutation = { __typename?: 'Mutation', createIncidentReportFromSupplier: { __typename?: 'IncidentReportOutput', id: string, subject: string } };

export type CreateInsuranceFromPropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  insuranceInput: CreateInsuranceInput;
}>;


export type CreateInsuranceFromPropertyMutation = { __typename?: 'Mutation', createInsuranceFromProperty: { __typename?: 'InsuranceOutput', policyNumber: string } };

export type CreateInventoryMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  input: CreateInventoryInput;
}>;


export type CreateInventoryMutation = { __typename?: 'Mutation', createInventory: { __typename?: 'InventoryOutput', id: string, description: string, items: Array<{ __typename?: 'InventoryItemOutput', id: string, description: string, quantity: string }> } };

export type CreateInventoryItemMutationVariables = Exact<{
  inventoryId: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
  input: CreateInventoryItemInput;
}>;


export type CreateInventoryItemMutation = { __typename?: 'Mutation', createInventoryItem: { __typename?: 'InventoryItemOutput', id: string, description: string, quantity: string } };

export type CreateMassiveCommunicationTemplateMutationVariables = Exact<{
  input: CreateMassiveCommunicationTemplateInput;
}>;


export type CreateMassiveCommunicationTemplateMutation = { __typename?: 'Mutation', createMassiveCommunicationTemplate: { __typename?: 'MassiveCommunicationTemplateOutput', id: string, title: string, content: string } };

export type CreateNewMessageFromIncidentMutationVariables = Exact<{
  incidentId: Scalars['String']['input'];
  input: CreateMessageFromIncidentInput;
}>;


export type CreateNewMessageFromIncidentMutation = { __typename?: 'Mutation', createMessageFromIncident: { __typename?: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } | { __typename?: 'CreateMessageOutput', messageSent: boolean } };

export type CreateNoteFromContractMutationVariables = Exact<{
  contractId: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type CreateNoteFromContractMutation = { __typename?: 'Mutation', createNoteFromContract: { __typename?: 'NoteOutput', id: string } };

export type CreateNoteFromIncidentMutationVariables = Exact<{
  incidentId: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type CreateNoteFromIncidentMutation = { __typename?: 'Mutation', createNoteFromIncident: { __typename?: 'NoteOutput', id: string } };

export type CreateNoteFromPropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type CreateNoteFromPropertyMutation = { __typename?: 'Mutation', createNoteFromProperty: { __typename?: 'NoteOutput', id: string } };

export type CreateOwnerMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  nationality: Scalars['String']['input'];
  genderOption: UserGenderTypeOption;
  birthDate: Scalars['DateTime']['input'];
  street: Scalars['String']['input'];
  buildingNumber: Scalars['String']['input'];
  addressLine?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  country: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOwnerMutation = { __typename?: 'Mutation', createOwner: { __typename?: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } | { __typename?: 'OwnerOutput', firstName: string, lastName: string } };

export type CreateOwnerContractMutationVariables = Exact<{
  input: CreateOwnerContractInput;
}>;


export type CreateOwnerContractMutation = { __typename?: 'Mutation', createOwnerContract: { __typename?: 'OwnerContractOutput', id: string } };

export type CreatePropertyMutationVariables = Exact<{
  input: CreatePropertyInput;
}>;


export type CreatePropertyMutation = { __typename?: 'Mutation', createProperty: { __typename?: 'PropertyOutput', name: string } };

export type CreateRentChargeFromContractMutationVariables = Exact<{
  contractId: Scalars['String']['input'];
  amountValue: Scalars['String']['input'];
  description: Scalars['String']['input'];
  rentChargeTypeOption: RentChargeTypeOption;
  executionDate: Scalars['DateTime']['input'];
}>;


export type CreateRentChargeFromContractMutation = { __typename?: 'Mutation', createRentChargeFromContract: { __typename?: 'RentChargeOutput', rentChargeTypeOption: RentChargeTypeOption } };

export type CreateSupplierMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  nationality: Scalars['String']['input'];
  genderOption: UserGenderTypeOption;
  birthDate: Scalars['DateTime']['input'];
  street: Scalars['String']['input'];
  buildingNumber: Scalars['String']['input'];
  addressLine?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  country: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSupplierMutation = { __typename?: 'Mutation', createSupplier: { __typename?: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } | { __typename?: 'SupplierOutput', firstName: string, lastName: string } };

export type CreateTenantMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  nationality: Scalars['String']['input'];
  genderOption: UserGenderTypeOption;
  birthDate: Scalars['DateTime']['input'];
  street: Scalars['String']['input'];
  buildingNumber: Scalars['String']['input'];
  addressLine?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  country: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateTenantMutation = { __typename?: 'Mutation', createTenant: { __typename?: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } | { __typename?: 'TenantOutput', firstName: string, lastName: string } };

export type CreateUnityFromPropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  unityInput: CreateUnityInput;
}>;


export type CreateUnityFromPropertyMutation = { __typename?: 'Mutation', createUnityFromProperty: { __typename?: 'PropertyOutput', name: string } };

export type DeleteOwnerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteOwnerMutation = { __typename?: 'Mutation', deleteOwner: { __typename?: 'OwnerOutput', firstName: string, lastName: string } };

export type DeletePropertyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePropertyMutation = { __typename?: 'Mutation', deleteProperty: { __typename?: 'PropertyOutput', name: string } };

export type DeleteRentChargeFromQueryMutationVariables = Exact<{
  contractId: Scalars['String']['input'];
  rentChargeId: Scalars['String']['input'];
}>;


export type DeleteRentChargeFromQueryMutation = { __typename?: 'Mutation', deleteRentChargeFromContract: { __typename?: 'RentChargeOutput', id: string, description: string } };

export type DeleteSupplierMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteSupplierMutation = { __typename?: 'Mutation', deleteSupplier: { __typename?: 'SupplierOutput', firstName: string, lastName: string } };

export type DeleteTenantMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTenantMutation = { __typename?: 'Mutation', deleteTenant: { __typename?: 'TenantOutput', firstName: string, lastName: string } };

export type DeleteUnityFromPropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  unityId: Scalars['String']['input'];
}>;


export type DeleteUnityFromPropertyMutation = { __typename?: 'Mutation', deleteUnityFromProperty: { __typename?: 'UnityOutput', name: string } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } };

export type GenerateClientFinderKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateClientFinderKeyMutation = { __typename?: 'Mutation', generateNewClientFinderSecretKey: { __typename?: 'GenerateClientFinderSecretKeyOutput', key: string } };

export type GetUploadUrlMutationVariables = Exact<{
  input: GenerateFileUploadInput;
}>;


export type GetUploadUrlMutation = { __typename?: 'Mutation', getUploadUrl: { __typename?: 'FileUploadOutput', uploadUrl?: string | null, id: string, fileName: string, fileStatusOption: FileStatusOption, urlToDownload?: string | null } };

export type GetFileUploadUrlsMutationVariables = Exact<{
  inputs: Array<GenerateFileUploadInput> | GenerateFileUploadInput;
}>;


export type GetFileUploadUrlsMutation = { __typename?: 'Mutation', getUploadUrls: Array<{ __typename?: 'FileUploadOutput', uploadUrl?: string | null, id: string, fileName: string, fileStatusOption: FileStatusOption, urlToDownload?: string | null }> };

export type CreateInventoryInspectionMutationVariables = Exact<{
  propertyId: Scalars['ID']['input'];
  input: CreateInventoryInspectionInput;
}>;


export type CreateInventoryInspectionMutation = { __typename?: 'Mutation', createInventoryInspection: { __typename?: 'InventoryInspectionOutput', id: string, type: InventoryInspectionTypeOption, inspectionDate: any, inspectorName: string, receiverName: string, generalNotes?: string | null, sections: Array<{ __typename?: 'InventoryInspectionSectionOutput', id: string, key: string, title: string, order: number, isSystem: boolean, items: Array<{ __typename?: 'InventoryInspectionItemOutput', id: string, title: string, quantity?: string | null, status: InventoryInspectionItemStatusOption, notes?: string | null, order: number, files: Array<{ __typename?: 'InventoryInspectionItemFileOutput', id: string, url: string }> }> }> } };

export type GenerateInventoryInspectionPdfMutationVariables = Exact<{
  propertyId: Scalars['ID']['input'];
  inspectionId: Scalars['ID']['input'];
}>;


export type GenerateInventoryInspectionPdfMutation = { __typename?: 'Mutation', generateInventoryInspectionPdf: { __typename?: 'InventoryInspectionPdfOutput', url: string, fileName: string, contentType: string } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  clientType: ClientAppTypeOption;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } | { __typename: 'LoginResponse', token: string, username: string, userType: UserTypeOption } };

export type MarkNotificationAsReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: { __typename?: 'NotificationOutput', id: string, type: NotificationTypeOption, message: string, read: boolean, createdAt: any } };

export type ResetPasswordMutationVariables = Exact<{
  otpCode: Scalars['Int']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } };

export type SaveRedsysConfigurationMutationVariables = Exact<{
  data: RedsysUserConfigInput;
}>;


export type SaveRedsysConfigurationMutation = { __typename?: 'Mutation', saveRedsysConfiguration: { __typename?: 'RedsysUserConfigOutput', terminal: string, merchantCode: string } };

export type SendMassiveCommunicationMutationVariables = Exact<{
  input: CreateMassiveCommunicationInput;
}>;


export type SendMassiveCommunicationMutation = { __typename?: 'Mutation', sendMassiveCommunication: { __typename?: 'MassiveCommunicationOutput', id: string, title: string, content: string, createdAt: any } };

export type SetSupplierToIncidentMutationVariables = Exact<{
  incidentId: Scalars['String']['input'];
  input: SetSuppliertToIncidentInput;
}>;


export type SetSupplierToIncidentMutation = { __typename?: 'Mutation', setSupplierToIncident: { __typename?: 'IncidentOutput', id: string } };

export type SignupNewUserMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userLanguageOption: UserLanguageOption;
  preferredCurrency: CurrencyOption;
}>;


export type SignupNewUserMutation = { __typename?: 'Mutation', signup: { __typename?: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } };

export type UpdateContactFromPropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
  contactInput: UpdateContactInput;
}>;


export type UpdateContactFromPropertyMutation = { __typename?: 'Mutation', updateContactFromProperty: { __typename?: 'ContactOutput', firstName: string, lastName: string } };

export type UpdateContractMutationVariables = Exact<{
  contractId: Scalars['String']['input'];
  input: UpdateContractInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract?: { __typename?: 'ContractOutput', id: string } | null };

export type UpdateDepositMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateDepositInput;
}>;


export type UpdateDepositMutation = { __typename?: 'Mutation', updateDeposit: { __typename?: 'DepositOutput', id: string, amount: string, reference: string } };

export type UpdateExpenseStatusMutationVariables = Exact<{
  updateExpenseStatusInput: UpdateExpenseStatusInput;
}>;


export type UpdateExpenseStatusMutation = { __typename?: 'Mutation', updateExpenseStatus: { __typename?: 'ExpenseOutput', id: string, chargeStatus: RentChargeStatusOption } };

export type UpdateIncidentMutationVariables = Exact<{
  incidentId: Scalars['String']['input'];
  statusOption?: InputMaybe<IncidentStatusOption>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  priorityOption?: InputMaybe<PriorityOption>;
  tenantPaymentResponsability?: InputMaybe<Scalars['String']['input']>;
  ownerPaymentResponsability?: InputMaybe<Scalars['String']['input']>;
  managerPaymentResponsability?: InputMaybe<Scalars['String']['input']>;
  supplierPaymentResponsability?: InputMaybe<Scalars['String']['input']>;
  uploadedFilesIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateIncidentMutation = { __typename?: 'Mutation', updateIncident: { __typename?: 'IncidentOutput', id: string } };

export type UpdateIncidentReportMutationVariables = Exact<{
  incidentReportId: Scalars['String']['input'];
  input: UpdateIncidentReportInput;
}>;


export type UpdateIncidentReportMutation = { __typename?: 'Mutation', updateIncidentReport: { __typename?: 'IncidentReportOutput', id: string, notes: Array<{ __typename?: 'NoteOutput', id: string, text: string, createdAt: any }> } };

export type UpdateInsuranceFromPropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  insuranceId: Scalars['String']['input'];
  insuranceInput: UpdateInsuranceInput;
}>;


export type UpdateInsuranceFromPropertyMutation = { __typename?: 'Mutation', updateInsuranceFromProperty: { __typename?: 'InsuranceOutput', policyNumber: string } };

export type UpdateInventoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
  input: UpdateInventoryInput;
}>;


export type UpdateInventoryMutation = { __typename?: 'Mutation', updateInventory: { __typename?: 'InventoryOutput', id: string, description: string, items: Array<{ __typename?: 'InventoryItemOutput', id: string, description: string, quantity: string }> } };

export type UpdateInventoryInspectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  propertyId: Scalars['ID']['input'];
  input: UpdateInventoryInspectionInput;
}>;


export type UpdateInventoryInspectionMutation = { __typename?: 'Mutation', updateInventoryInspection: { __typename?: 'InventoryInspectionOutput', id: string } };

export type UpdateInventoryItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
  inventoryId: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
  input: UpdateInventoryItemInput;
}>;


export type UpdateInventoryItemMutation = { __typename?: 'Mutation', updateInventoryItem: { __typename?: 'InventoryItemOutput', id: string, description: string, quantity: string } };

export type UpdateMangerMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMangerMutation = { __typename?: 'Mutation', updateManager: { __typename?: 'ManagerOutput', firstName: string, lastName: string } };

export type UpdateOwnerMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  genderOption?: InputMaybe<UserGenderTypeOption>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  addressLine?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOwnerMutation = { __typename?: 'Mutation', updateOwner: { __typename?: 'OwnerOutput', firstName: string, lastName: string } };

export type UpdatePropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  input: UpdatePropertyInput;
}>;


export type UpdatePropertyMutation = { __typename?: 'Mutation', updateProperty: { __typename?: 'PropertyOutput', name: string } };

export type UpdateRentChargeFromContractMutationVariables = Exact<{
  contractId: Scalars['String']['input'];
  rentChargeId: Scalars['String']['input'];
  amountValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  rentChargeTypeOption?: InputMaybe<RentChargeTypeOption>;
  executionDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateRentChargeFromContractMutation = { __typename?: 'Mutation', updateRentChargeFromContract: { __typename?: 'RentChargeOutput', rentChargeTypeOption: RentChargeTypeOption } };

export type UpdateRentChargeStatusMutationVariables = Exact<{
  rentChargeId: Scalars['String']['input'];
  statusOption: RentChargeStatusOption;
}>;


export type UpdateRentChargeStatusMutation = { __typename?: 'Mutation', updateRentCharge: { __typename?: 'RentChargeOutput', id: string, rentChargeStatusOption: RentChargeStatusOption } };

export type UpdateSupplierMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  genderOption?: InputMaybe<UserGenderTypeOption>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  addressLine?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSupplierMutation = { __typename?: 'Mutation', updateSupplier: { __typename?: 'SupplierOutput', firstName: string, lastName: string } };

export type UpdateTenantMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  genderOption?: InputMaybe<UserGenderTypeOption>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  addressLine?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountHolder?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountEmail?: InputMaybe<Scalars['String']['input']>;
  bankAccountPhone?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', updateTenant: { __typename?: 'TenantOutput', firstName: string, lastName: string } };

export type UpdateUnityFromPropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input'];
  unityId: Scalars['String']['input'];
  unityInput: UpdateUnityInput;
}>;


export type UpdateUnityFromPropertyMutation = { __typename?: 'Mutation', updateUnityFromProperty: { __typename?: 'PropertyOutput', name: string } };

export type UpsertInventoryInspectionItemMutationVariables = Exact<{
  sectionId: Scalars['ID']['input'];
  propertyId: Scalars['ID']['input'];
  input: UpsertInventoryInspectionItemInput;
}>;


export type UpsertInventoryInspectionItemMutation = { __typename?: 'Mutation', upsertInventoryInspectionItem: { __typename?: 'InventoryInspectionOutput', id: string, sections: Array<{ __typename?: 'InventoryInspectionSectionOutput', id: string, items: Array<{ __typename?: 'InventoryInspectionItemOutput', id: string, title: string, quantity?: string | null, notes?: string | null, order: number, status: InventoryInspectionItemStatusOption, files: Array<{ __typename?: 'InventoryInspectionItemFileOutput', id: string, url: string }> }> }> } };

export type UpsertInventoryInspectionSectionMutationVariables = Exact<{
  inspectionId: Scalars['ID']['input'];
  propertyId: Scalars['ID']['input'];
  input: UpsertInventoryInspectionSectionInput;
}>;


export type UpsertInventoryInspectionSectionMutation = { __typename?: 'Mutation', upsertInventoryInspectionSection: { __typename?: 'InventoryInspectionOutput', id: string, sections: Array<{ __typename?: 'InventoryInspectionSectionOutput', id: string, key: string }> } };

export type ValidateOtpMutationVariables = Exact<{
  code: Scalars['Int']['input'];
  isForRegistration?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ValidateOtpMutation = { __typename?: 'Mutation', validateOtp: { __typename?: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } };

export type AlertNoticesQueryVariables = Exact<{
  filter?: InputMaybe<DashboardFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AlertNoticesQuery = { __typename?: 'Query', alertNotices: { __typename?: 'AlertNoticesPaginatedOutput', items: Array<{ __typename?: 'AlertNoticeOutput', id: string, message: string, tenantName: string, period: string, dueDate: any, createdAt: any, rentChargeId?: string | null }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetChargeDetailQueryVariables = Exact<{
  chargeId: Scalars['String']['input'];
}>;


export type GetChargeDetailQuery = { __typename?: 'Query', rentCharge: { __typename?: 'RentChargeOutput', id: string, executionDate?: any | null, rentChargeStatusOption: RentChargeStatusOption, rentChargeTypeOption: RentChargeTypeOption, description: string, amountValue: string, currencyOption: CurrencyOption } };

export type GetAllCitiesQueryVariables = Exact<{
  stateCode: Scalars['String']['input'];
}>;


export type GetAllCitiesQuery = { __typename?: 'Query', cities: Array<{ __typename?: 'CityOutput', name: string, geonamesId: string, latitude?: number | null, longitude?: number | null }> };

export type GetCityQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
}>;


export type GetCityQuery = { __typename?: 'Query', city: { __typename?: 'CityOutput', name: string, latitude?: number | null, longitude?: number | null } };

export type GetCityWithStateAndCountryNamesQueryVariables = Exact<{
  cityId: Scalars['String']['input'];
}>;


export type GetCityWithStateAndCountryNamesQuery = { __typename?: 'Query', city: { __typename?: 'CityOutput', name: string, state: { __typename?: 'StateOutput', name: string }, country: { __typename?: 'CountryOutput', name: string } } };

export type GetContractQueryVariables = Exact<{
  id: Scalars['String']['input'];
  expensesFilterInput?: InputMaybe<ExpensesReportFilterInput>;
}>;


export type GetContractQuery = { __typename?: 'Query', contract: { __typename?: 'ContractOutput', id: string, createdAt: any, startDate: any, finishDate?: any | null, keysDelivered?: any | null, keysReceived?: any | null, signed: boolean, leaseTermOption: LeaseTermOption, rentAmount?: string | null, statusOption: ContractStatusOption, dayForExecuteCharges: string, monthlyChargeAmount?: string | null, isAutoGenerateRentCharges: boolean, unities: Array<{ __typename?: 'UnityOutput', id: string, name: string }>, property?: { __typename?: 'PropertyOutput', id: string, name: string, address: { __typename?: 'AddressOutput', street: string, buildingNumber: string, addressLine?: string | null, zipCode: string, country?: { __typename?: 'CountryOutput', name: string } | null, state?: { __typename?: 'StateOutput', name: string } | null, city?: { __typename?: 'CityOutput', name: string } | null } } | null, rentCharges: Array<{ __typename?: 'RentChargeOutput', id: string, amountValue: string, rentChargeTypeOption: RentChargeTypeOption, rentChargeStatusOption: RentChargeStatusOption, executionDate?: any | null, description: string }>, tenant?: { __typename?: 'TenantOutput', firstName: string, lastName: string, user: { __typename?: 'UserOutput', id: string } } | null, owner?: { __typename?: 'OwnerOutput', firstName: string, lastName: string, user: { __typename?: 'UserOutput', id: string } } | null, notes: Array<{ __typename?: 'NoteOutput', id: string, text: string, createdAt: any, ownerFirstName?: string | null, ownerLastName?: string | null }>, incidents: Array<{ __typename?: 'IncidentOutput', id: string, subject: string, incidentTypeOption: IncidentTypeOption, incidentCategoryOption: IncidentCategoryOption, priorityOption: PriorityOption, statusOption: IncidentStatusOption, startDate?: any | null, endDate?: any | null, unity?: { __typename?: 'UnityOutput', name: string } | null }> }, expensesReport: { __typename?: 'ExpensesPaginatedOutput', items: Array<{ __typename?: 'ExpenseOutput', id: string, incidentId?: string | null, contractId?: string | null, incidentSubject?: string | null, propertyName?: string | null, supplierName?: string | null, payerLabel?: string | null, payerUserType?: UserTypeOption | null, paidToSupplier: boolean, collectedFromPayer: boolean, title: string, description: string, date: any, expenseCost: string, invoiceNumber: string, chargeStatus: RentChargeStatusOption, typeOption: IncidentCategoryOption, currencyOption: CurrencyOption }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetContractsByStatusQueryVariables = Exact<{
  year?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetContractsByStatusQuery = { __typename?: 'Query', dashboardData: { __typename?: 'DashboardOutput', contractsByStatus: Array<{ __typename?: 'ContractsByStatusOutput', status: ContractStatusOption, count: string }> } };

export type GetContractsForIncidentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractsForIncidentsQuery = { __typename?: 'Query', contracts: { __typename?: 'ContractsPaginatedOutput', items: Array<{ __typename?: 'ContractOutput', id: string, statusOption: ContractStatusOption, unities: Array<{ __typename?: 'UnityOutput', name: string, property: { __typename?: 'PropertyOutput', address: { __typename?: 'AddressOutput', street: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null, country?: { __typename?: 'CountryOutput', iso2: string, name: string } | null } } }>, tenant?: { __typename?: 'TenantOutput', firstName: string, lastName: string } | null }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetContractsForListQueryVariables = Exact<{
  input?: InputMaybe<ContractFilterInput>;
}>;


export type GetContractsForListQuery = { __typename?: 'Query', contracts: { __typename?: 'ContractsPaginatedOutput', items: Array<{ __typename?: 'ContractOutput', id: string, rentAmount?: string | null, startDate: any, finishDate?: any | null, monthlyChargeAmount?: string | null, isAutoGenerateRentCharges: boolean, statusOption: ContractStatusOption, signed: boolean, unities: Array<{ __typename?: 'UnityOutput', name: string }>, property?: { __typename?: 'PropertyOutput', id: string, name: string } | null, tenant?: { __typename?: 'TenantOutput', firstName: string, lastName: string, user: { __typename?: 'UserOutput', id: string } } | null }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetCountriesForPhoneCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesForPhoneCodeQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'CountryOutput', iso2: string, name: string, phoneCode?: string | null }> };

export type GetCountryIsoCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountryIsoCodesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'CountryOutput', iso2: string, name: string }> };

export type GetCountryByCodeQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
}>;


export type GetCountryByCodeQuery = { __typename?: 'Query', country: { __typename?: 'CountryOutput', name: string } };

export type GetDashboardDataQueryVariables = Exact<{
  filter?: InputMaybe<DashboardFilterInput>;
}>;


export type GetDashboardDataQuery = { __typename?: 'Query', dashboardData: { __typename?: 'DashboardOutput', incomeAndExpenses: { __typename?: 'IncomeAndExpensesOutput', income: { __typename?: 'IncomeSummaryOutput', collected: string, notCollected: string, total: string, collectedPercentage: number }, expenses: { __typename?: 'ExpensesSummaryOutput', paid: string, notPaid: string, total: string, paidPercentage: number } }, occupation: { __typename?: 'OccupationDataOutput', total: string, occupied: string, previousMonth: { __typename?: 'OccupationSnapshotOutput', year?: number | null, month?: number | null, occupied: string, total: string }, monthlyTrend: Array<{ __typename?: 'OccupationMonthPointOutput', year: number, month: number, occupied: string, total: string }> }, stats: { __typename?: 'StatsDataOutput', tenants: string, properties: string, incidents: string, owners: string }, incidentsByStatus: Array<{ __typename?: 'IncidentsByStatusOutput', status: IncidentStatusOption, count: string }> } };

export type GetDepositsReportQueryVariables = Exact<{
  filterInput?: InputMaybe<DepositsReportFilterInput>;
}>;


export type GetDepositsReportQuery = { __typename?: 'Query', depositsReport: { __typename?: 'DepositsPaginatedOutput', items: Array<{ __typename?: 'DepositReportOutput', id: string, amount: string, operationDate: any, reference: string, ownerAccountName: string, currencyOption: CurrencyOption, depositStatusOption: DepositStatusOption, payment?: { __typename?: 'PaymentReportOutput', id: string, paymentStatusOption: PaymentStatusOption, amountValue: string, createdAt: any } | null }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetExpensesReportQueryVariables = Exact<{
  filterInput?: InputMaybe<ExpensesReportFilterInput>;
}>;


export type GetExpensesReportQuery = { __typename?: 'Query', expensesReport: { __typename?: 'ExpensesPaginatedOutput', items: Array<{ __typename?: 'ExpenseOutput', id: string, incidentId?: string | null, contractId?: string | null, incidentSubject?: string | null, propertyName?: string | null, supplierName?: string | null, payerLabel?: string | null, payerUserType?: UserTypeOption | null, paidToSupplier: boolean, collectedFromPayer: boolean, title: string, description: string, date: any, expenseCost: string, invoiceNumber: string, chargeStatus: RentChargeStatusOption, typeOption: IncidentCategoryOption, currencyOption: CurrencyOption }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetIncidentQueryVariables = Exact<{
  incidentId: Scalars['String']['input'];
}>;


export type GetIncidentQuery = { __typename?: 'Query', incident: { __typename?: 'IncidentOutput', id: string, subject: string, incidentTypeOption: IncidentTypeOption, incidentCategoryOption: IncidentCategoryOption, priorityOption: PriorityOption, statusOption: IncidentStatusOption, startDate?: any | null, endDate?: any | null, updatedAt: any, incidentResponsabilities: Array<{ __typename?: 'IncidentResponsabilityOutput', responsabilityPercentage: string, userTypeOption: UserTypeOption, amount: string }>, supplier?: { __typename?: 'SupplierOutput', firstName: string, lastName: string, user: { __typename?: 'UserOutput', id: string } } | null, tenant?: { __typename?: 'TenantOutput', firstName: string, lastName: string, hasDebt?: boolean | null, user: { __typename?: 'UserOutput', id: string } } | null, incidentRating?: { __typename?: 'RatingOutput', id: string, value: string, comment: string } | null, property?: { __typename?: 'PropertyOutput', id: string, name: string, address: { __typename?: 'AddressOutput', street: string, buildingNumber: string, addressLine?: string | null, zipCode: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null, country?: { __typename?: 'CountryOutput', iso2: string, name: string } | null } } | null, unity?: { __typename?: 'UnityOutput', id: string, name: string } | null, budgets?: Array<{ __typename?: 'BudgetOutput', id: string, budgetCost: string, budgetEarning: string, budgetStatusOption: BudgetStatusOption, subject: string, supplier: { __typename?: 'SupplierOutput', firstName: string, lastName: string } }> | null, selectedBudget?: { __typename?: 'BudgetOutput', id: string, budgetCost: string, budgetEarning: string, budgetStatusOption: BudgetStatusOption, subject: string, supplier: { __typename?: 'SupplierOutput', firstName: string, lastName: string } } | null, notes: Array<{ __typename?: 'NoteOutput', id: string, text: string, createdAt: any, ownerFirstName?: string | null, ownerLastName?: string | null }>, fileUploads: Array<{ __typename?: 'FileUrlDownloadOutput', urlToDownload: string, fileTypeOption: FileTypeOption }>, incidentReports: Array<{ __typename?: 'IncidentReportOutput', id: string, subject: string, updatedAt: any }>, incidentExpenses: Array<{ __typename?: 'IncidentExpenseOutput', id: string, invoiceNumber: string, invoiceDate: any, amount: string, description: string }> } };

export type GetIncidentReportDetailQueryVariables = Exact<{
  incidentId: Scalars['String']['input'];
  incidentReportId: Scalars['String']['input'];
}>;


export type GetIncidentReportDetailQuery = { __typename?: 'Query', getIncidentReport: { __typename?: 'IncidentReportOutput', id: string, subject: string, createdAt: any, updatedAt: any, notes: Array<{ __typename?: 'NoteOutput', id: string, text: string, createdAt: any, ownerFirstName?: string | null, ownerLastName?: string | null }>, fileUploads: Array<{ __typename?: 'FileUrlDownloadOutput', urlToDownload: string, fileTypeOption: FileTypeOption }> } };

export type GetIncidentsForListQueryVariables = Exact<{
  input?: InputMaybe<IncidentFilterInput>;
}>;


export type GetIncidentsForListQuery = { __typename?: 'Query', incidents: { __typename: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } | { __typename: 'IncidentsPaginatedOutput', items: Array<{ __typename?: 'IncidentOutput', id: string, incidentTypeOption: IncidentTypeOption, priorityOption: PriorityOption, statusOption: IncidentStatusOption, subject: string, startDate?: any | null, supplier?: { __typename?: 'SupplierOutput', firstName: string, lastName: string } | null, tenant?: { __typename?: 'TenantOutput', firstName: string, lastName: string, hasDebt?: boolean | null } | null, property?: { __typename?: 'PropertyOutput', name: string, address: { __typename?: 'AddressOutput', street: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null } } | null, unity?: { __typename?: 'UnityOutput', name: string } | null }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetInventoryInspectionsQueryVariables = Exact<{
  propertyId: Scalars['ID']['input'];
}>;


export type GetInventoryInspectionsQuery = { __typename?: 'Query', inventoryInspections: Array<{ __typename?: 'InventoryInspectionOutput', id: string, type: InventoryInspectionTypeOption, inspectionDate: any, inspectorName: string, receiverName: string, generalNotes?: string | null, sections: Array<{ __typename?: 'InventoryInspectionSectionOutput', id: string, key: string, title: string, order: number, isSystem: boolean, items: Array<{ __typename?: 'InventoryInspectionItemOutput', id: string, title: string, quantity?: string | null, status: InventoryInspectionItemStatusOption, notes?: string | null, order: number, files: Array<{ __typename?: 'InventoryInspectionItemFileOutput', id: string, url: string }> }> }> }> };

export type GetInventoryQueryVariables = Exact<{
  id: Scalars['String']['input'];
  propertyId: Scalars['String']['input'];
}>;


export type GetInventoryQuery = { __typename?: 'Query', inventory: { __typename?: 'InventoryOutput', id: string, description: string, items: Array<{ __typename?: 'InventoryItemOutput', id: string, description: string, quantity: string }> } };

export type GetManagerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagerQuery = { __typename?: 'Query', manager: { __typename?: 'ManagerOutput', firstName: string, lastName: string, phoneNumber: string, user: { __typename?: 'UserOutput', email: string } } };

export type ManagerIncidentAppointmentSlotsQueryVariables = Exact<{
  incidentId: Scalars['ID']['input'];
}>;


export type ManagerIncidentAppointmentSlotsQuery = { __typename?: 'Query', managerIncidentAppointmentSlots: Array<{ __typename?: 'AppointmentSlotOutput', id: string, status: AppointmentSlotStatusOption, startAt: any, endAt: any, selectedAt?: any | null, createdAt: any, updatedAt: any }> };

export type GetManagerMassiveCommunicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagerMassiveCommunicationsQuery = { __typename?: 'Query', managerMassiveCommunications: Array<{ __typename?: 'ManagerCommunicationOutput', id: string, title: string, content: string, recipientCount: number, createdAt: any }> };

export type GetManagerRatingsReportQueryVariables = Exact<{
  filterInput?: InputMaybe<ManagerRatingsReportFilterInput>;
}>;


export type GetManagerRatingsReportQuery = { __typename?: 'Query', managerRatingsReport: { __typename?: 'ManagerRatingsPaginatedOutput', items: Array<{ __typename?: 'ManagerRatingReportRowOutput', id: string, createdAt: any, tenantName?: string | null, incidentId: string, ratingValue: number, comment?: string | null, propertyName?: string | null, unityName?: string | null }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetManagerRatingsSummaryQueryVariables = Exact<{
  filter?: InputMaybe<DashboardFilterInput>;
}>;


export type GetManagerRatingsSummaryQuery = { __typename?: 'Query', managerRatingsSummary: { __typename?: 'ManagerRatingsSummaryOutput', averageRating: number, totalRatings: number, breakdown: Array<{ __typename?: 'ManagerRatingBreakdownRowOutput', ratingValue: number, percentage: number, count: number }> } };

export type GetMassiveCommunicationTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMassiveCommunicationTemplatesQuery = { __typename?: 'Query', massiveCommunicationTemplates: Array<{ __typename?: 'MassiveCommunicationTemplateOutput', id: string, title: string, content: string, createdAt: any, updatedAt: any }> };

export type GetMessagesByIncidentQueryVariables = Exact<{
  incidentId: Scalars['String']['input'];
}>;


export type GetMessagesByIncidentQuery = { __typename?: 'Query', getMessagesByIncident: Array<{ __typename?: 'MessageOutput', id: string, content: string, messageOwnerOption?: MessageOwnerOption | null, messageStatusOption: MessageStatusOption, senderUserTypeOption?: UserTypeOption | null, receiverUserTypeOption?: UserTypeOption | null, createdAt: any }> };

export type UserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationsQuery = { __typename?: 'Query', userNotifications: Array<{ __typename?: 'NotificationOutput', id: string, type: NotificationTypeOption, message: string, read: boolean, createdAt: any, additionalData?: { __typename: 'ContractNotificationData', contractId: string } | { __typename: 'IncidentAssignedNotificationData', incidentId: string, incidentSubject: string, propertyName: string } | { __typename: 'IncidentCreatedNotificationData', incidentId: string, tenantName: string, propertyName: string } | { __typename: 'IncidentFollowUpNotificationData', incidentId: string, incidentSubject: string, propertyName: string, daysSinceCreation: number } | { __typename: 'IncidentReportSubmittedNotificationData', incidentId: string, incidentReportId: string, incidentSubject: string, supplierName: string } | { __typename: 'MessageCreatedNotificationData', messageId: string, senderName: string, incidentId: string } | { __typename: 'PaymentDeadlineNotificationData', ownerUserId: string, rentCharge: { __typename?: 'RentChargeOutput', id: string, amountValue: string, description: string, dueDate?: any | null, executionDate?: any | null, rentChargeStatusOption: RentChargeStatusOption, rentChargeTypeOption: RentChargeTypeOption, currencyOption: CurrencyOption } } | null }> };

export type GetOwnerContractQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOwnerContractQuery = { __typename?: 'Query', ownerContract: { __typename?: 'OwnerContractOutput', id: string, startDate: any, finishDate: any, ownerContractLeaseTypeOption: OwnerContractLeaseTypeOption, paymentFrequencyOption: PaymentFrequencyOption, contractStatusOption: ContractStatusOption, contractAmount: string, property: { __typename?: 'PropertyOutput', id: string, name: string, address: { __typename?: 'AddressOutput', street: string, buildingNumber: string, addressLine?: string | null, zipCode: string, country?: { __typename?: 'CountryOutput', name: string } | null, state?: { __typename?: 'StateOutput', name: string } | null, city?: { __typename?: 'CityOutput', name: string } | null }, unities: Array<{ __typename?: 'UnityOutput', id: string, name: string }> }, owner: { __typename?: 'OwnerOutput', firstName: string, lastName: string, user: { __typename?: 'UserOutput', id: string } } } };

export type GetOwnerContractsForListQueryVariables = Exact<{
  filterInput?: InputMaybe<OwnerContractFilterInput>;
}>;


export type GetOwnerContractsForListQuery = { __typename?: 'Query', ownerContracts: { __typename?: 'OwnerContractsPaginatedOutput', items: Array<{ __typename?: 'OwnerContractOutput', id: string, createdAt: any, startDate: any, finishDate: any, ownerContractLeaseTypeOption: OwnerContractLeaseTypeOption, contractStatusOption: ContractStatusOption, contractAmount: string, owner: { __typename?: 'OwnerOutput', firstName: string, lastName: string }, property: { __typename?: 'PropertyOutput', id: string, name: string } }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetOwnerDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOwnerDetailQuery = { __typename?: 'Query', owner: { __typename?: 'OwnerOutput', firstName: string, lastName: string, phoneNumber: string, phoneNumber2?: string | null, documentId: string, nationality: string, birthDate: any, genderOption: UserGenderTypeOption, user: { __typename?: 'UserOutput', id: string, email: string }, address: { __typename?: 'AddressOutput', street: string, buildingNumber: string, addressLine?: string | null, zipCode: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null, country?: { __typename?: 'CountryOutput', iso2: string, name: string } | null }, bankAccount: { __typename?: 'BankAccountOutput', name: string, holderName: string, accountNumber: string, email: string, phone: string } } };

export type GetOwnersQueryVariables = Exact<{
  filterInput?: InputMaybe<OwnerFilterInput>;
}>;


export type GetOwnersQuery = { __typename?: 'Query', owners: { __typename?: 'OwnersPaginatedOutput', items: Array<{ __typename?: 'OwnerOutput', id: string, firstName: string, lastName: string, phoneNumber: string, isActive: boolean, address: { __typename?: 'AddressOutput', street: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null }, user: { __typename?: 'UserOutput', id: string, email: string } }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetOwnersSimpleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOwnersSimpleQuery = { __typename?: 'Query', owners: { __typename?: 'OwnersPaginatedOutput', items: Array<{ __typename?: 'OwnerOutput', firstName: string, lastName: string, isActive: boolean, address: { __typename?: 'AddressOutput', city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null }, user: { __typename?: 'UserOutput', id: string } }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetPropertiesQueryVariables = Exact<{
  input?: InputMaybe<PropertyFilterInput>;
}>;


export type GetPropertiesQuery = { __typename?: 'Query', properties: { __typename?: 'PropertiesPaginatedOutput', items: Array<{ __typename?: 'PropertyOutput', id: string, name: string, typeOption: PropertyTypeOption, occupancyStatusOption: UnityStatusOption, balcony: boolean, patio: boolean, commonBathroom: boolean, kitchen: boolean, elevator: boolean, commonAirConditioner: boolean, commonFan: boolean, unities: Array<{ __typename?: 'UnityOutput', id: string, name: string, bedSizeOption: BedSizeOption, privateBathroom: boolean, fan: boolean, airConditioner: boolean, currentStatusOption: UnityStatusOption }>, address: { __typename?: 'AddressOutput', city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null }, owner?: { __typename?: 'OwnerOutput', firstName: string, lastName: string } | null }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetPropertiesForContractsQueryVariables = Exact<{
  input?: InputMaybe<PropertyFilterInput>;
}>;


export type GetPropertiesForContractsQuery = { __typename?: 'Query', properties: { __typename?: 'PropertiesPaginatedOutput', items: Array<{ __typename?: 'PropertyOutput', id: string, name: string, isForRentWhole: boolean, occupancyStatusOption: UnityStatusOption, address: { __typename?: 'AddressOutput', street: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null }, unities: Array<{ __typename?: 'UnityOutput', id: string, name: string, bedSizeOption: BedSizeOption, privateBathroom: boolean, fan: boolean, airConditioner: boolean, currentStatusOption: UnityStatusOption }>, owner?: { __typename?: 'OwnerOutput', firstName: string, lastName: string, user: { __typename?: 'UserOutput', id: string } } | null }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetPropertiesForOwnerContractCreationQueryVariables = Exact<{
  ownerId: Scalars['String']['input'];
}>;


export type GetPropertiesForOwnerContractCreationQuery = { __typename?: 'Query', propertiesByOwner: Array<{ __typename?: 'PropertyOutput', id: string, name: string, occupancyStatusOption: UnityStatusOption, address: { __typename?: 'AddressOutput', street: string, city?: { __typename?: 'CityOutput', name: string } | null, state?: { __typename?: 'StateOutput', name: string } | null } }> };

export type GetPropertyQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPropertyQuery = { __typename?: 'Query', property?: { __typename?: 'PropertyOutput', id: string, name: string, typeOption: PropertyTypeOption, occupancyStatusOption: UnityStatusOption, isForRentWhole: boolean, balcony: boolean, patio: boolean, commonBathroom: boolean, kitchen: boolean, elevator: boolean, commonAirConditioner: boolean, commonFan: boolean, owner?: { __typename?: 'OwnerOutput', firstName: string, lastName: string, user: { __typename?: 'UserOutput', id: string } } | null, unities: Array<{ __typename?: 'UnityOutput', id: string, name: string, bedSizeOption: BedSizeOption, privateBathroom: boolean, fan: boolean, airConditioner: boolean, currentStatusOption: UnityStatusOption, contracts: Array<{ __typename?: 'ContractOutput', id: string, createdAt: any, finishDate?: any | null, statusOption: ContractStatusOption, rentAmount?: string | null, tenant?: { __typename?: 'TenantOutput', firstName: string, lastName: string, phoneNumber: string, user: { __typename?: 'UserOutput', id: string, email: string } } | null }> }>, address: { __typename?: 'AddressOutput', street: string, buildingNumber: string, addressLine?: string | null, zipCode: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null, country?: { __typename?: 'CountryOutput', iso2: string, name: string } | null }, notes: Array<{ __typename?: 'NoteOutput', id: string, text: string, createdAt: any, ownerFirstName?: string | null, ownerLastName?: string | null }>, insurances: Array<{ __typename?: 'InsuranceOutput', id: string, insuranceCompany: string, insurancePhone: string, policyNumber: string, insuranceHolder?: string | null, holderDocument?: string | null, insuranceBroker?: string | null, insuranceBrokerPhone?: string | null, insuranceBrokerEmail?: string | null, policyPlan?: string | null }>, contacts: Array<{ __typename?: 'ContactOutput', id: string, firstName: string, lastName: string, phoneNumber: string, email: string }>, incidents: Array<{ __typename?: 'IncidentOutput', id: string, subject: string, incidentTypeOption: IncidentTypeOption, incidentCategoryOption: IncidentCategoryOption, priorityOption: PriorityOption, statusOption: IncidentStatusOption, startDate?: any | null, endDate?: any | null, unity?: { __typename?: 'UnityOutput', name: string } | null, supplier?: { __typename?: 'SupplierOutput', firstName: string, lastName: string, user: { __typename?: 'UserOutput', id: string } } | null }>, fileUploads: Array<{ __typename?: 'FileUploadOutput', id: string, urlToDownload?: string | null, fileTypeOption?: FileTypeOption | null }> } | null };

export type GetRedsysConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRedsysConfigurationQuery = { __typename?: 'Query', getRedsysConfiguration: { __typename: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } | { __typename: 'RedsysUserConfigOutput', terminal: string, merchantCode: string } };

export type GetRentChargeDetailQueryVariables = Exact<{
  rentChargeId: Scalars['String']['input'];
}>;


export type GetRentChargeDetailQuery = { __typename?: 'Query', rentCharge: { __typename?: 'RentChargeOutput', id: string, rentChargeTypeOption: RentChargeTypeOption, description: string, amountValue: string, rentChargeStatusOption: RentChargeStatusOption, currencyOption: CurrencyOption, executionDate?: any | null, dueDate?: any | null } };

export type GetRentChargesReportQueryVariables = Exact<{
  filterInput?: InputMaybe<RentChargesReportFilterInput>;
}>;


export type GetRentChargesReportQuery = { __typename?: 'Query', rentChargesReport: { __typename?: 'RentChargesPaginatedOutput', items: Array<{ __typename?: 'RentChargeReportOutput', id: string, rentChargeTypeOption: RentChargeTypeOption, description: string, executionDate?: any | null, dueDate?: any | null, amountValue: string, rentChargeStatusOption: RentChargeStatusOption, currencyOption: CurrencyOption, tenant: { __typename?: 'TenantOutput', firstName: string, lastName: string }, payments: Array<{ __typename?: 'PaymentReportOutput', id: string, createdAt: any, paymentStatusOption: PaymentStatusOption, amountValue: string, providerData?: { __typename: 'DepositPaymentReportOutput', ownerAccountName: string, reference: string } | { __typename: 'RedsysPaymentReportOutput', order: string } | { __typename: 'StripePaymentReportOutput', operationId?: string | null } | null }> }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetStateQueryVariables = Exact<{
  stateCode: Scalars['String']['input'];
}>;


export type GetStateQuery = { __typename?: 'Query', state: { __typename?: 'StateOutput', name: string } };

export type GetAllStatesQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
}>;


export type GetAllStatesQuery = { __typename?: 'Query', states: Array<{ __typename?: 'StateOutput', name: string, geonamesAdmin1Code: string }> };

export type GetSupplierDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSupplierDetailQuery = { __typename?: 'Query', supplier: { __typename?: 'SupplierOutput', firstName: string, lastName: string, phoneNumber: string, phoneNumber2?: string | null, documentId: string, nationality: string, birthDate: any, genderOption: UserGenderTypeOption, user: { __typename?: 'UserOutput', id: string, email: string }, address: { __typename?: 'AddressOutput', street: string, buildingNumber: string, addressLine?: string | null, zipCode: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null, country?: { __typename?: 'CountryOutput', iso2: string, name: string } | null }, bankAccount: { __typename?: 'BankAccountOutput', name: string, holderName: string, accountNumber: string, email: string, phone: string } } };

export type GetSuppliersQueryVariables = Exact<{
  filterInput?: InputMaybe<SupplierFilterInput>;
}>;


export type GetSuppliersQuery = { __typename?: 'Query', suppliers: { __typename?: 'SuppliersPaginatedOutput', items: Array<{ __typename?: 'SupplierOutput', id: string, firstName: string, lastName: string, phoneNumber: string, isActive: boolean, user: { __typename?: 'UserOutput', id: string }, address: { __typename?: 'AddressOutput', street: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null } }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetSuppliersMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuppliersMinimalQuery = { __typename?: 'Query', suppliers: { __typename?: 'SuppliersPaginatedOutput', items: Array<{ __typename?: 'SupplierOutput', firstName: string, lastName: string, isActive: boolean, user: { __typename?: 'UserOutput', id: string } }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetSuppliersSimpleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuppliersSimpleQuery = { __typename?: 'Query', suppliers: { __typename?: 'SuppliersPaginatedOutput', items: Array<{ __typename?: 'SupplierOutput', firstName: string, lastName: string, isActive: boolean, address: { __typename?: 'AddressOutput', city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null }, user: { __typename?: 'UserOutput', id: string } }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetTenantDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTenantDetailQuery = { __typename?: 'Query', tenant: { __typename?: 'TenantOutput', firstName: string, lastName: string, phoneNumber: string, phoneNumber2?: string | null, documentId: string, nationality: string, birthDate: any, genderOption: UserGenderTypeOption, user: { __typename?: 'UserOutput', id: string, email: string }, address: { __typename?: 'AddressOutput', street: string, buildingNumber: string, addressLine?: string | null, zipCode: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null, country?: { __typename?: 'CountryOutput', iso2: string, name: string } | null }, bankAccount?: { __typename?: 'BankAccountOutput', name: string, holderName: string, accountNumber: string, email: string, phone: string } | null } };

export type GetTenantsQueryVariables = Exact<{
  filterInput?: InputMaybe<TenantFilterInput>;
}>;


export type GetTenantsQuery = { __typename?: 'Query', tenants: { __typename?: 'TenantsPaginatedOutput', items: Array<{ __typename?: 'TenantOutput', id: string, firstName: string, lastName: string, phoneNumber: string, address: { __typename?: 'AddressOutput', street: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null } }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetTenantsForContractsQueryVariables = Exact<{
  input?: InputMaybe<TenantFilterInput>;
}>;


export type GetTenantsForContractsQuery = { __typename?: 'Query', tenants: { __typename?: 'TenantsPaginatedOutput', items: Array<{ __typename?: 'TenantOutput', firstName: string, lastName: string, genderOption: UserGenderTypeOption, user: { __typename?: 'UserOutput', id: string, email: string }, address: { __typename?: 'AddressOutput', street: string, city?: { __typename?: 'CityOutput', geonamesId: string, name: string } | null, state?: { __typename?: 'StateOutput', geonamesAdmin1Code: string, name: string } | null } }>, pagination: { __typename?: 'PaginationMetaOutput', totalItems: number, totalPages: number, currentPage: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type UserConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserConfigurationQuery = { __typename?: 'Query', userConfiguration: { __typename?: 'UserConfigurationOutput', id: string, languageOption: UserLanguageOption, preferredCurrencyOption: CurrencyOption } };

export type IsLoggedQueryVariables = Exact<{ [key: string]: never; }>;


export type IsLoggedQuery = { __typename?: 'Query', isLogged: { __typename?: 'ActionResponseMessageOutput', responseType: ResponseType, code: MessageCodeOption, message: string } };

export type TenantQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantQuery = { __typename?: 'Query', tenant: { __typename?: 'TenantOutput', firstName: string, lastName: string } };

export type GetOwnManagerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOwnManagerQuery = { __typename?: 'Query', ownManager: { __typename?: 'ManagerOutput', firstName: string, lastName: string } };

export type OnNewMessageInIncidentSubscriptionVariables = Exact<{
  incidentId: Scalars['String']['input'];
}>;


export type OnNewMessageInIncidentSubscription = { __typename?: 'Subscription', newMessageInIncident: { __typename?: 'MessageOutput', id: string, content: string, messageOwnerOption?: MessageOwnerOption | null, messageStatusOption: MessageStatusOption, senderUserTypeOption?: UserTypeOption | null, receiverUserTypeOption?: UserTypeOption | null, createdAt: any, messageTransactionId?: string | null } };

export type NewNotificationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewNotificationSubscription = { __typename?: 'Subscription', newNotification: { __typename?: 'NotificationOutput', id: string, type: NotificationTypeOption, message: string, read: boolean, createdAt: any, additionalData?: { __typename: 'ContractNotificationData', contractId: string } | { __typename: 'IncidentAssignedNotificationData', incidentId: string, incidentSubject: string, propertyName: string } | { __typename: 'IncidentCreatedNotificationData', incidentId: string, tenantName: string, propertyName: string } | { __typename: 'IncidentFollowUpNotificationData', incidentId: string, incidentSubject: string, propertyName: string, daysSinceCreation: number } | { __typename: 'IncidentReportSubmittedNotificationData', incidentId: string, incidentReportId: string, incidentSubject: string, supplierName: string } | { __typename: 'MessageCreatedNotificationData', messageId: string, senderName: string, incidentId: string } | { __typename: 'PaymentDeadlineNotificationData', ownerUserId: string, rentCharge: { __typename?: 'RentChargeOutput', id: string, amountValue: string, description: string, dueDate?: any | null, executionDate?: any | null, rentChargeStatusOption: RentChargeStatusOption, rentChargeTypeOption: RentChargeTypeOption, currencyOption: CurrencyOption } } | null } };


export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(
    changePasswordInput: {oldPassword: $oldPassword, newPassword: $newPassword}
  ) {
    oldPasswordWrong
    paswordWasUpdated
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const CreateBudgetFromIncidentDocument = gql`
    mutation CreateBudgetFromIncident($incidentId: String!, $subject: String!, $budgetCost: String!, $budgetEarning: String!, $observation: String!, $supplierId: String) {
  createBudgetFromIncident(
    incidentId: $incidentId
    budgetInput: {subject: $subject, budgetCost: $budgetCost, budgetEarning: $budgetEarning, observation: $observation, supplierId: $supplierId}
  ) {
    id
  }
}
    `;
export type CreateBudgetFromIncidentMutationFn = Apollo.MutationFunction<CreateBudgetFromIncidentMutation, CreateBudgetFromIncidentMutationVariables>;

/**
 * __useCreateBudgetFromIncidentMutation__
 *
 * To run a mutation, you first call `useCreateBudgetFromIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBudgetFromIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBudgetFromIncidentMutation, { data, loading, error }] = useCreateBudgetFromIncidentMutation({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *      subject: // value for 'subject'
 *      budgetCost: // value for 'budgetCost'
 *      budgetEarning: // value for 'budgetEarning'
 *      observation: // value for 'observation'
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useCreateBudgetFromIncidentMutation(baseOptions?: Apollo.MutationHookOptions<CreateBudgetFromIncidentMutation, CreateBudgetFromIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBudgetFromIncidentMutation, CreateBudgetFromIncidentMutationVariables>(CreateBudgetFromIncidentDocument, options);
      }
export type CreateBudgetFromIncidentMutationHookResult = ReturnType<typeof useCreateBudgetFromIncidentMutation>;
export type CreateBudgetFromIncidentMutationResult = Apollo.MutationResult<CreateBudgetFromIncidentMutation>;
export type CreateBudgetFromIncidentMutationOptions = Apollo.BaseMutationOptions<CreateBudgetFromIncidentMutation, CreateBudgetFromIncidentMutationVariables>;
export const CreateContactFromPropertyDocument = gql`
    mutation CreateContactFromProperty($propertyId: String!, $contactInput: CreateContactInput!) {
  createContactFromProperty(propertyId: $propertyId, contactInput: $contactInput) {
    firstName
    lastName
  }
}
    `;
export type CreateContactFromPropertyMutationFn = Apollo.MutationFunction<CreateContactFromPropertyMutation, CreateContactFromPropertyMutationVariables>;

/**
 * __useCreateContactFromPropertyMutation__
 *
 * To run a mutation, you first call `useCreateContactFromPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactFromPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactFromPropertyMutation, { data, loading, error }] = useCreateContactFromPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      contactInput: // value for 'contactInput'
 *   },
 * });
 */
export function useCreateContactFromPropertyMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactFromPropertyMutation, CreateContactFromPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactFromPropertyMutation, CreateContactFromPropertyMutationVariables>(CreateContactFromPropertyDocument, options);
      }
export type CreateContactFromPropertyMutationHookResult = ReturnType<typeof useCreateContactFromPropertyMutation>;
export type CreateContactFromPropertyMutationResult = Apollo.MutationResult<CreateContactFromPropertyMutation>;
export type CreateContactFromPropertyMutationOptions = Apollo.BaseMutationOptions<CreateContactFromPropertyMutation, CreateContactFromPropertyMutationVariables>;
export const CreateContractDocument = gql`
    mutation CreateContract($input: CreateContractInput!) {
  createContract(createContractInput: $input) {
    id
  }
}
    `;
export type CreateContractMutationFn = Apollo.MutationFunction<CreateContractMutation, CreateContractMutationVariables>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractMutation, CreateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument, options);
      }
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = Apollo.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = Apollo.BaseMutationOptions<CreateContractMutation, CreateContractMutationVariables>;
export const CreateExpenseDocument = gql`
    mutation CreateExpense($createExpenseInput: CreateExpenseInput!, $originInput: ExpenseOriginInput) {
  createExpense(
    createExpenseInput: $createExpenseInput
    originInput: $originInput
  ) {
    id
    title
  }
}
    `;
export type CreateExpenseMutationFn = Apollo.MutationFunction<CreateExpenseMutation, CreateExpenseMutationVariables>;

/**
 * __useCreateExpenseMutation__
 *
 * To run a mutation, you first call `useCreateExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpenseMutation, { data, loading, error }] = useCreateExpenseMutation({
 *   variables: {
 *      createExpenseInput: // value for 'createExpenseInput'
 *      originInput: // value for 'originInput'
 *   },
 * });
 */
export function useCreateExpenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpenseMutation, CreateExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExpenseMutation, CreateExpenseMutationVariables>(CreateExpenseDocument, options);
      }
export type CreateExpenseMutationHookResult = ReturnType<typeof useCreateExpenseMutation>;
export type CreateExpenseMutationResult = Apollo.MutationResult<CreateExpenseMutation>;
export type CreateExpenseMutationOptions = Apollo.BaseMutationOptions<CreateExpenseMutation, CreateExpenseMutationVariables>;
export const CreateIncidentDocument = gql`
    mutation CreateIncident($input: CreateIncidentInput!) {
  createIncident(createIncidentInput: $input) {
    id
  }
}
    `;
export type CreateIncidentMutationFn = Apollo.MutationFunction<CreateIncidentMutation, CreateIncidentMutationVariables>;

/**
 * __useCreateIncidentMutation__
 *
 * To run a mutation, you first call `useCreateIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentMutation, { data, loading, error }] = useCreateIncidentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIncidentMutation(baseOptions?: Apollo.MutationHookOptions<CreateIncidentMutation, CreateIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIncidentMutation, CreateIncidentMutationVariables>(CreateIncidentDocument, options);
      }
export type CreateIncidentMutationHookResult = ReturnType<typeof useCreateIncidentMutation>;
export type CreateIncidentMutationResult = Apollo.MutationResult<CreateIncidentMutation>;
export type CreateIncidentMutationOptions = Apollo.BaseMutationOptions<CreateIncidentMutation, CreateIncidentMutationVariables>;
export const CreateIncidentExpenseDocument = gql`
    mutation CreateIncidentExpense($incidentExpenseInput: CreateIncidentExpenseInput!, $incidentId: ID!) {
  createIncidentExpense(
    incidentExpenseInput: $incidentExpenseInput
    incidentId: $incidentId
  ) {
    id
  }
}
    `;
export type CreateIncidentExpenseMutationFn = Apollo.MutationFunction<CreateIncidentExpenseMutation, CreateIncidentExpenseMutationVariables>;

/**
 * __useCreateIncidentExpenseMutation__
 *
 * To run a mutation, you first call `useCreateIncidentExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentExpenseMutation, { data, loading, error }] = useCreateIncidentExpenseMutation({
 *   variables: {
 *      incidentExpenseInput: // value for 'incidentExpenseInput'
 *      incidentId: // value for 'incidentId'
 *   },
 * });
 */
export function useCreateIncidentExpenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateIncidentExpenseMutation, CreateIncidentExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIncidentExpenseMutation, CreateIncidentExpenseMutationVariables>(CreateIncidentExpenseDocument, options);
      }
export type CreateIncidentExpenseMutationHookResult = ReturnType<typeof useCreateIncidentExpenseMutation>;
export type CreateIncidentExpenseMutationResult = Apollo.MutationResult<CreateIncidentExpenseMutation>;
export type CreateIncidentExpenseMutationOptions = Apollo.BaseMutationOptions<CreateIncidentExpenseMutation, CreateIncidentExpenseMutationVariables>;
export const CreateIncidentReportFromSupplierDocument = gql`
    mutation createIncidentReportFromSupplier($incidentId: String!, $input: CreateIncidentReportInput!) {
  createIncidentReportFromSupplier(
    incidentId: $incidentId
    incidentReportInput: $input
  ) {
    id
    subject
  }
}
    `;
export type CreateIncidentReportFromSupplierMutationFn = Apollo.MutationFunction<CreateIncidentReportFromSupplierMutation, CreateIncidentReportFromSupplierMutationVariables>;

/**
 * __useCreateIncidentReportFromSupplierMutation__
 *
 * To run a mutation, you first call `useCreateIncidentReportFromSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentReportFromSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentReportFromSupplierMutation, { data, loading, error }] = useCreateIncidentReportFromSupplierMutation({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIncidentReportFromSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateIncidentReportFromSupplierMutation, CreateIncidentReportFromSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIncidentReportFromSupplierMutation, CreateIncidentReportFromSupplierMutationVariables>(CreateIncidentReportFromSupplierDocument, options);
      }
export type CreateIncidentReportFromSupplierMutationHookResult = ReturnType<typeof useCreateIncidentReportFromSupplierMutation>;
export type CreateIncidentReportFromSupplierMutationResult = Apollo.MutationResult<CreateIncidentReportFromSupplierMutation>;
export type CreateIncidentReportFromSupplierMutationOptions = Apollo.BaseMutationOptions<CreateIncidentReportFromSupplierMutation, CreateIncidentReportFromSupplierMutationVariables>;
export const CreateInsuranceFromPropertyDocument = gql`
    mutation CreateInsuranceFromProperty($propertyId: String!, $insuranceInput: CreateInsuranceInput!) {
  createInsuranceFromProperty(
    propertyId: $propertyId
    insuranceInput: $insuranceInput
  ) {
    policyNumber
  }
}
    `;
export type CreateInsuranceFromPropertyMutationFn = Apollo.MutationFunction<CreateInsuranceFromPropertyMutation, CreateInsuranceFromPropertyMutationVariables>;

/**
 * __useCreateInsuranceFromPropertyMutation__
 *
 * To run a mutation, you first call `useCreateInsuranceFromPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsuranceFromPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsuranceFromPropertyMutation, { data, loading, error }] = useCreateInsuranceFromPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      insuranceInput: // value for 'insuranceInput'
 *   },
 * });
 */
export function useCreateInsuranceFromPropertyMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsuranceFromPropertyMutation, CreateInsuranceFromPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsuranceFromPropertyMutation, CreateInsuranceFromPropertyMutationVariables>(CreateInsuranceFromPropertyDocument, options);
      }
export type CreateInsuranceFromPropertyMutationHookResult = ReturnType<typeof useCreateInsuranceFromPropertyMutation>;
export type CreateInsuranceFromPropertyMutationResult = Apollo.MutationResult<CreateInsuranceFromPropertyMutation>;
export type CreateInsuranceFromPropertyMutationOptions = Apollo.BaseMutationOptions<CreateInsuranceFromPropertyMutation, CreateInsuranceFromPropertyMutationVariables>;
export const CreateInventoryDocument = gql`
    mutation CreateInventory($propertyId: String!, $input: CreateInventoryInput!) {
  createInventory(propertyId: $propertyId, createInventoryInput: $input) {
    id
    description
    items {
      id
      description
      quantity
    }
  }
}
    `;
export type CreateInventoryMutationFn = Apollo.MutationFunction<CreateInventoryMutation, CreateInventoryMutationVariables>;

/**
 * __useCreateInventoryMutation__
 *
 * To run a mutation, you first call `useCreateInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInventoryMutation, { data, loading, error }] = useCreateInventoryMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInventoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateInventoryMutation, CreateInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInventoryMutation, CreateInventoryMutationVariables>(CreateInventoryDocument, options);
      }
export type CreateInventoryMutationHookResult = ReturnType<typeof useCreateInventoryMutation>;
export type CreateInventoryMutationResult = Apollo.MutationResult<CreateInventoryMutation>;
export type CreateInventoryMutationOptions = Apollo.BaseMutationOptions<CreateInventoryMutation, CreateInventoryMutationVariables>;
export const CreateInventoryItemDocument = gql`
    mutation CreateInventoryItem($inventoryId: String!, $propertyId: String!, $input: CreateInventoryItemInput!) {
  createInventoryItem(
    inventoryId: $inventoryId
    propertyId: $propertyId
    createInventoryItemInput: $input
  ) {
    id
    description
    quantity
  }
}
    `;
export type CreateInventoryItemMutationFn = Apollo.MutationFunction<CreateInventoryItemMutation, CreateInventoryItemMutationVariables>;

/**
 * __useCreateInventoryItemMutation__
 *
 * To run a mutation, you first call `useCreateInventoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInventoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInventoryItemMutation, { data, loading, error }] = useCreateInventoryItemMutation({
 *   variables: {
 *      inventoryId: // value for 'inventoryId'
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInventoryItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateInventoryItemMutation, CreateInventoryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInventoryItemMutation, CreateInventoryItemMutationVariables>(CreateInventoryItemDocument, options);
      }
export type CreateInventoryItemMutationHookResult = ReturnType<typeof useCreateInventoryItemMutation>;
export type CreateInventoryItemMutationResult = Apollo.MutationResult<CreateInventoryItemMutation>;
export type CreateInventoryItemMutationOptions = Apollo.BaseMutationOptions<CreateInventoryItemMutation, CreateInventoryItemMutationVariables>;
export const CreateMassiveCommunicationTemplateDocument = gql`
    mutation CreateMassiveCommunicationTemplate($input: CreateMassiveCommunicationTemplateInput!) {
  createMassiveCommunicationTemplate(input: $input) {
    id
    title
    content
  }
}
    `;
export type CreateMassiveCommunicationTemplateMutationFn = Apollo.MutationFunction<CreateMassiveCommunicationTemplateMutation, CreateMassiveCommunicationTemplateMutationVariables>;

/**
 * __useCreateMassiveCommunicationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMassiveCommunicationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMassiveCommunicationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMassiveCommunicationTemplateMutation, { data, loading, error }] = useCreateMassiveCommunicationTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMassiveCommunicationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMassiveCommunicationTemplateMutation, CreateMassiveCommunicationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMassiveCommunicationTemplateMutation, CreateMassiveCommunicationTemplateMutationVariables>(CreateMassiveCommunicationTemplateDocument, options);
      }
export type CreateMassiveCommunicationTemplateMutationHookResult = ReturnType<typeof useCreateMassiveCommunicationTemplateMutation>;
export type CreateMassiveCommunicationTemplateMutationResult = Apollo.MutationResult<CreateMassiveCommunicationTemplateMutation>;
export type CreateMassiveCommunicationTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMassiveCommunicationTemplateMutation, CreateMassiveCommunicationTemplateMutationVariables>;
export const CreateNewMessageFromIncidentDocument = gql`
    mutation CreateNewMessageFromIncident($incidentId: String!, $input: CreateMessageFromIncidentInput!) {
  createMessageFromIncident(incidentId: $incidentId, input: $input) {
    ... on ActionResponseMessageOutput {
      responseType
      code
      message
    }
    ... on CreateMessageOutput {
      messageSent
    }
  }
}
    `;
export type CreateNewMessageFromIncidentMutationFn = Apollo.MutationFunction<CreateNewMessageFromIncidentMutation, CreateNewMessageFromIncidentMutationVariables>;

/**
 * __useCreateNewMessageFromIncidentMutation__
 *
 * To run a mutation, you first call `useCreateNewMessageFromIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewMessageFromIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewMessageFromIncidentMutation, { data, loading, error }] = useCreateNewMessageFromIncidentMutation({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewMessageFromIncidentMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewMessageFromIncidentMutation, CreateNewMessageFromIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewMessageFromIncidentMutation, CreateNewMessageFromIncidentMutationVariables>(CreateNewMessageFromIncidentDocument, options);
      }
export type CreateNewMessageFromIncidentMutationHookResult = ReturnType<typeof useCreateNewMessageFromIncidentMutation>;
export type CreateNewMessageFromIncidentMutationResult = Apollo.MutationResult<CreateNewMessageFromIncidentMutation>;
export type CreateNewMessageFromIncidentMutationOptions = Apollo.BaseMutationOptions<CreateNewMessageFromIncidentMutation, CreateNewMessageFromIncidentMutationVariables>;
export const CreateNoteFromContractDocument = gql`
    mutation CreateNoteFromContract($contractId: String!, $description: String!) {
  createNoteFromContract(
    contractId: $contractId
    noteInput: {description: $description}
  ) {
    id
  }
}
    `;
export type CreateNoteFromContractMutationFn = Apollo.MutationFunction<CreateNoteFromContractMutation, CreateNoteFromContractMutationVariables>;

/**
 * __useCreateNoteFromContractMutation__
 *
 * To run a mutation, you first call `useCreateNoteFromContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteFromContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteFromContractMutation, { data, loading, error }] = useCreateNoteFromContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateNoteFromContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteFromContractMutation, CreateNoteFromContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteFromContractMutation, CreateNoteFromContractMutationVariables>(CreateNoteFromContractDocument, options);
      }
export type CreateNoteFromContractMutationHookResult = ReturnType<typeof useCreateNoteFromContractMutation>;
export type CreateNoteFromContractMutationResult = Apollo.MutationResult<CreateNoteFromContractMutation>;
export type CreateNoteFromContractMutationOptions = Apollo.BaseMutationOptions<CreateNoteFromContractMutation, CreateNoteFromContractMutationVariables>;
export const CreateNoteFromIncidentDocument = gql`
    mutation CreateNoteFromIncident($incidentId: String!, $description: String!) {
  createNoteFromIncident(
    incidentId: $incidentId
    noteInput: {description: $description}
  ) {
    id
  }
}
    `;
export type CreateNoteFromIncidentMutationFn = Apollo.MutationFunction<CreateNoteFromIncidentMutation, CreateNoteFromIncidentMutationVariables>;

/**
 * __useCreateNoteFromIncidentMutation__
 *
 * To run a mutation, you first call `useCreateNoteFromIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteFromIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteFromIncidentMutation, { data, loading, error }] = useCreateNoteFromIncidentMutation({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateNoteFromIncidentMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteFromIncidentMutation, CreateNoteFromIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteFromIncidentMutation, CreateNoteFromIncidentMutationVariables>(CreateNoteFromIncidentDocument, options);
      }
export type CreateNoteFromIncidentMutationHookResult = ReturnType<typeof useCreateNoteFromIncidentMutation>;
export type CreateNoteFromIncidentMutationResult = Apollo.MutationResult<CreateNoteFromIncidentMutation>;
export type CreateNoteFromIncidentMutationOptions = Apollo.BaseMutationOptions<CreateNoteFromIncidentMutation, CreateNoteFromIncidentMutationVariables>;
export const CreateNoteFromPropertyDocument = gql`
    mutation CreateNoteFromProperty($propertyId: String!, $description: String!) {
  createNoteFromProperty(
    propertyId: $propertyId
    noteInput: {description: $description}
  ) {
    id
  }
}
    `;
export type CreateNoteFromPropertyMutationFn = Apollo.MutationFunction<CreateNoteFromPropertyMutation, CreateNoteFromPropertyMutationVariables>;

/**
 * __useCreateNoteFromPropertyMutation__
 *
 * To run a mutation, you first call `useCreateNoteFromPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteFromPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteFromPropertyMutation, { data, loading, error }] = useCreateNoteFromPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateNoteFromPropertyMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteFromPropertyMutation, CreateNoteFromPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteFromPropertyMutation, CreateNoteFromPropertyMutationVariables>(CreateNoteFromPropertyDocument, options);
      }
export type CreateNoteFromPropertyMutationHookResult = ReturnType<typeof useCreateNoteFromPropertyMutation>;
export type CreateNoteFromPropertyMutationResult = Apollo.MutationResult<CreateNoteFromPropertyMutation>;
export type CreateNoteFromPropertyMutationOptions = Apollo.BaseMutationOptions<CreateNoteFromPropertyMutation, CreateNoteFromPropertyMutationVariables>;
export const CreateOwnerDocument = gql`
    mutation CreateOwner($firstName: String!, $lastName: String!, $phoneNumber: String!, $phoneNumber2: String, $email: String!, $documentId: String!, $nationality: String!, $genderOption: UserGenderTypeOption!, $birthDate: DateTime!, $street: String!, $buildingNumber: String!, $addressLine: String, $city: String!, $state: String!, $country: String!, $zipCode: String!, $bankAccountName: String, $bankAccountNumber: String, $bankAccountEmail: String, $bankAccountPhone: String, $bankAccountHolder: String) {
  createOwner(
    createOwnerInput: {firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, phoneNumber2: $phoneNumber2, email: $email, documentId: $documentId, nationality: $nationality, genderOption: $genderOption, birthDate: $birthDate, street: $street, buildingNumber: $buildingNumber, addressLine: $addressLine, cityId: $city, stateId: $state, countryId: $country, zipCode: $zipCode, bankAccountName: $bankAccountName, bankAccountNumber: $bankAccountNumber, bankAccountEmail: $bankAccountEmail, bankAccountPhone: $bankAccountPhone, bankAccountHolder: $bankAccountHolder}
  ) {
    ... on ActionResponseMessageOutput {
      responseType
      code
      message
    }
    ... on OwnerOutput {
      firstName
      lastName
    }
  }
}
    `;
export type CreateOwnerMutationFn = Apollo.MutationFunction<CreateOwnerMutation, CreateOwnerMutationVariables>;

/**
 * __useCreateOwnerMutation__
 *
 * To run a mutation, you first call `useCreateOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOwnerMutation, { data, loading, error }] = useCreateOwnerMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneNumber2: // value for 'phoneNumber2'
 *      email: // value for 'email'
 *      documentId: // value for 'documentId'
 *      nationality: // value for 'nationality'
 *      genderOption: // value for 'genderOption'
 *      birthDate: // value for 'birthDate'
 *      street: // value for 'street'
 *      buildingNumber: // value for 'buildingNumber'
 *      addressLine: // value for 'addressLine'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      zipCode: // value for 'zipCode'
 *      bankAccountName: // value for 'bankAccountName'
 *      bankAccountNumber: // value for 'bankAccountNumber'
 *      bankAccountEmail: // value for 'bankAccountEmail'
 *      bankAccountPhone: // value for 'bankAccountPhone'
 *      bankAccountHolder: // value for 'bankAccountHolder'
 *   },
 * });
 */
export function useCreateOwnerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOwnerMutation, CreateOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOwnerMutation, CreateOwnerMutationVariables>(CreateOwnerDocument, options);
      }
export type CreateOwnerMutationHookResult = ReturnType<typeof useCreateOwnerMutation>;
export type CreateOwnerMutationResult = Apollo.MutationResult<CreateOwnerMutation>;
export type CreateOwnerMutationOptions = Apollo.BaseMutationOptions<CreateOwnerMutation, CreateOwnerMutationVariables>;
export const CreateOwnerContractDocument = gql`
    mutation CreateOwnerContract($input: CreateOwnerContractInput!) {
  createOwnerContract(input: $input) {
    id
  }
}
    `;
export type CreateOwnerContractMutationFn = Apollo.MutationFunction<CreateOwnerContractMutation, CreateOwnerContractMutationVariables>;

/**
 * __useCreateOwnerContractMutation__
 *
 * To run a mutation, you first call `useCreateOwnerContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOwnerContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOwnerContractMutation, { data, loading, error }] = useCreateOwnerContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOwnerContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateOwnerContractMutation, CreateOwnerContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOwnerContractMutation, CreateOwnerContractMutationVariables>(CreateOwnerContractDocument, options);
      }
export type CreateOwnerContractMutationHookResult = ReturnType<typeof useCreateOwnerContractMutation>;
export type CreateOwnerContractMutationResult = Apollo.MutationResult<CreateOwnerContractMutation>;
export type CreateOwnerContractMutationOptions = Apollo.BaseMutationOptions<CreateOwnerContractMutation, CreateOwnerContractMutationVariables>;
export const CreatePropertyDocument = gql`
    mutation CreateProperty($input: CreatePropertyInput!) {
  createProperty(createPropertyInput: $input) {
    name
  }
}
    `;
export type CreatePropertyMutationFn = Apollo.MutationFunction<CreatePropertyMutation, CreatePropertyMutationVariables>;

/**
 * __useCreatePropertyMutation__
 *
 * To run a mutation, you first call `useCreatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPropertyMutation, { data, loading, error }] = useCreatePropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePropertyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePropertyMutation, CreatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePropertyMutation, CreatePropertyMutationVariables>(CreatePropertyDocument, options);
      }
export type CreatePropertyMutationHookResult = ReturnType<typeof useCreatePropertyMutation>;
export type CreatePropertyMutationResult = Apollo.MutationResult<CreatePropertyMutation>;
export type CreatePropertyMutationOptions = Apollo.BaseMutationOptions<CreatePropertyMutation, CreatePropertyMutationVariables>;
export const CreateRentChargeFromContractDocument = gql`
    mutation CreateRentChargeFromContract($contractId: String!, $amountValue: String!, $description: String!, $rentChargeTypeOption: RentChargeTypeOption!, $executionDate: DateTime!) {
  createRentChargeFromContract(
    contractId: $contractId
    createRentChargeInput: {amountValue: $amountValue, description: $description, rentChargeType: $rentChargeTypeOption, executionDate: $executionDate}
  ) {
    rentChargeTypeOption
  }
}
    `;
export type CreateRentChargeFromContractMutationFn = Apollo.MutationFunction<CreateRentChargeFromContractMutation, CreateRentChargeFromContractMutationVariables>;

/**
 * __useCreateRentChargeFromContractMutation__
 *
 * To run a mutation, you first call `useCreateRentChargeFromContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRentChargeFromContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRentChargeFromContractMutation, { data, loading, error }] = useCreateRentChargeFromContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      amountValue: // value for 'amountValue'
 *      description: // value for 'description'
 *      rentChargeTypeOption: // value for 'rentChargeTypeOption'
 *      executionDate: // value for 'executionDate'
 *   },
 * });
 */
export function useCreateRentChargeFromContractMutation(baseOptions?: Apollo.MutationHookOptions<CreateRentChargeFromContractMutation, CreateRentChargeFromContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRentChargeFromContractMutation, CreateRentChargeFromContractMutationVariables>(CreateRentChargeFromContractDocument, options);
      }
export type CreateRentChargeFromContractMutationHookResult = ReturnType<typeof useCreateRentChargeFromContractMutation>;
export type CreateRentChargeFromContractMutationResult = Apollo.MutationResult<CreateRentChargeFromContractMutation>;
export type CreateRentChargeFromContractMutationOptions = Apollo.BaseMutationOptions<CreateRentChargeFromContractMutation, CreateRentChargeFromContractMutationVariables>;
export const CreateSupplierDocument = gql`
    mutation CreateSupplier($firstName: String!, $lastName: String!, $phoneNumber: String!, $phoneNumber2: String, $email: String!, $documentId: String!, $nationality: String!, $genderOption: UserGenderTypeOption!, $birthDate: DateTime!, $street: String!, $buildingNumber: String!, $addressLine: String, $city: String!, $state: String!, $country: String!, $zipCode: String!, $bankAccountName: String, $bankAccountNumber: String, $bankAccountEmail: String, $bankAccountPhone: String, $bankAccountHolder: String) {
  createSupplier(
    createSupplierInput: {firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, phoneNumber2: $phoneNumber2, email: $email, documentId: $documentId, nationality: $nationality, genderOption: $genderOption, birthDate: $birthDate, street: $street, buildingNumber: $buildingNumber, addressLine: $addressLine, cityId: $city, stateId: $state, countryId: $country, zipCode: $zipCode, bankAccountName: $bankAccountName, bankAccountNumber: $bankAccountNumber, bankAccountEmail: $bankAccountEmail, bankAccountPhone: $bankAccountPhone, bankAccountHolder: $bankAccountHolder}
  ) {
    ... on ActionResponseMessageOutput {
      responseType
      code
      message
    }
    ... on SupplierOutput {
      firstName
      lastName
    }
  }
}
    `;
export type CreateSupplierMutationFn = Apollo.MutationFunction<CreateSupplierMutation, CreateSupplierMutationVariables>;

/**
 * __useCreateSupplierMutation__
 *
 * To run a mutation, you first call `useCreateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierMutation, { data, loading, error }] = useCreateSupplierMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneNumber2: // value for 'phoneNumber2'
 *      email: // value for 'email'
 *      documentId: // value for 'documentId'
 *      nationality: // value for 'nationality'
 *      genderOption: // value for 'genderOption'
 *      birthDate: // value for 'birthDate'
 *      street: // value for 'street'
 *      buildingNumber: // value for 'buildingNumber'
 *      addressLine: // value for 'addressLine'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      zipCode: // value for 'zipCode'
 *      bankAccountName: // value for 'bankAccountName'
 *      bankAccountNumber: // value for 'bankAccountNumber'
 *      bankAccountEmail: // value for 'bankAccountEmail'
 *      bankAccountPhone: // value for 'bankAccountPhone'
 *      bankAccountHolder: // value for 'bankAccountHolder'
 *   },
 * });
 */
export function useCreateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierMutation, CreateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplierMutation, CreateSupplierMutationVariables>(CreateSupplierDocument, options);
      }
export type CreateSupplierMutationHookResult = ReturnType<typeof useCreateSupplierMutation>;
export type CreateSupplierMutationResult = Apollo.MutationResult<CreateSupplierMutation>;
export type CreateSupplierMutationOptions = Apollo.BaseMutationOptions<CreateSupplierMutation, CreateSupplierMutationVariables>;
export const CreateTenantDocument = gql`
    mutation CreateTenant($firstName: String!, $lastName: String!, $phoneNumber: String!, $phoneNumber2: String, $email: String!, $documentId: String!, $nationality: String!, $genderOption: UserGenderTypeOption!, $birthDate: DateTime!, $street: String!, $buildingNumber: String!, $addressLine: String, $city: String!, $state: String!, $country: String!, $zipCode: String!, $bankAccountName: String, $bankAccountHolder: String, $bankAccountNumber: String, $bankAccountEmail: String, $bankAccountPhone: String) {
  createTenant(
    createTenantInput: {firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, phoneNumber2: $phoneNumber2, email: $email, documentId: $documentId, nationality: $nationality, genderOption: $genderOption, birthDate: $birthDate, street: $street, buildingNumber: $buildingNumber, addressLine: $addressLine, cityId: $city, stateId: $state, countryId: $country, zipCode: $zipCode, bankAccountName: $bankAccountName, bankAccountHolder: $bankAccountHolder, bankAccountNumber: $bankAccountNumber, bankAccountEmail: $bankAccountEmail, bankAccountPhone: $bankAccountPhone}
  ) {
    ... on ActionResponseMessageOutput {
      responseType
      code
      message
    }
    ... on TenantOutput {
      firstName
      lastName
    }
  }
}
    `;
export type CreateTenantMutationFn = Apollo.MutationFunction<CreateTenantMutation, CreateTenantMutationVariables>;

/**
 * __useCreateTenantMutation__
 *
 * To run a mutation, you first call `useCreateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantMutation, { data, loading, error }] = useCreateTenantMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneNumber2: // value for 'phoneNumber2'
 *      email: // value for 'email'
 *      documentId: // value for 'documentId'
 *      nationality: // value for 'nationality'
 *      genderOption: // value for 'genderOption'
 *      birthDate: // value for 'birthDate'
 *      street: // value for 'street'
 *      buildingNumber: // value for 'buildingNumber'
 *      addressLine: // value for 'addressLine'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      zipCode: // value for 'zipCode'
 *      bankAccountName: // value for 'bankAccountName'
 *      bankAccountHolder: // value for 'bankAccountHolder'
 *      bankAccountNumber: // value for 'bankAccountNumber'
 *      bankAccountEmail: // value for 'bankAccountEmail'
 *      bankAccountPhone: // value for 'bankAccountPhone'
 *   },
 * });
 */
export function useCreateTenantMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantMutation, CreateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantMutation, CreateTenantMutationVariables>(CreateTenantDocument, options);
      }
export type CreateTenantMutationHookResult = ReturnType<typeof useCreateTenantMutation>;
export type CreateTenantMutationResult = Apollo.MutationResult<CreateTenantMutation>;
export type CreateTenantMutationOptions = Apollo.BaseMutationOptions<CreateTenantMutation, CreateTenantMutationVariables>;
export const CreateUnityFromPropertyDocument = gql`
    mutation CreateUnityFromProperty($propertyId: String!, $unityInput: CreateUnityInput!) {
  createUnityFromProperty(propertyId: $propertyId, createUnityInput: $unityInput) {
    name
  }
}
    `;
export type CreateUnityFromPropertyMutationFn = Apollo.MutationFunction<CreateUnityFromPropertyMutation, CreateUnityFromPropertyMutationVariables>;

/**
 * __useCreateUnityFromPropertyMutation__
 *
 * To run a mutation, you first call `useCreateUnityFromPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnityFromPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnityFromPropertyMutation, { data, loading, error }] = useCreateUnityFromPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      unityInput: // value for 'unityInput'
 *   },
 * });
 */
export function useCreateUnityFromPropertyMutation(baseOptions?: Apollo.MutationHookOptions<CreateUnityFromPropertyMutation, CreateUnityFromPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUnityFromPropertyMutation, CreateUnityFromPropertyMutationVariables>(CreateUnityFromPropertyDocument, options);
      }
export type CreateUnityFromPropertyMutationHookResult = ReturnType<typeof useCreateUnityFromPropertyMutation>;
export type CreateUnityFromPropertyMutationResult = Apollo.MutationResult<CreateUnityFromPropertyMutation>;
export type CreateUnityFromPropertyMutationOptions = Apollo.BaseMutationOptions<CreateUnityFromPropertyMutation, CreateUnityFromPropertyMutationVariables>;
export const DeleteOwnerDocument = gql`
    mutation DeleteOwner($id: String!) {
  deleteOwner(id: $id) {
    firstName
    lastName
  }
}
    `;
export type DeleteOwnerMutationFn = Apollo.MutationFunction<DeleteOwnerMutation, DeleteOwnerMutationVariables>;

/**
 * __useDeleteOwnerMutation__
 *
 * To run a mutation, you first call `useDeleteOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOwnerMutation, { data, loading, error }] = useDeleteOwnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOwnerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOwnerMutation, DeleteOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOwnerMutation, DeleteOwnerMutationVariables>(DeleteOwnerDocument, options);
      }
export type DeleteOwnerMutationHookResult = ReturnType<typeof useDeleteOwnerMutation>;
export type DeleteOwnerMutationResult = Apollo.MutationResult<DeleteOwnerMutation>;
export type DeleteOwnerMutationOptions = Apollo.BaseMutationOptions<DeleteOwnerMutation, DeleteOwnerMutationVariables>;
export const DeletePropertyDocument = gql`
    mutation DeleteProperty($id: String!) {
  deleteProperty(id: $id) {
    name
  }
}
    `;
export type DeletePropertyMutationFn = Apollo.MutationFunction<DeletePropertyMutation, DeletePropertyMutationVariables>;

/**
 * __useDeletePropertyMutation__
 *
 * To run a mutation, you first call `useDeletePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePropertyMutation, { data, loading, error }] = useDeletePropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePropertyMutation(baseOptions?: Apollo.MutationHookOptions<DeletePropertyMutation, DeletePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePropertyMutation, DeletePropertyMutationVariables>(DeletePropertyDocument, options);
      }
export type DeletePropertyMutationHookResult = ReturnType<typeof useDeletePropertyMutation>;
export type DeletePropertyMutationResult = Apollo.MutationResult<DeletePropertyMutation>;
export type DeletePropertyMutationOptions = Apollo.BaseMutationOptions<DeletePropertyMutation, DeletePropertyMutationVariables>;
export const DeleteRentChargeFromQueryDocument = gql`
    mutation DeleteRentChargeFromQuery($contractId: String!, $rentChargeId: String!) {
  deleteRentChargeFromContract(
    contractId: $contractId
    rentChargeId: $rentChargeId
  ) {
    id
    description
  }
}
    `;
export type DeleteRentChargeFromQueryMutationFn = Apollo.MutationFunction<DeleteRentChargeFromQueryMutation, DeleteRentChargeFromQueryMutationVariables>;

/**
 * __useDeleteRentChargeFromQueryMutation__
 *
 * To run a mutation, you first call `useDeleteRentChargeFromQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRentChargeFromQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRentChargeFromQueryMutation, { data, loading, error }] = useDeleteRentChargeFromQueryMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      rentChargeId: // value for 'rentChargeId'
 *   },
 * });
 */
export function useDeleteRentChargeFromQueryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRentChargeFromQueryMutation, DeleteRentChargeFromQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRentChargeFromQueryMutation, DeleteRentChargeFromQueryMutationVariables>(DeleteRentChargeFromQueryDocument, options);
      }
export type DeleteRentChargeFromQueryMutationHookResult = ReturnType<typeof useDeleteRentChargeFromQueryMutation>;
export type DeleteRentChargeFromQueryMutationResult = Apollo.MutationResult<DeleteRentChargeFromQueryMutation>;
export type DeleteRentChargeFromQueryMutationOptions = Apollo.BaseMutationOptions<DeleteRentChargeFromQueryMutation, DeleteRentChargeFromQueryMutationVariables>;
export const DeleteSupplierDocument = gql`
    mutation DeleteSupplier($id: String!) {
  deleteSupplier(id: $id) {
    firstName
    lastName
  }
}
    `;
export type DeleteSupplierMutationFn = Apollo.MutationFunction<DeleteSupplierMutation, DeleteSupplierMutationVariables>;

/**
 * __useDeleteSupplierMutation__
 *
 * To run a mutation, you first call `useDeleteSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupplierMutation, { data, loading, error }] = useDeleteSupplierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSupplierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSupplierMutation, DeleteSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSupplierMutation, DeleteSupplierMutationVariables>(DeleteSupplierDocument, options);
      }
export type DeleteSupplierMutationHookResult = ReturnType<typeof useDeleteSupplierMutation>;
export type DeleteSupplierMutationResult = Apollo.MutationResult<DeleteSupplierMutation>;
export type DeleteSupplierMutationOptions = Apollo.BaseMutationOptions<DeleteSupplierMutation, DeleteSupplierMutationVariables>;
export const DeleteTenantDocument = gql`
    mutation DeleteTenant($id: String!) {
  deleteTenant(id: $id) {
    firstName
    lastName
  }
}
    `;
export type DeleteTenantMutationFn = Apollo.MutationFunction<DeleteTenantMutation, DeleteTenantMutationVariables>;

/**
 * __useDeleteTenantMutation__
 *
 * To run a mutation, you first call `useDeleteTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenantMutation, { data, loading, error }] = useDeleteTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTenantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenantMutation, DeleteTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenantMutation, DeleteTenantMutationVariables>(DeleteTenantDocument, options);
      }
export type DeleteTenantMutationHookResult = ReturnType<typeof useDeleteTenantMutation>;
export type DeleteTenantMutationResult = Apollo.MutationResult<DeleteTenantMutation>;
export type DeleteTenantMutationOptions = Apollo.BaseMutationOptions<DeleteTenantMutation, DeleteTenantMutationVariables>;
export const DeleteUnityFromPropertyDocument = gql`
    mutation DeleteUnityFromProperty($propertyId: String!, $unityId: String!) {
  deleteUnityFromProperty(propertyId: $propertyId, unityId: $unityId) {
    name
  }
}
    `;
export type DeleteUnityFromPropertyMutationFn = Apollo.MutationFunction<DeleteUnityFromPropertyMutation, DeleteUnityFromPropertyMutationVariables>;

/**
 * __useDeleteUnityFromPropertyMutation__
 *
 * To run a mutation, you first call `useDeleteUnityFromPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnityFromPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnityFromPropertyMutation, { data, loading, error }] = useDeleteUnityFromPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      unityId: // value for 'unityId'
 *   },
 * });
 */
export function useDeleteUnityFromPropertyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnityFromPropertyMutation, DeleteUnityFromPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnityFromPropertyMutation, DeleteUnityFromPropertyMutationVariables>(DeleteUnityFromPropertyDocument, options);
      }
export type DeleteUnityFromPropertyMutationHookResult = ReturnType<typeof useDeleteUnityFromPropertyMutation>;
export type DeleteUnityFromPropertyMutationResult = Apollo.MutationResult<DeleteUnityFromPropertyMutation>;
export type DeleteUnityFromPropertyMutationOptions = Apollo.BaseMutationOptions<DeleteUnityFromPropertyMutation, DeleteUnityFromPropertyMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!) {
  forgotPassword(forgotPasswordInput: {email: $email}) {
    responseType
    code
    message
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const GenerateClientFinderKeyDocument = gql`
    mutation GenerateClientFinderKey {
  generateNewClientFinderSecretKey {
    key
  }
}
    `;
export type GenerateClientFinderKeyMutationFn = Apollo.MutationFunction<GenerateClientFinderKeyMutation, GenerateClientFinderKeyMutationVariables>;

/**
 * __useGenerateClientFinderKeyMutation__
 *
 * To run a mutation, you first call `useGenerateClientFinderKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateClientFinderKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateClientFinderKeyMutation, { data, loading, error }] = useGenerateClientFinderKeyMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateClientFinderKeyMutation(baseOptions?: Apollo.MutationHookOptions<GenerateClientFinderKeyMutation, GenerateClientFinderKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateClientFinderKeyMutation, GenerateClientFinderKeyMutationVariables>(GenerateClientFinderKeyDocument, options);
      }
export type GenerateClientFinderKeyMutationHookResult = ReturnType<typeof useGenerateClientFinderKeyMutation>;
export type GenerateClientFinderKeyMutationResult = Apollo.MutationResult<GenerateClientFinderKeyMutation>;
export type GenerateClientFinderKeyMutationOptions = Apollo.BaseMutationOptions<GenerateClientFinderKeyMutation, GenerateClientFinderKeyMutationVariables>;
export const GetUploadUrlDocument = gql`
    mutation GetUploadUrl($input: GenerateFileUploadInput!) {
  getUploadUrl(input: $input) {
    uploadUrl
    id
    fileName
    fileStatusOption
    urlToDownload
  }
}
    `;
export type GetUploadUrlMutationFn = Apollo.MutationFunction<GetUploadUrlMutation, GetUploadUrlMutationVariables>;

/**
 * __useGetUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getUploadUrlMutation, { data, loading, error }] = useGetUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetUploadUrlMutation, GetUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetUploadUrlMutation, GetUploadUrlMutationVariables>(GetUploadUrlDocument, options);
      }
export type GetUploadUrlMutationHookResult = ReturnType<typeof useGetUploadUrlMutation>;
export type GetUploadUrlMutationResult = Apollo.MutationResult<GetUploadUrlMutation>;
export type GetUploadUrlMutationOptions = Apollo.BaseMutationOptions<GetUploadUrlMutation, GetUploadUrlMutationVariables>;
export const GetFileUploadUrlsDocument = gql`
    mutation GetFileUploadUrls($inputs: [GenerateFileUploadInput!]!) {
  getUploadUrls(inputs: $inputs) {
    uploadUrl
    id
    fileName
    fileStatusOption
    urlToDownload
  }
}
    `;
export type GetFileUploadUrlsMutationFn = Apollo.MutationFunction<GetFileUploadUrlsMutation, GetFileUploadUrlsMutationVariables>;

/**
 * __useGetFileUploadUrlsMutation__
 *
 * To run a mutation, you first call `useGetFileUploadUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetFileUploadUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getFileUploadUrlsMutation, { data, loading, error }] = useGetFileUploadUrlsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useGetFileUploadUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GetFileUploadUrlsMutation, GetFileUploadUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetFileUploadUrlsMutation, GetFileUploadUrlsMutationVariables>(GetFileUploadUrlsDocument, options);
      }
export type GetFileUploadUrlsMutationHookResult = ReturnType<typeof useGetFileUploadUrlsMutation>;
export type GetFileUploadUrlsMutationResult = Apollo.MutationResult<GetFileUploadUrlsMutation>;
export type GetFileUploadUrlsMutationOptions = Apollo.BaseMutationOptions<GetFileUploadUrlsMutation, GetFileUploadUrlsMutationVariables>;
export const CreateInventoryInspectionDocument = gql`
    mutation CreateInventoryInspection($propertyId: ID!, $input: CreateInventoryInspectionInput!) {
  createInventoryInspection(propertyId: $propertyId, input: $input) {
    id
    type
    inspectionDate
    inspectorName
    receiverName
    generalNotes
    sections {
      id
      key
      title
      order
      isSystem
      items {
        id
        title
        quantity
        status
        notes
        order
        files {
          id
          url
        }
      }
    }
  }
}
    `;
export type CreateInventoryInspectionMutationFn = Apollo.MutationFunction<CreateInventoryInspectionMutation, CreateInventoryInspectionMutationVariables>;

/**
 * __useCreateInventoryInspectionMutation__
 *
 * To run a mutation, you first call `useCreateInventoryInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInventoryInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInventoryInspectionMutation, { data, loading, error }] = useCreateInventoryInspectionMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInventoryInspectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateInventoryInspectionMutation, CreateInventoryInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInventoryInspectionMutation, CreateInventoryInspectionMutationVariables>(CreateInventoryInspectionDocument, options);
      }
export type CreateInventoryInspectionMutationHookResult = ReturnType<typeof useCreateInventoryInspectionMutation>;
export type CreateInventoryInspectionMutationResult = Apollo.MutationResult<CreateInventoryInspectionMutation>;
export type CreateInventoryInspectionMutationOptions = Apollo.BaseMutationOptions<CreateInventoryInspectionMutation, CreateInventoryInspectionMutationVariables>;
export const GenerateInventoryInspectionPdfDocument = gql`
    mutation GenerateInventoryInspectionPdf($propertyId: ID!, $inspectionId: ID!) {
  generateInventoryInspectionPdf(
    propertyId: $propertyId
    inspectionId: $inspectionId
  ) {
    url
    fileName
    contentType
  }
}
    `;
export type GenerateInventoryInspectionPdfMutationFn = Apollo.MutationFunction<GenerateInventoryInspectionPdfMutation, GenerateInventoryInspectionPdfMutationVariables>;

/**
 * __useGenerateInventoryInspectionPdfMutation__
 *
 * To run a mutation, you first call `useGenerateInventoryInspectionPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInventoryInspectionPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInventoryInspectionPdfMutation, { data, loading, error }] = useGenerateInventoryInspectionPdfMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      inspectionId: // value for 'inspectionId'
 *   },
 * });
 */
export function useGenerateInventoryInspectionPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateInventoryInspectionPdfMutation, GenerateInventoryInspectionPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateInventoryInspectionPdfMutation, GenerateInventoryInspectionPdfMutationVariables>(GenerateInventoryInspectionPdfDocument, options);
      }
export type GenerateInventoryInspectionPdfMutationHookResult = ReturnType<typeof useGenerateInventoryInspectionPdfMutation>;
export type GenerateInventoryInspectionPdfMutationResult = Apollo.MutationResult<GenerateInventoryInspectionPdfMutation>;
export type GenerateInventoryInspectionPdfMutationOptions = Apollo.BaseMutationOptions<GenerateInventoryInspectionPdfMutation, GenerateInventoryInspectionPdfMutationVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!, $clientType: ClientAppTypeOption!) {
  login(loginInput: {email: $email, password: $password, clientType: $clientType}) {
    __typename
    ... on LoginResponse {
      token
      username
      userType
    }
    ... on ActionResponseMessageOutput {
      responseType
      code
      message
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      clientType: // value for 'clientType'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($id: ID!) {
  markNotificationAsRead(id: $id) {
    id
    type
    message
    read
    createdAt
  }
}
    `;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($otpCode: Int!, $newPassword: String!) {
  resetPassword(
    resetPasswordInput: {otpCode: $otpCode, newPassword: $newPassword}
  ) {
    responseType
    code
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      otpCode: // value for 'otpCode'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SaveRedsysConfigurationDocument = gql`
    mutation SaveRedsysConfiguration($data: RedsysUserConfigInput!) {
  saveRedsysConfiguration(data: $data) {
    terminal
    merchantCode
  }
}
    `;
export type SaveRedsysConfigurationMutationFn = Apollo.MutationFunction<SaveRedsysConfigurationMutation, SaveRedsysConfigurationMutationVariables>;

/**
 * __useSaveRedsysConfigurationMutation__
 *
 * To run a mutation, you first call `useSaveRedsysConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRedsysConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRedsysConfigurationMutation, { data, loading, error }] = useSaveRedsysConfigurationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveRedsysConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SaveRedsysConfigurationMutation, SaveRedsysConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRedsysConfigurationMutation, SaveRedsysConfigurationMutationVariables>(SaveRedsysConfigurationDocument, options);
      }
export type SaveRedsysConfigurationMutationHookResult = ReturnType<typeof useSaveRedsysConfigurationMutation>;
export type SaveRedsysConfigurationMutationResult = Apollo.MutationResult<SaveRedsysConfigurationMutation>;
export type SaveRedsysConfigurationMutationOptions = Apollo.BaseMutationOptions<SaveRedsysConfigurationMutation, SaveRedsysConfigurationMutationVariables>;
export const SendMassiveCommunicationDocument = gql`
    mutation SendMassiveCommunication($input: CreateMassiveCommunicationInput!) {
  sendMassiveCommunication(input: $input) {
    id
    title
    content
    createdAt
  }
}
    `;
export type SendMassiveCommunicationMutationFn = Apollo.MutationFunction<SendMassiveCommunicationMutation, SendMassiveCommunicationMutationVariables>;

/**
 * __useSendMassiveCommunicationMutation__
 *
 * To run a mutation, you first call `useSendMassiveCommunicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMassiveCommunicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMassiveCommunicationMutation, { data, loading, error }] = useSendMassiveCommunicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMassiveCommunicationMutation(baseOptions?: Apollo.MutationHookOptions<SendMassiveCommunicationMutation, SendMassiveCommunicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMassiveCommunicationMutation, SendMassiveCommunicationMutationVariables>(SendMassiveCommunicationDocument, options);
      }
export type SendMassiveCommunicationMutationHookResult = ReturnType<typeof useSendMassiveCommunicationMutation>;
export type SendMassiveCommunicationMutationResult = Apollo.MutationResult<SendMassiveCommunicationMutation>;
export type SendMassiveCommunicationMutationOptions = Apollo.BaseMutationOptions<SendMassiveCommunicationMutation, SendMassiveCommunicationMutationVariables>;
export const SetSupplierToIncidentDocument = gql`
    mutation SetSupplierToIncident($incidentId: String!, $input: SetSuppliertToIncidentInput!) {
  setSupplierToIncident(incidentId: $incidentId, incidentInput: $input) {
    id
  }
}
    `;
export type SetSupplierToIncidentMutationFn = Apollo.MutationFunction<SetSupplierToIncidentMutation, SetSupplierToIncidentMutationVariables>;

/**
 * __useSetSupplierToIncidentMutation__
 *
 * To run a mutation, you first call `useSetSupplierToIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSupplierToIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSupplierToIncidentMutation, { data, loading, error }] = useSetSupplierToIncidentMutation({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSupplierToIncidentMutation(baseOptions?: Apollo.MutationHookOptions<SetSupplierToIncidentMutation, SetSupplierToIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSupplierToIncidentMutation, SetSupplierToIncidentMutationVariables>(SetSupplierToIncidentDocument, options);
      }
export type SetSupplierToIncidentMutationHookResult = ReturnType<typeof useSetSupplierToIncidentMutation>;
export type SetSupplierToIncidentMutationResult = Apollo.MutationResult<SetSupplierToIncidentMutation>;
export type SetSupplierToIncidentMutationOptions = Apollo.BaseMutationOptions<SetSupplierToIncidentMutation, SetSupplierToIncidentMutationVariables>;
export const SignupNewUserDocument = gql`
    mutation SignupNewUser($firstName: String!, $lastName: String!, $email: String!, $phoneNumber: String!, $password: String!, $userLanguageOption: UserLanguageOption!, $preferredCurrency: CurrencyOption!) {
  signup(
    signupDataInput: {firstName: $firstName, lastName: $lastName, email: $email, phoneNumber: $phoneNumber, password: $password, userLanguageOption: $userLanguageOption, preferredCurrency: $preferredCurrency}
  ) {
    responseType
    code
    message
  }
}
    `;
export type SignupNewUserMutationFn = Apollo.MutationFunction<SignupNewUserMutation, SignupNewUserMutationVariables>;

/**
 * __useSignupNewUserMutation__
 *
 * To run a mutation, you first call `useSignupNewUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupNewUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupNewUserMutation, { data, loading, error }] = useSignupNewUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      password: // value for 'password'
 *      userLanguageOption: // value for 'userLanguageOption'
 *      preferredCurrency: // value for 'preferredCurrency'
 *   },
 * });
 */
export function useSignupNewUserMutation(baseOptions?: Apollo.MutationHookOptions<SignupNewUserMutation, SignupNewUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupNewUserMutation, SignupNewUserMutationVariables>(SignupNewUserDocument, options);
      }
export type SignupNewUserMutationHookResult = ReturnType<typeof useSignupNewUserMutation>;
export type SignupNewUserMutationResult = Apollo.MutationResult<SignupNewUserMutation>;
export type SignupNewUserMutationOptions = Apollo.BaseMutationOptions<SignupNewUserMutation, SignupNewUserMutationVariables>;
export const UpdateContactFromPropertyDocument = gql`
    mutation UpdateContactFromProperty($propertyId: String!, $contactId: String!, $contactInput: UpdateContactInput!) {
  updateContactFromProperty(
    propertyId: $propertyId
    contactId: $contactId
    contactInput: $contactInput
  ) {
    firstName
    lastName
  }
}
    `;
export type UpdateContactFromPropertyMutationFn = Apollo.MutationFunction<UpdateContactFromPropertyMutation, UpdateContactFromPropertyMutationVariables>;

/**
 * __useUpdateContactFromPropertyMutation__
 *
 * To run a mutation, you first call `useUpdateContactFromPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactFromPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactFromPropertyMutation, { data, loading, error }] = useUpdateContactFromPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      contactId: // value for 'contactId'
 *      contactInput: // value for 'contactInput'
 *   },
 * });
 */
export function useUpdateContactFromPropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactFromPropertyMutation, UpdateContactFromPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactFromPropertyMutation, UpdateContactFromPropertyMutationVariables>(UpdateContactFromPropertyDocument, options);
      }
export type UpdateContactFromPropertyMutationHookResult = ReturnType<typeof useUpdateContactFromPropertyMutation>;
export type UpdateContactFromPropertyMutationResult = Apollo.MutationResult<UpdateContactFromPropertyMutation>;
export type UpdateContactFromPropertyMutationOptions = Apollo.BaseMutationOptions<UpdateContactFromPropertyMutation, UpdateContactFromPropertyMutationVariables>;
export const UpdateContractDocument = gql`
    mutation UpdateContract($contractId: String!, $input: UpdateContractInput!) {
  updateContract(id: $contractId, updateContractInput: $input) {
    id
  }
}
    `;
export type UpdateContractMutationFn = Apollo.MutationFunction<UpdateContractMutation, UpdateContractMutationVariables>;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractMutation, { data, loading, error }] = useUpdateContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractMutation, UpdateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractMutation, UpdateContractMutationVariables>(UpdateContractDocument, options);
      }
export type UpdateContractMutationHookResult = ReturnType<typeof useUpdateContractMutation>;
export type UpdateContractMutationResult = Apollo.MutationResult<UpdateContractMutation>;
export type UpdateContractMutationOptions = Apollo.BaseMutationOptions<UpdateContractMutation, UpdateContractMutationVariables>;
export const UpdateDepositDocument = gql`
    mutation UpdateDeposit($id: String!, $input: UpdateDepositInput!) {
  updateDeposit(id: $id, input: $input) {
    id
    amount
    reference
  }
}
    `;
export type UpdateDepositMutationFn = Apollo.MutationFunction<UpdateDepositMutation, UpdateDepositMutationVariables>;

/**
 * __useUpdateDepositMutation__
 *
 * To run a mutation, you first call `useUpdateDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepositMutation, { data, loading, error }] = useUpdateDepositMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDepositMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepositMutation, UpdateDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepositMutation, UpdateDepositMutationVariables>(UpdateDepositDocument, options);
      }
export type UpdateDepositMutationHookResult = ReturnType<typeof useUpdateDepositMutation>;
export type UpdateDepositMutationResult = Apollo.MutationResult<UpdateDepositMutation>;
export type UpdateDepositMutationOptions = Apollo.BaseMutationOptions<UpdateDepositMutation, UpdateDepositMutationVariables>;
export const UpdateExpenseStatusDocument = gql`
    mutation UpdateExpenseStatus($updateExpenseStatusInput: UpdateExpenseStatusInput!) {
  updateExpenseStatus(updateExpenseStatusInput: $updateExpenseStatusInput) {
    id
    chargeStatus
  }
}
    `;
export type UpdateExpenseStatusMutationFn = Apollo.MutationFunction<UpdateExpenseStatusMutation, UpdateExpenseStatusMutationVariables>;

/**
 * __useUpdateExpenseStatusMutation__
 *
 * To run a mutation, you first call `useUpdateExpenseStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpenseStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpenseStatusMutation, { data, loading, error }] = useUpdateExpenseStatusMutation({
 *   variables: {
 *      updateExpenseStatusInput: // value for 'updateExpenseStatusInput'
 *   },
 * });
 */
export function useUpdateExpenseStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpenseStatusMutation, UpdateExpenseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpenseStatusMutation, UpdateExpenseStatusMutationVariables>(UpdateExpenseStatusDocument, options);
      }
export type UpdateExpenseStatusMutationHookResult = ReturnType<typeof useUpdateExpenseStatusMutation>;
export type UpdateExpenseStatusMutationResult = Apollo.MutationResult<UpdateExpenseStatusMutation>;
export type UpdateExpenseStatusMutationOptions = Apollo.BaseMutationOptions<UpdateExpenseStatusMutation, UpdateExpenseStatusMutationVariables>;
export const UpdateIncidentDocument = gql`
    mutation UpdateIncident($incidentId: String!, $statusOption: IncidentStatusOption, $endDate: DateTime, $priorityOption: PriorityOption, $tenantPaymentResponsability: String, $ownerPaymentResponsability: String, $managerPaymentResponsability: String, $supplierPaymentResponsability: String, $uploadedFilesIds: [String!]) {
  updateIncident(
    id: $incidentId
    updateIncidentInput: {statusOption: $statusOption, endDate: $endDate, priorityOption: $priorityOption, managerPaymentResponsability: $managerPaymentResponsability, tenantPaymentResponsability: $tenantPaymentResponsability, ownerPaymentResponsability: $ownerPaymentResponsability, supplierPaymentResponsability: $supplierPaymentResponsability, uploadedFilesIds: $uploadedFilesIds}
  ) {
    id
  }
}
    `;
export type UpdateIncidentMutationFn = Apollo.MutationFunction<UpdateIncidentMutation, UpdateIncidentMutationVariables>;

/**
 * __useUpdateIncidentMutation__
 *
 * To run a mutation, you first call `useUpdateIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncidentMutation, { data, loading, error }] = useUpdateIncidentMutation({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *      statusOption: // value for 'statusOption'
 *      endDate: // value for 'endDate'
 *      priorityOption: // value for 'priorityOption'
 *      tenantPaymentResponsability: // value for 'tenantPaymentResponsability'
 *      ownerPaymentResponsability: // value for 'ownerPaymentResponsability'
 *      managerPaymentResponsability: // value for 'managerPaymentResponsability'
 *      supplierPaymentResponsability: // value for 'supplierPaymentResponsability'
 *      uploadedFilesIds: // value for 'uploadedFilesIds'
 *   },
 * });
 */
export function useUpdateIncidentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIncidentMutation, UpdateIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIncidentMutation, UpdateIncidentMutationVariables>(UpdateIncidentDocument, options);
      }
export type UpdateIncidentMutationHookResult = ReturnType<typeof useUpdateIncidentMutation>;
export type UpdateIncidentMutationResult = Apollo.MutationResult<UpdateIncidentMutation>;
export type UpdateIncidentMutationOptions = Apollo.BaseMutationOptions<UpdateIncidentMutation, UpdateIncidentMutationVariables>;
export const UpdateIncidentReportDocument = gql`
    mutation UpdateIncidentReport($incidentReportId: String!, $input: UpdateIncidentReportInput!) {
  updateIncidentReport(id: $incidentReportId, input: $input) {
    id
    notes {
      id
      text
      createdAt
    }
  }
}
    `;
export type UpdateIncidentReportMutationFn = Apollo.MutationFunction<UpdateIncidentReportMutation, UpdateIncidentReportMutationVariables>;

/**
 * __useUpdateIncidentReportMutation__
 *
 * To run a mutation, you first call `useUpdateIncidentReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncidentReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncidentReportMutation, { data, loading, error }] = useUpdateIncidentReportMutation({
 *   variables: {
 *      incidentReportId: // value for 'incidentReportId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIncidentReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIncidentReportMutation, UpdateIncidentReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIncidentReportMutation, UpdateIncidentReportMutationVariables>(UpdateIncidentReportDocument, options);
      }
export type UpdateIncidentReportMutationHookResult = ReturnType<typeof useUpdateIncidentReportMutation>;
export type UpdateIncidentReportMutationResult = Apollo.MutationResult<UpdateIncidentReportMutation>;
export type UpdateIncidentReportMutationOptions = Apollo.BaseMutationOptions<UpdateIncidentReportMutation, UpdateIncidentReportMutationVariables>;
export const UpdateInsuranceFromPropertyDocument = gql`
    mutation UpdateInsuranceFromProperty($propertyId: String!, $insuranceId: String!, $insuranceInput: UpdateInsuranceInput!) {
  updateInsuranceFromProperty(
    propertyId: $propertyId
    insuranceId: $insuranceId
    insuranceInput: $insuranceInput
  ) {
    policyNumber
  }
}
    `;
export type UpdateInsuranceFromPropertyMutationFn = Apollo.MutationFunction<UpdateInsuranceFromPropertyMutation, UpdateInsuranceFromPropertyMutationVariables>;

/**
 * __useUpdateInsuranceFromPropertyMutation__
 *
 * To run a mutation, you first call `useUpdateInsuranceFromPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsuranceFromPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsuranceFromPropertyMutation, { data, loading, error }] = useUpdateInsuranceFromPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      insuranceId: // value for 'insuranceId'
 *      insuranceInput: // value for 'insuranceInput'
 *   },
 * });
 */
export function useUpdateInsuranceFromPropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsuranceFromPropertyMutation, UpdateInsuranceFromPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsuranceFromPropertyMutation, UpdateInsuranceFromPropertyMutationVariables>(UpdateInsuranceFromPropertyDocument, options);
      }
export type UpdateInsuranceFromPropertyMutationHookResult = ReturnType<typeof useUpdateInsuranceFromPropertyMutation>;
export type UpdateInsuranceFromPropertyMutationResult = Apollo.MutationResult<UpdateInsuranceFromPropertyMutation>;
export type UpdateInsuranceFromPropertyMutationOptions = Apollo.BaseMutationOptions<UpdateInsuranceFromPropertyMutation, UpdateInsuranceFromPropertyMutationVariables>;
export const UpdateInventoryDocument = gql`
    mutation UpdateInventory($id: String!, $propertyId: String!, $input: UpdateInventoryInput!) {
  updateInventory(id: $id, propertyId: $propertyId, updateInventoryInput: $input) {
    id
    description
    items {
      id
      description
      quantity
    }
  }
}
    `;
export type UpdateInventoryMutationFn = Apollo.MutationFunction<UpdateInventoryMutation, UpdateInventoryMutationVariables>;

/**
 * __useUpdateInventoryMutation__
 *
 * To run a mutation, you first call `useUpdateInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInventoryMutation, { data, loading, error }] = useUpdateInventoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInventoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInventoryMutation, UpdateInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInventoryMutation, UpdateInventoryMutationVariables>(UpdateInventoryDocument, options);
      }
export type UpdateInventoryMutationHookResult = ReturnType<typeof useUpdateInventoryMutation>;
export type UpdateInventoryMutationResult = Apollo.MutationResult<UpdateInventoryMutation>;
export type UpdateInventoryMutationOptions = Apollo.BaseMutationOptions<UpdateInventoryMutation, UpdateInventoryMutationVariables>;
export const UpdateInventoryInspectionDocument = gql`
    mutation UpdateInventoryInspection($id: ID!, $propertyId: ID!, $input: UpdateInventoryInspectionInput!) {
  updateInventoryInspection(id: $id, propertyId: $propertyId, input: $input) {
    id
  }
}
    `;
export type UpdateInventoryInspectionMutationFn = Apollo.MutationFunction<UpdateInventoryInspectionMutation, UpdateInventoryInspectionMutationVariables>;

/**
 * __useUpdateInventoryInspectionMutation__
 *
 * To run a mutation, you first call `useUpdateInventoryInspectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInventoryInspectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInventoryInspectionMutation, { data, loading, error }] = useUpdateInventoryInspectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInventoryInspectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInventoryInspectionMutation, UpdateInventoryInspectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInventoryInspectionMutation, UpdateInventoryInspectionMutationVariables>(UpdateInventoryInspectionDocument, options);
      }
export type UpdateInventoryInspectionMutationHookResult = ReturnType<typeof useUpdateInventoryInspectionMutation>;
export type UpdateInventoryInspectionMutationResult = Apollo.MutationResult<UpdateInventoryInspectionMutation>;
export type UpdateInventoryInspectionMutationOptions = Apollo.BaseMutationOptions<UpdateInventoryInspectionMutation, UpdateInventoryInspectionMutationVariables>;
export const UpdateInventoryItemDocument = gql`
    mutation UpdateInventoryItem($id: String!, $inventoryId: String!, $propertyId: String!, $input: UpdateInventoryItemInput!) {
  updateInventoryItem(
    id: $id
    inventoryId: $inventoryId
    propertyId: $propertyId
    updateInventoryItemInput: $input
  ) {
    id
    description
    quantity
  }
}
    `;
export type UpdateInventoryItemMutationFn = Apollo.MutationFunction<UpdateInventoryItemMutation, UpdateInventoryItemMutationVariables>;

/**
 * __useUpdateInventoryItemMutation__
 *
 * To run a mutation, you first call `useUpdateInventoryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInventoryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInventoryItemMutation, { data, loading, error }] = useUpdateInventoryItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      inventoryId: // value for 'inventoryId'
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInventoryItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInventoryItemMutation, UpdateInventoryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInventoryItemMutation, UpdateInventoryItemMutationVariables>(UpdateInventoryItemDocument, options);
      }
export type UpdateInventoryItemMutationHookResult = ReturnType<typeof useUpdateInventoryItemMutation>;
export type UpdateInventoryItemMutationResult = Apollo.MutationResult<UpdateInventoryItemMutation>;
export type UpdateInventoryItemMutationOptions = Apollo.BaseMutationOptions<UpdateInventoryItemMutation, UpdateInventoryItemMutationVariables>;
export const UpdateMangerDocument = gql`
    mutation UpdateManger($firstName: String, $lastName: String, $email: String, $phoneNumber: String) {
  updateManager(
    updateManagerInput: {firstName: $firstName, lastName: $lastName, email: $email, phoneNumber: $phoneNumber}
  ) {
    firstName
    lastName
  }
}
    `;
export type UpdateMangerMutationFn = Apollo.MutationFunction<UpdateMangerMutation, UpdateMangerMutationVariables>;

/**
 * __useUpdateMangerMutation__
 *
 * To run a mutation, you first call `useUpdateMangerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMangerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMangerMutation, { data, loading, error }] = useUpdateMangerMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateMangerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMangerMutation, UpdateMangerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMangerMutation, UpdateMangerMutationVariables>(UpdateMangerDocument, options);
      }
export type UpdateMangerMutationHookResult = ReturnType<typeof useUpdateMangerMutation>;
export type UpdateMangerMutationResult = Apollo.MutationResult<UpdateMangerMutation>;
export type UpdateMangerMutationOptions = Apollo.BaseMutationOptions<UpdateMangerMutation, UpdateMangerMutationVariables>;
export const UpdateOwnerDocument = gql`
    mutation UpdateOwner($id: String, $firstName: String, $lastName: String, $phoneNumber: String, $phoneNumber2: String, $email: String, $documentId: String, $nationality: String, $genderOption: UserGenderTypeOption, $birthDate: DateTime, $street: String, $buildingNumber: String, $addressLine: String, $city: String, $state: String, $country: String, $zipCode: String, $bankAccountName: String, $bankAccountNumber: String, $bankAccountEmail: String, $bankAccountPhone: String, $bankAccountHolder: String) {
  updateOwner(
    id: $id
    updateOwnerInput: {firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, phoneNumber2: $phoneNumber2, email: $email, documentId: $documentId, nationality: $nationality, genderOption: $genderOption, birthDate: $birthDate, street: $street, buildingNumber: $buildingNumber, addressLine: $addressLine, cityId: $city, stateId: $state, countryId: $country, zipCode: $zipCode, bankAccountName: $bankAccountName, bankAccountNumber: $bankAccountNumber, bankAccountEmail: $bankAccountEmail, bankAccountPhone: $bankAccountPhone, bankAccountHolder: $bankAccountHolder}
  ) {
    firstName
    lastName
  }
}
    `;
export type UpdateOwnerMutationFn = Apollo.MutationFunction<UpdateOwnerMutation, UpdateOwnerMutationVariables>;

/**
 * __useUpdateOwnerMutation__
 *
 * To run a mutation, you first call `useUpdateOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOwnerMutation, { data, loading, error }] = useUpdateOwnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneNumber2: // value for 'phoneNumber2'
 *      email: // value for 'email'
 *      documentId: // value for 'documentId'
 *      nationality: // value for 'nationality'
 *      genderOption: // value for 'genderOption'
 *      birthDate: // value for 'birthDate'
 *      street: // value for 'street'
 *      buildingNumber: // value for 'buildingNumber'
 *      addressLine: // value for 'addressLine'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      zipCode: // value for 'zipCode'
 *      bankAccountName: // value for 'bankAccountName'
 *      bankAccountNumber: // value for 'bankAccountNumber'
 *      bankAccountEmail: // value for 'bankAccountEmail'
 *      bankAccountPhone: // value for 'bankAccountPhone'
 *      bankAccountHolder: // value for 'bankAccountHolder'
 *   },
 * });
 */
export function useUpdateOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOwnerMutation, UpdateOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOwnerMutation, UpdateOwnerMutationVariables>(UpdateOwnerDocument, options);
      }
export type UpdateOwnerMutationHookResult = ReturnType<typeof useUpdateOwnerMutation>;
export type UpdateOwnerMutationResult = Apollo.MutationResult<UpdateOwnerMutation>;
export type UpdateOwnerMutationOptions = Apollo.BaseMutationOptions<UpdateOwnerMutation, UpdateOwnerMutationVariables>;
export const UpdatePropertyDocument = gql`
    mutation UpdateProperty($propertyId: String!, $input: UpdatePropertyInput!) {
  updateProperty(id: $propertyId, updatePropertyInput: $input) {
    name
  }
}
    `;
export type UpdatePropertyMutationFn = Apollo.MutationFunction<UpdatePropertyMutation, UpdatePropertyMutationVariables>;

/**
 * __useUpdatePropertyMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyMutation, { data, loading, error }] = useUpdatePropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyMutation, UpdatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyMutation, UpdatePropertyMutationVariables>(UpdatePropertyDocument, options);
      }
export type UpdatePropertyMutationHookResult = ReturnType<typeof useUpdatePropertyMutation>;
export type UpdatePropertyMutationResult = Apollo.MutationResult<UpdatePropertyMutation>;
export type UpdatePropertyMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyMutation, UpdatePropertyMutationVariables>;
export const UpdateRentChargeFromContractDocument = gql`
    mutation UpdateRentChargeFromContract($contractId: String!, $rentChargeId: String!, $amountValue: String, $description: String, $rentChargeTypeOption: RentChargeTypeOption, $executionDate: DateTime) {
  updateRentChargeFromContract(
    contractId: $contractId
    rentChargeId: $rentChargeId
    updateRentChargeInput: {amountValue: $amountValue, description: $description, rentChargeType: $rentChargeTypeOption, executionDate: $executionDate}
  ) {
    rentChargeTypeOption
  }
}
    `;
export type UpdateRentChargeFromContractMutationFn = Apollo.MutationFunction<UpdateRentChargeFromContractMutation, UpdateRentChargeFromContractMutationVariables>;

/**
 * __useUpdateRentChargeFromContractMutation__
 *
 * To run a mutation, you first call `useUpdateRentChargeFromContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRentChargeFromContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRentChargeFromContractMutation, { data, loading, error }] = useUpdateRentChargeFromContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      rentChargeId: // value for 'rentChargeId'
 *      amountValue: // value for 'amountValue'
 *      description: // value for 'description'
 *      rentChargeTypeOption: // value for 'rentChargeTypeOption'
 *      executionDate: // value for 'executionDate'
 *   },
 * });
 */
export function useUpdateRentChargeFromContractMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRentChargeFromContractMutation, UpdateRentChargeFromContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRentChargeFromContractMutation, UpdateRentChargeFromContractMutationVariables>(UpdateRentChargeFromContractDocument, options);
      }
export type UpdateRentChargeFromContractMutationHookResult = ReturnType<typeof useUpdateRentChargeFromContractMutation>;
export type UpdateRentChargeFromContractMutationResult = Apollo.MutationResult<UpdateRentChargeFromContractMutation>;
export type UpdateRentChargeFromContractMutationOptions = Apollo.BaseMutationOptions<UpdateRentChargeFromContractMutation, UpdateRentChargeFromContractMutationVariables>;
export const UpdateRentChargeStatusDocument = gql`
    mutation UpdateRentChargeStatus($rentChargeId: String!, $statusOption: RentChargeStatusOption!) {
  updateRentCharge(
    id: $rentChargeId
    updateRentChargeInput: {rentChargeStatus: $statusOption}
  ) {
    id
    rentChargeStatusOption
  }
}
    `;
export type UpdateRentChargeStatusMutationFn = Apollo.MutationFunction<UpdateRentChargeStatusMutation, UpdateRentChargeStatusMutationVariables>;

/**
 * __useUpdateRentChargeStatusMutation__
 *
 * To run a mutation, you first call `useUpdateRentChargeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRentChargeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRentChargeStatusMutation, { data, loading, error }] = useUpdateRentChargeStatusMutation({
 *   variables: {
 *      rentChargeId: // value for 'rentChargeId'
 *      statusOption: // value for 'statusOption'
 *   },
 * });
 */
export function useUpdateRentChargeStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRentChargeStatusMutation, UpdateRentChargeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRentChargeStatusMutation, UpdateRentChargeStatusMutationVariables>(UpdateRentChargeStatusDocument, options);
      }
export type UpdateRentChargeStatusMutationHookResult = ReturnType<typeof useUpdateRentChargeStatusMutation>;
export type UpdateRentChargeStatusMutationResult = Apollo.MutationResult<UpdateRentChargeStatusMutation>;
export type UpdateRentChargeStatusMutationOptions = Apollo.BaseMutationOptions<UpdateRentChargeStatusMutation, UpdateRentChargeStatusMutationVariables>;
export const UpdateSupplierDocument = gql`
    mutation UpdateSupplier($id: String, $firstName: String, $lastName: String, $phoneNumber: String, $phoneNumber2: String, $email: String, $documentId: String, $nationality: String, $isActive: Boolean, $genderOption: UserGenderTypeOption, $birthDate: DateTime, $street: String, $buildingNumber: String, $addressLine: String, $city: String, $state: String, $country: String, $zipCode: String, $bankAccountName: String, $bankAccountNumber: String, $bankAccountEmail: String, $bankAccountPhone: String, $bankAccountHolder: String) {
  updateSupplier(
    id: $id
    updateSupplierInput: {firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, phoneNumber2: $phoneNumber2, email: $email, documentId: $documentId, nationality: $nationality, isActive: $isActive, genderOption: $genderOption, birthDate: $birthDate, street: $street, buildingNumber: $buildingNumber, addressLine: $addressLine, cityId: $city, stateId: $state, countryId: $country, zipCode: $zipCode, bankAccountName: $bankAccountName, bankAccountNumber: $bankAccountNumber, bankAccountEmail: $bankAccountEmail, bankAccountPhone: $bankAccountPhone, bankAccountHolder: $bankAccountHolder}
  ) {
    firstName
    lastName
  }
}
    `;
export type UpdateSupplierMutationFn = Apollo.MutationFunction<UpdateSupplierMutation, UpdateSupplierMutationVariables>;

/**
 * __useUpdateSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierMutation, { data, loading, error }] = useUpdateSupplierMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneNumber2: // value for 'phoneNumber2'
 *      email: // value for 'email'
 *      documentId: // value for 'documentId'
 *      nationality: // value for 'nationality'
 *      isActive: // value for 'isActive'
 *      genderOption: // value for 'genderOption'
 *      birthDate: // value for 'birthDate'
 *      street: // value for 'street'
 *      buildingNumber: // value for 'buildingNumber'
 *      addressLine: // value for 'addressLine'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      zipCode: // value for 'zipCode'
 *      bankAccountName: // value for 'bankAccountName'
 *      bankAccountNumber: // value for 'bankAccountNumber'
 *      bankAccountEmail: // value for 'bankAccountEmail'
 *      bankAccountPhone: // value for 'bankAccountPhone'
 *      bankAccountHolder: // value for 'bankAccountHolder'
 *   },
 * });
 */
export function useUpdateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplierMutation, UpdateSupplierMutationVariables>(UpdateSupplierDocument, options);
      }
export type UpdateSupplierMutationHookResult = ReturnType<typeof useUpdateSupplierMutation>;
export type UpdateSupplierMutationResult = Apollo.MutationResult<UpdateSupplierMutation>;
export type UpdateSupplierMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>;
export const UpdateTenantDocument = gql`
    mutation UpdateTenant($id: String, $firstName: String, $lastName: String, $phoneNumber: String, $phoneNumber2: String, $email: String, $documentId: String, $nationality: String, $genderOption: UserGenderTypeOption, $birthDate: DateTime, $street: String, $buildingNumber: String, $addressLine: String, $city: String, $state: String, $country: String, $zipCode: String, $bankAccountName: String, $bankAccountHolder: String, $bankAccountNumber: String, $bankAccountEmail: String, $bankAccountPhone: String) {
  updateTenant(
    id: $id
    updateTenantInput: {firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, phoneNumber2: $phoneNumber2, email: $email, documentId: $documentId, nationality: $nationality, genderOption: $genderOption, birthDate: $birthDate, street: $street, buildingNumber: $buildingNumber, addressLine: $addressLine, cityId: $city, stateId: $state, countryId: $country, zipCode: $zipCode, bankAccountName: $bankAccountName, bankAccountHolder: $bankAccountHolder, bankAccountNumber: $bankAccountNumber, bankAccountEmail: $bankAccountEmail, bankAccountPhone: $bankAccountPhone}
  ) {
    firstName
    lastName
  }
}
    `;
export type UpdateTenantMutationFn = Apollo.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>;

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneNumber2: // value for 'phoneNumber2'
 *      email: // value for 'email'
 *      documentId: // value for 'documentId'
 *      nationality: // value for 'nationality'
 *      genderOption: // value for 'genderOption'
 *      birthDate: // value for 'birthDate'
 *      street: // value for 'street'
 *      buildingNumber: // value for 'buildingNumber'
 *      addressLine: // value for 'addressLine'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      zipCode: // value for 'zipCode'
 *      bankAccountName: // value for 'bankAccountName'
 *      bankAccountHolder: // value for 'bankAccountHolder'
 *      bankAccountNumber: // value for 'bankAccountNumber'
 *      bankAccountEmail: // value for 'bankAccountEmail'
 *      bankAccountPhone: // value for 'bankAccountPhone'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, options);
      }
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>;
export type UpdateTenantMutationResult = Apollo.MutationResult<UpdateTenantMutation>;
export type UpdateTenantMutationOptions = Apollo.BaseMutationOptions<UpdateTenantMutation, UpdateTenantMutationVariables>;
export const UpdateUnityFromPropertyDocument = gql`
    mutation UpdateUnityFromProperty($propertyId: String!, $unityId: String!, $unityInput: UpdateUnityInput!) {
  updateUnityFromProperty(
    propertyId: $propertyId
    unityId: $unityId
    updateUnityInput: $unityInput
  ) {
    name
  }
}
    `;
export type UpdateUnityFromPropertyMutationFn = Apollo.MutationFunction<UpdateUnityFromPropertyMutation, UpdateUnityFromPropertyMutationVariables>;

/**
 * __useUpdateUnityFromPropertyMutation__
 *
 * To run a mutation, you first call `useUpdateUnityFromPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnityFromPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnityFromPropertyMutation, { data, loading, error }] = useUpdateUnityFromPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      unityId: // value for 'unityId'
 *      unityInput: // value for 'unityInput'
 *   },
 * });
 */
export function useUpdateUnityFromPropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUnityFromPropertyMutation, UpdateUnityFromPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUnityFromPropertyMutation, UpdateUnityFromPropertyMutationVariables>(UpdateUnityFromPropertyDocument, options);
      }
export type UpdateUnityFromPropertyMutationHookResult = ReturnType<typeof useUpdateUnityFromPropertyMutation>;
export type UpdateUnityFromPropertyMutationResult = Apollo.MutationResult<UpdateUnityFromPropertyMutation>;
export type UpdateUnityFromPropertyMutationOptions = Apollo.BaseMutationOptions<UpdateUnityFromPropertyMutation, UpdateUnityFromPropertyMutationVariables>;
export const UpsertInventoryInspectionItemDocument = gql`
    mutation UpsertInventoryInspectionItem($sectionId: ID!, $propertyId: ID!, $input: UpsertInventoryInspectionItemInput!) {
  upsertInventoryInspectionItem(
    sectionId: $sectionId
    propertyId: $propertyId
    input: $input
  ) {
    id
    sections {
      id
      items {
        id
        title
        quantity
        notes
        order
        status
        files {
          id
          url
        }
      }
    }
  }
}
    `;
export type UpsertInventoryInspectionItemMutationFn = Apollo.MutationFunction<UpsertInventoryInspectionItemMutation, UpsertInventoryInspectionItemMutationVariables>;

/**
 * __useUpsertInventoryInspectionItemMutation__
 *
 * To run a mutation, you first call `useUpsertInventoryInspectionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertInventoryInspectionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertInventoryInspectionItemMutation, { data, loading, error }] = useUpsertInventoryInspectionItemMutation({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertInventoryInspectionItemMutation(baseOptions?: Apollo.MutationHookOptions<UpsertInventoryInspectionItemMutation, UpsertInventoryInspectionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertInventoryInspectionItemMutation, UpsertInventoryInspectionItemMutationVariables>(UpsertInventoryInspectionItemDocument, options);
      }
export type UpsertInventoryInspectionItemMutationHookResult = ReturnType<typeof useUpsertInventoryInspectionItemMutation>;
export type UpsertInventoryInspectionItemMutationResult = Apollo.MutationResult<UpsertInventoryInspectionItemMutation>;
export type UpsertInventoryInspectionItemMutationOptions = Apollo.BaseMutationOptions<UpsertInventoryInspectionItemMutation, UpsertInventoryInspectionItemMutationVariables>;
export const UpsertInventoryInspectionSectionDocument = gql`
    mutation UpsertInventoryInspectionSection($inspectionId: ID!, $propertyId: ID!, $input: UpsertInventoryInspectionSectionInput!) {
  upsertInventoryInspectionSection(
    inspectionId: $inspectionId
    propertyId: $propertyId
    input: $input
  ) {
    id
    sections {
      id
      key
    }
  }
}
    `;
export type UpsertInventoryInspectionSectionMutationFn = Apollo.MutationFunction<UpsertInventoryInspectionSectionMutation, UpsertInventoryInspectionSectionMutationVariables>;

/**
 * __useUpsertInventoryInspectionSectionMutation__
 *
 * To run a mutation, you first call `useUpsertInventoryInspectionSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertInventoryInspectionSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertInventoryInspectionSectionMutation, { data, loading, error }] = useUpsertInventoryInspectionSectionMutation({
 *   variables: {
 *      inspectionId: // value for 'inspectionId'
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertInventoryInspectionSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertInventoryInspectionSectionMutation, UpsertInventoryInspectionSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertInventoryInspectionSectionMutation, UpsertInventoryInspectionSectionMutationVariables>(UpsertInventoryInspectionSectionDocument, options);
      }
export type UpsertInventoryInspectionSectionMutationHookResult = ReturnType<typeof useUpsertInventoryInspectionSectionMutation>;
export type UpsertInventoryInspectionSectionMutationResult = Apollo.MutationResult<UpsertInventoryInspectionSectionMutation>;
export type UpsertInventoryInspectionSectionMutationOptions = Apollo.BaseMutationOptions<UpsertInventoryInspectionSectionMutation, UpsertInventoryInspectionSectionMutationVariables>;
export const ValidateOtpDocument = gql`
    mutation ValidateOtp($code: Int!, $isForRegistration: Boolean) {
  validateOtp(
    validateOtpInput: {code: $code, isForRegistration: $isForRegistration}
  ) {
    responseType
    code
    message
  }
}
    `;
export type ValidateOtpMutationFn = Apollo.MutationFunction<ValidateOtpMutation, ValidateOtpMutationVariables>;

/**
 * __useValidateOtpMutation__
 *
 * To run a mutation, you first call `useValidateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateOtpMutation, { data, loading, error }] = useValidateOtpMutation({
 *   variables: {
 *      code: // value for 'code'
 *      isForRegistration: // value for 'isForRegistration'
 *   },
 * });
 */
export function useValidateOtpMutation(baseOptions?: Apollo.MutationHookOptions<ValidateOtpMutation, ValidateOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateOtpMutation, ValidateOtpMutationVariables>(ValidateOtpDocument, options);
      }
export type ValidateOtpMutationHookResult = ReturnType<typeof useValidateOtpMutation>;
export type ValidateOtpMutationResult = Apollo.MutationResult<ValidateOtpMutation>;
export type ValidateOtpMutationOptions = Apollo.BaseMutationOptions<ValidateOtpMutation, ValidateOtpMutationVariables>;
export const AlertNoticesDocument = gql`
    query AlertNotices($filter: DashboardFilterInput, $pageSize: Int, $page: Int) {
  alertNotices(filter: $filter, pageSize: $pageSize, page: $page) {
    items {
      id
      message
      tenantName
      period
      dueDate
      createdAt
      rentChargeId
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useAlertNoticesQuery__
 *
 * To run a query within a React component, call `useAlertNoticesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertNoticesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertNoticesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAlertNoticesQuery(baseOptions?: Apollo.QueryHookOptions<AlertNoticesQuery, AlertNoticesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertNoticesQuery, AlertNoticesQueryVariables>(AlertNoticesDocument, options);
      }
export function useAlertNoticesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertNoticesQuery, AlertNoticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertNoticesQuery, AlertNoticesQueryVariables>(AlertNoticesDocument, options);
        }
export function useAlertNoticesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlertNoticesQuery, AlertNoticesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlertNoticesQuery, AlertNoticesQueryVariables>(AlertNoticesDocument, options);
        }
export type AlertNoticesQueryHookResult = ReturnType<typeof useAlertNoticesQuery>;
export type AlertNoticesLazyQueryHookResult = ReturnType<typeof useAlertNoticesLazyQuery>;
export type AlertNoticesSuspenseQueryHookResult = ReturnType<typeof useAlertNoticesSuspenseQuery>;
export type AlertNoticesQueryResult = Apollo.QueryResult<AlertNoticesQuery, AlertNoticesQueryVariables>;
export const GetChargeDetailDocument = gql`
    query GetChargeDetail($chargeId: String!) {
  rentCharge(id: $chargeId) {
    id
    executionDate
    rentChargeStatusOption
    rentChargeTypeOption
    description
    amountValue
    currencyOption
  }
}
    `;

/**
 * __useGetChargeDetailQuery__
 *
 * To run a query within a React component, call `useGetChargeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargeDetailQuery({
 *   variables: {
 *      chargeId: // value for 'chargeId'
 *   },
 * });
 */
export function useGetChargeDetailQuery(baseOptions: Apollo.QueryHookOptions<GetChargeDetailQuery, GetChargeDetailQueryVariables> & ({ variables: GetChargeDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChargeDetailQuery, GetChargeDetailQueryVariables>(GetChargeDetailDocument, options);
      }
export function useGetChargeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChargeDetailQuery, GetChargeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChargeDetailQuery, GetChargeDetailQueryVariables>(GetChargeDetailDocument, options);
        }
export function useGetChargeDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChargeDetailQuery, GetChargeDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChargeDetailQuery, GetChargeDetailQueryVariables>(GetChargeDetailDocument, options);
        }
export type GetChargeDetailQueryHookResult = ReturnType<typeof useGetChargeDetailQuery>;
export type GetChargeDetailLazyQueryHookResult = ReturnType<typeof useGetChargeDetailLazyQuery>;
export type GetChargeDetailSuspenseQueryHookResult = ReturnType<typeof useGetChargeDetailSuspenseQuery>;
export type GetChargeDetailQueryResult = Apollo.QueryResult<GetChargeDetailQuery, GetChargeDetailQueryVariables>;
export const GetAllCitiesDocument = gql`
    query GetAllCities($stateCode: String!) {
  cities(stateId: $stateCode) {
    name
    geonamesId
    latitude
    longitude
  }
}
    `;

/**
 * __useGetAllCitiesQuery__
 *
 * To run a query within a React component, call `useGetAllCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCitiesQuery({
 *   variables: {
 *      stateCode: // value for 'stateCode'
 *   },
 * });
 */
export function useGetAllCitiesQuery(baseOptions: Apollo.QueryHookOptions<GetAllCitiesQuery, GetAllCitiesQueryVariables> & ({ variables: GetAllCitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCitiesQuery, GetAllCitiesQueryVariables>(GetAllCitiesDocument, options);
      }
export function useGetAllCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCitiesQuery, GetAllCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCitiesQuery, GetAllCitiesQueryVariables>(GetAllCitiesDocument, options);
        }
export function useGetAllCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCitiesQuery, GetAllCitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCitiesQuery, GetAllCitiesQueryVariables>(GetAllCitiesDocument, options);
        }
export type GetAllCitiesQueryHookResult = ReturnType<typeof useGetAllCitiesQuery>;
export type GetAllCitiesLazyQueryHookResult = ReturnType<typeof useGetAllCitiesLazyQuery>;
export type GetAllCitiesSuspenseQueryHookResult = ReturnType<typeof useGetAllCitiesSuspenseQuery>;
export type GetAllCitiesQueryResult = Apollo.QueryResult<GetAllCitiesQuery, GetAllCitiesQueryVariables>;
export const GetCityDocument = gql`
    query GetCity($cityId: String!) {
  city(cityId: $cityId) {
    name
    latitude
    longitude
  }
}
    `;

/**
 * __useGetCityQuery__
 *
 * To run a query within a React component, call `useGetCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityQuery({
 *   variables: {
 *      cityId: // value for 'cityId'
 *   },
 * });
 */
export function useGetCityQuery(baseOptions: Apollo.QueryHookOptions<GetCityQuery, GetCityQueryVariables> & ({ variables: GetCityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityQuery, GetCityQueryVariables>(GetCityDocument, options);
      }
export function useGetCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityQuery, GetCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityQuery, GetCityQueryVariables>(GetCityDocument, options);
        }
export function useGetCitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCityQuery, GetCityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCityQuery, GetCityQueryVariables>(GetCityDocument, options);
        }
export type GetCityQueryHookResult = ReturnType<typeof useGetCityQuery>;
export type GetCityLazyQueryHookResult = ReturnType<typeof useGetCityLazyQuery>;
export type GetCitySuspenseQueryHookResult = ReturnType<typeof useGetCitySuspenseQuery>;
export type GetCityQueryResult = Apollo.QueryResult<GetCityQuery, GetCityQueryVariables>;
export const GetCityWithStateAndCountryNamesDocument = gql`
    query GetCityWithStateAndCountryNames($cityId: String!) {
  city(cityId: $cityId) {
    name
    state {
      name
    }
    country {
      name
    }
  }
}
    `;

/**
 * __useGetCityWithStateAndCountryNamesQuery__
 *
 * To run a query within a React component, call `useGetCityWithStateAndCountryNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityWithStateAndCountryNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityWithStateAndCountryNamesQuery({
 *   variables: {
 *      cityId: // value for 'cityId'
 *   },
 * });
 */
export function useGetCityWithStateAndCountryNamesQuery(baseOptions: Apollo.QueryHookOptions<GetCityWithStateAndCountryNamesQuery, GetCityWithStateAndCountryNamesQueryVariables> & ({ variables: GetCityWithStateAndCountryNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityWithStateAndCountryNamesQuery, GetCityWithStateAndCountryNamesQueryVariables>(GetCityWithStateAndCountryNamesDocument, options);
      }
export function useGetCityWithStateAndCountryNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityWithStateAndCountryNamesQuery, GetCityWithStateAndCountryNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityWithStateAndCountryNamesQuery, GetCityWithStateAndCountryNamesQueryVariables>(GetCityWithStateAndCountryNamesDocument, options);
        }
export function useGetCityWithStateAndCountryNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCityWithStateAndCountryNamesQuery, GetCityWithStateAndCountryNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCityWithStateAndCountryNamesQuery, GetCityWithStateAndCountryNamesQueryVariables>(GetCityWithStateAndCountryNamesDocument, options);
        }
export type GetCityWithStateAndCountryNamesQueryHookResult = ReturnType<typeof useGetCityWithStateAndCountryNamesQuery>;
export type GetCityWithStateAndCountryNamesLazyQueryHookResult = ReturnType<typeof useGetCityWithStateAndCountryNamesLazyQuery>;
export type GetCityWithStateAndCountryNamesSuspenseQueryHookResult = ReturnType<typeof useGetCityWithStateAndCountryNamesSuspenseQuery>;
export type GetCityWithStateAndCountryNamesQueryResult = Apollo.QueryResult<GetCityWithStateAndCountryNamesQuery, GetCityWithStateAndCountryNamesQueryVariables>;
export const GetContractDocument = gql`
    query GetContract($id: String!, $expensesFilterInput: ExpensesReportFilterInput) {
  contract(id: $id) {
    id
    createdAt
    startDate
    finishDate
    keysDelivered
    keysReceived
    signed
    leaseTermOption
    rentAmount
    statusOption
    dayForExecuteCharges
    monthlyChargeAmount
    isAutoGenerateRentCharges
    unities {
      id
      name
    }
    property {
      id
      name
      address {
        street
        buildingNumber
        addressLine
        zipCode
        country {
          name
        }
        state {
          name
        }
        city {
          name
        }
      }
    }
    rentCharges {
      id
      amountValue
      rentChargeTypeOption
      rentChargeStatusOption
      executionDate
      description
    }
    tenant {
      firstName
      lastName
      user {
        id
      }
    }
    owner {
      firstName
      lastName
      user {
        id
      }
    }
    notes {
      id
      text
      createdAt
      ownerFirstName
      ownerLastName
    }
    incidents {
      id
      subject
      incidentTypeOption
      incidentCategoryOption
      priorityOption
      statusOption
      startDate
      endDate
      unity {
        name
      }
    }
  }
  expensesReport(filterInput: $expensesFilterInput) {
    items {
      id
      incidentId
      contractId
      incidentSubject
      propertyName
      supplierName
      payerLabel
      payerUserType
      paidToSupplier
      collectedFromPayer
      title
      description
      date
      expenseCost
      invoiceNumber
      chargeStatus
      typeOption
      currencyOption
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetContractQuery__
 *
 * To run a query within a React component, call `useGetContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *      expensesFilterInput: // value for 'expensesFilterInput'
 *   },
 * });
 */
export function useGetContractQuery(baseOptions: Apollo.QueryHookOptions<GetContractQuery, GetContractQueryVariables> & ({ variables: GetContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
      }
export function useGetContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractQuery, GetContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
        }
export function useGetContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractQuery, GetContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractQuery, GetContractQueryVariables>(GetContractDocument, options);
        }
export type GetContractQueryHookResult = ReturnType<typeof useGetContractQuery>;
export type GetContractLazyQueryHookResult = ReturnType<typeof useGetContractLazyQuery>;
export type GetContractSuspenseQueryHookResult = ReturnType<typeof useGetContractSuspenseQuery>;
export type GetContractQueryResult = Apollo.QueryResult<GetContractQuery, GetContractQueryVariables>;
export const GetContractsByStatusDocument = gql`
    query GetContractsByStatus($year: Float) {
  dashboardData {
    contractsByStatus(year: $year) {
      status
      count
    }
  }
}
    `;

/**
 * __useGetContractsByStatusQuery__
 *
 * To run a query within a React component, call `useGetContractsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsByStatusQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetContractsByStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetContractsByStatusQuery, GetContractsByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractsByStatusQuery, GetContractsByStatusQueryVariables>(GetContractsByStatusDocument, options);
      }
export function useGetContractsByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractsByStatusQuery, GetContractsByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractsByStatusQuery, GetContractsByStatusQueryVariables>(GetContractsByStatusDocument, options);
        }
export function useGetContractsByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractsByStatusQuery, GetContractsByStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractsByStatusQuery, GetContractsByStatusQueryVariables>(GetContractsByStatusDocument, options);
        }
export type GetContractsByStatusQueryHookResult = ReturnType<typeof useGetContractsByStatusQuery>;
export type GetContractsByStatusLazyQueryHookResult = ReturnType<typeof useGetContractsByStatusLazyQuery>;
export type GetContractsByStatusSuspenseQueryHookResult = ReturnType<typeof useGetContractsByStatusSuspenseQuery>;
export type GetContractsByStatusQueryResult = Apollo.QueryResult<GetContractsByStatusQuery, GetContractsByStatusQueryVariables>;
export const GetContractsForIncidentsDocument = gql`
    query GetContractsForIncidents {
  contracts {
    items {
      id
      unities {
        name
        property {
          address {
            street
            city {
              geonamesId
              name
            }
            state {
              geonamesAdmin1Code
              name
            }
            country {
              iso2
              name
            }
          }
        }
      }
      tenant {
        firstName
        lastName
      }
      statusOption
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetContractsForIncidentsQuery__
 *
 * To run a query within a React component, call `useGetContractsForIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsForIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsForIncidentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractsForIncidentsQuery(baseOptions?: Apollo.QueryHookOptions<GetContractsForIncidentsQuery, GetContractsForIncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractsForIncidentsQuery, GetContractsForIncidentsQueryVariables>(GetContractsForIncidentsDocument, options);
      }
export function useGetContractsForIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractsForIncidentsQuery, GetContractsForIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractsForIncidentsQuery, GetContractsForIncidentsQueryVariables>(GetContractsForIncidentsDocument, options);
        }
export function useGetContractsForIncidentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractsForIncidentsQuery, GetContractsForIncidentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractsForIncidentsQuery, GetContractsForIncidentsQueryVariables>(GetContractsForIncidentsDocument, options);
        }
export type GetContractsForIncidentsQueryHookResult = ReturnType<typeof useGetContractsForIncidentsQuery>;
export type GetContractsForIncidentsLazyQueryHookResult = ReturnType<typeof useGetContractsForIncidentsLazyQuery>;
export type GetContractsForIncidentsSuspenseQueryHookResult = ReturnType<typeof useGetContractsForIncidentsSuspenseQuery>;
export type GetContractsForIncidentsQueryResult = Apollo.QueryResult<GetContractsForIncidentsQuery, GetContractsForIncidentsQueryVariables>;
export const GetContractsForListDocument = gql`
    query GetContractsForList($input: ContractFilterInput) {
  contracts(filterInput: $input) {
    items {
      id
      rentAmount
      startDate
      finishDate
      monthlyChargeAmount
      isAutoGenerateRentCharges
      unities {
        name
      }
      property {
        id
        name
      }
      tenant {
        firstName
        lastName
        user {
          id
        }
      }
      statusOption
      signed
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetContractsForListQuery__
 *
 * To run a query within a React component, call `useGetContractsForListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsForListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsForListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetContractsForListQuery(baseOptions?: Apollo.QueryHookOptions<GetContractsForListQuery, GetContractsForListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractsForListQuery, GetContractsForListQueryVariables>(GetContractsForListDocument, options);
      }
export function useGetContractsForListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractsForListQuery, GetContractsForListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractsForListQuery, GetContractsForListQueryVariables>(GetContractsForListDocument, options);
        }
export function useGetContractsForListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractsForListQuery, GetContractsForListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractsForListQuery, GetContractsForListQueryVariables>(GetContractsForListDocument, options);
        }
export type GetContractsForListQueryHookResult = ReturnType<typeof useGetContractsForListQuery>;
export type GetContractsForListLazyQueryHookResult = ReturnType<typeof useGetContractsForListLazyQuery>;
export type GetContractsForListSuspenseQueryHookResult = ReturnType<typeof useGetContractsForListSuspenseQuery>;
export type GetContractsForListQueryResult = Apollo.QueryResult<GetContractsForListQuery, GetContractsForListQueryVariables>;
export const GetCountriesForPhoneCodeDocument = gql`
    query GetCountriesForPhoneCode {
  countries {
    iso2
    name
    phoneCode
  }
}
    `;

/**
 * __useGetCountriesForPhoneCodeQuery__
 *
 * To run a query within a React component, call `useGetCountriesForPhoneCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesForPhoneCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesForPhoneCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesForPhoneCodeQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesForPhoneCodeQuery, GetCountriesForPhoneCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesForPhoneCodeQuery, GetCountriesForPhoneCodeQueryVariables>(GetCountriesForPhoneCodeDocument, options);
      }
export function useGetCountriesForPhoneCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesForPhoneCodeQuery, GetCountriesForPhoneCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesForPhoneCodeQuery, GetCountriesForPhoneCodeQueryVariables>(GetCountriesForPhoneCodeDocument, options);
        }
export function useGetCountriesForPhoneCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesForPhoneCodeQuery, GetCountriesForPhoneCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesForPhoneCodeQuery, GetCountriesForPhoneCodeQueryVariables>(GetCountriesForPhoneCodeDocument, options);
        }
export type GetCountriesForPhoneCodeQueryHookResult = ReturnType<typeof useGetCountriesForPhoneCodeQuery>;
export type GetCountriesForPhoneCodeLazyQueryHookResult = ReturnType<typeof useGetCountriesForPhoneCodeLazyQuery>;
export type GetCountriesForPhoneCodeSuspenseQueryHookResult = ReturnType<typeof useGetCountriesForPhoneCodeSuspenseQuery>;
export type GetCountriesForPhoneCodeQueryResult = Apollo.QueryResult<GetCountriesForPhoneCodeQuery, GetCountriesForPhoneCodeQueryVariables>;
export const GetCountryIsoCodesDocument = gql`
    query GetCountryIsoCodes {
  countries {
    iso2
    name
  }
}
    `;

/**
 * __useGetCountryIsoCodesQuery__
 *
 * To run a query within a React component, call `useGetCountryIsoCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryIsoCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryIsoCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryIsoCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountryIsoCodesQuery, GetCountryIsoCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryIsoCodesQuery, GetCountryIsoCodesQueryVariables>(GetCountryIsoCodesDocument, options);
      }
export function useGetCountryIsoCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryIsoCodesQuery, GetCountryIsoCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryIsoCodesQuery, GetCountryIsoCodesQueryVariables>(GetCountryIsoCodesDocument, options);
        }
export function useGetCountryIsoCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountryIsoCodesQuery, GetCountryIsoCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountryIsoCodesQuery, GetCountryIsoCodesQueryVariables>(GetCountryIsoCodesDocument, options);
        }
export type GetCountryIsoCodesQueryHookResult = ReturnType<typeof useGetCountryIsoCodesQuery>;
export type GetCountryIsoCodesLazyQueryHookResult = ReturnType<typeof useGetCountryIsoCodesLazyQuery>;
export type GetCountryIsoCodesSuspenseQueryHookResult = ReturnType<typeof useGetCountryIsoCodesSuspenseQuery>;
export type GetCountryIsoCodesQueryResult = Apollo.QueryResult<GetCountryIsoCodesQuery, GetCountryIsoCodesQueryVariables>;
export const GetCountryByCodeDocument = gql`
    query GetCountryByCode($countryCode: String!) {
  country(code: $countryCode) {
    name
  }
}
    `;

/**
 * __useGetCountryByCodeQuery__
 *
 * To run a query within a React component, call `useGetCountryByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryByCodeQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetCountryByCodeQuery(baseOptions: Apollo.QueryHookOptions<GetCountryByCodeQuery, GetCountryByCodeQueryVariables> & ({ variables: GetCountryByCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryByCodeQuery, GetCountryByCodeQueryVariables>(GetCountryByCodeDocument, options);
      }
export function useGetCountryByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryByCodeQuery, GetCountryByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryByCodeQuery, GetCountryByCodeQueryVariables>(GetCountryByCodeDocument, options);
        }
export function useGetCountryByCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountryByCodeQuery, GetCountryByCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountryByCodeQuery, GetCountryByCodeQueryVariables>(GetCountryByCodeDocument, options);
        }
export type GetCountryByCodeQueryHookResult = ReturnType<typeof useGetCountryByCodeQuery>;
export type GetCountryByCodeLazyQueryHookResult = ReturnType<typeof useGetCountryByCodeLazyQuery>;
export type GetCountryByCodeSuspenseQueryHookResult = ReturnType<typeof useGetCountryByCodeSuspenseQuery>;
export type GetCountryByCodeQueryResult = Apollo.QueryResult<GetCountryByCodeQuery, GetCountryByCodeQueryVariables>;
export const GetDashboardDataDocument = gql`
    query GetDashboardData($filter: DashboardFilterInput) {
  dashboardData(filter: $filter) {
    incomeAndExpenses {
      income {
        collected
        notCollected
        total
        collectedPercentage
      }
      expenses {
        paid
        notPaid
        total
        paidPercentage
      }
    }
    occupation {
      total
      occupied
      previousMonth {
        year
        month
        occupied
        total
      }
      monthlyTrend {
        year
        month
        occupied
        total
      }
    }
    stats {
      tenants
      properties
      incidents
      owners
    }
    incidentsByStatus {
      status
      count
    }
  }
}
    `;

/**
 * __useGetDashboardDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardDataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDashboardDataQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardDataQuery, GetDashboardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardDataQuery, GetDashboardDataQueryVariables>(GetDashboardDataDocument, options);
      }
export function useGetDashboardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardDataQuery, GetDashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardDataQuery, GetDashboardDataQueryVariables>(GetDashboardDataDocument, options);
        }
export function useGetDashboardDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardDataQuery, GetDashboardDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardDataQuery, GetDashboardDataQueryVariables>(GetDashboardDataDocument, options);
        }
export type GetDashboardDataQueryHookResult = ReturnType<typeof useGetDashboardDataQuery>;
export type GetDashboardDataLazyQueryHookResult = ReturnType<typeof useGetDashboardDataLazyQuery>;
export type GetDashboardDataSuspenseQueryHookResult = ReturnType<typeof useGetDashboardDataSuspenseQuery>;
export type GetDashboardDataQueryResult = Apollo.QueryResult<GetDashboardDataQuery, GetDashboardDataQueryVariables>;
export const GetDepositsReportDocument = gql`
    query GetDepositsReport($filterInput: DepositsReportFilterInput) {
  depositsReport(filterInput: $filterInput) {
    items {
      id
      amount
      operationDate
      reference
      ownerAccountName
      currencyOption
      depositStatusOption
      payment {
        id
        paymentStatusOption
        amountValue
        createdAt
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetDepositsReportQuery__
 *
 * To run a query within a React component, call `useGetDepositsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepositsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepositsReportQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetDepositsReportQuery(baseOptions?: Apollo.QueryHookOptions<GetDepositsReportQuery, GetDepositsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepositsReportQuery, GetDepositsReportQueryVariables>(GetDepositsReportDocument, options);
      }
export function useGetDepositsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepositsReportQuery, GetDepositsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepositsReportQuery, GetDepositsReportQueryVariables>(GetDepositsReportDocument, options);
        }
export function useGetDepositsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDepositsReportQuery, GetDepositsReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDepositsReportQuery, GetDepositsReportQueryVariables>(GetDepositsReportDocument, options);
        }
export type GetDepositsReportQueryHookResult = ReturnType<typeof useGetDepositsReportQuery>;
export type GetDepositsReportLazyQueryHookResult = ReturnType<typeof useGetDepositsReportLazyQuery>;
export type GetDepositsReportSuspenseQueryHookResult = ReturnType<typeof useGetDepositsReportSuspenseQuery>;
export type GetDepositsReportQueryResult = Apollo.QueryResult<GetDepositsReportQuery, GetDepositsReportQueryVariables>;
export const GetExpensesReportDocument = gql`
    query GetExpensesReport($filterInput: ExpensesReportFilterInput) {
  expensesReport(filterInput: $filterInput) {
    items {
      id
      incidentId
      contractId
      incidentSubject
      propertyName
      supplierName
      payerLabel
      payerUserType
      paidToSupplier
      collectedFromPayer
      title
      description
      date
      expenseCost
      invoiceNumber
      chargeStatus
      typeOption
      currencyOption
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetExpensesReportQuery__
 *
 * To run a query within a React component, call `useGetExpensesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpensesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpensesReportQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetExpensesReportQuery(baseOptions?: Apollo.QueryHookOptions<GetExpensesReportQuery, GetExpensesReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpensesReportQuery, GetExpensesReportQueryVariables>(GetExpensesReportDocument, options);
      }
export function useGetExpensesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpensesReportQuery, GetExpensesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpensesReportQuery, GetExpensesReportQueryVariables>(GetExpensesReportDocument, options);
        }
export function useGetExpensesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExpensesReportQuery, GetExpensesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpensesReportQuery, GetExpensesReportQueryVariables>(GetExpensesReportDocument, options);
        }
export type GetExpensesReportQueryHookResult = ReturnType<typeof useGetExpensesReportQuery>;
export type GetExpensesReportLazyQueryHookResult = ReturnType<typeof useGetExpensesReportLazyQuery>;
export type GetExpensesReportSuspenseQueryHookResult = ReturnType<typeof useGetExpensesReportSuspenseQuery>;
export type GetExpensesReportQueryResult = Apollo.QueryResult<GetExpensesReportQuery, GetExpensesReportQueryVariables>;
export const GetIncidentDocument = gql`
    query GetIncident($incidentId: String!) {
  incident(id: $incidentId) {
    id
    subject
    incidentTypeOption
    incidentCategoryOption
    priorityOption
    statusOption
    startDate
    endDate
    updatedAt
    incidentResponsabilities {
      responsabilityPercentage
      userTypeOption
      amount
    }
    supplier {
      firstName
      lastName
      user {
        id
      }
    }
    tenant {
      firstName
      lastName
      hasDebt
      user {
        id
      }
    }
    incidentRating {
      id
      value
      comment
    }
    property {
      id
      name
      address {
        street
        buildingNumber
        addressLine
        zipCode
        city {
          geonamesId
          name
        }
        state {
          geonamesAdmin1Code
          name
        }
        country {
          iso2
          name
        }
      }
    }
    unity {
      id
      name
    }
    budgets {
      id
      budgetCost
      budgetEarning
      budgetStatusOption
      subject
      supplier {
        firstName
        lastName
      }
    }
    selectedBudget {
      id
      budgetCost
      budgetEarning
      budgetStatusOption
      subject
      supplier {
        firstName
        lastName
      }
    }
    notes {
      id
      text
      createdAt
      ownerFirstName
      ownerLastName
    }
    fileUploads {
      urlToDownload
      fileTypeOption
    }
    incidentReports {
      id
      subject
      updatedAt
    }
    incidentExpenses {
      id
      invoiceNumber
      invoiceDate
      amount
      description
    }
  }
}
    `;

/**
 * __useGetIncidentQuery__
 *
 * To run a query within a React component, call `useGetIncidentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncidentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncidentQuery({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *   },
 * });
 */
export function useGetIncidentQuery(baseOptions: Apollo.QueryHookOptions<GetIncidentQuery, GetIncidentQueryVariables> & ({ variables: GetIncidentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncidentQuery, GetIncidentQueryVariables>(GetIncidentDocument, options);
      }
export function useGetIncidentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncidentQuery, GetIncidentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncidentQuery, GetIncidentQueryVariables>(GetIncidentDocument, options);
        }
export function useGetIncidentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIncidentQuery, GetIncidentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIncidentQuery, GetIncidentQueryVariables>(GetIncidentDocument, options);
        }
export type GetIncidentQueryHookResult = ReturnType<typeof useGetIncidentQuery>;
export type GetIncidentLazyQueryHookResult = ReturnType<typeof useGetIncidentLazyQuery>;
export type GetIncidentSuspenseQueryHookResult = ReturnType<typeof useGetIncidentSuspenseQuery>;
export type GetIncidentQueryResult = Apollo.QueryResult<GetIncidentQuery, GetIncidentQueryVariables>;
export const GetIncidentReportDetailDocument = gql`
    query GetIncidentReportDetail($incidentId: String!, $incidentReportId: String!) {
  getIncidentReport(incidentId: $incidentId, incidentReportId: $incidentReportId) {
    id
    subject
    createdAt
    updatedAt
    notes {
      id
      text
      createdAt
      ownerFirstName
      ownerLastName
    }
    fileUploads {
      urlToDownload
      fileTypeOption
    }
  }
}
    `;

/**
 * __useGetIncidentReportDetailQuery__
 *
 * To run a query within a React component, call `useGetIncidentReportDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncidentReportDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncidentReportDetailQuery({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *      incidentReportId: // value for 'incidentReportId'
 *   },
 * });
 */
export function useGetIncidentReportDetailQuery(baseOptions: Apollo.QueryHookOptions<GetIncidentReportDetailQuery, GetIncidentReportDetailQueryVariables> & ({ variables: GetIncidentReportDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncidentReportDetailQuery, GetIncidentReportDetailQueryVariables>(GetIncidentReportDetailDocument, options);
      }
export function useGetIncidentReportDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncidentReportDetailQuery, GetIncidentReportDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncidentReportDetailQuery, GetIncidentReportDetailQueryVariables>(GetIncidentReportDetailDocument, options);
        }
export function useGetIncidentReportDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIncidentReportDetailQuery, GetIncidentReportDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIncidentReportDetailQuery, GetIncidentReportDetailQueryVariables>(GetIncidentReportDetailDocument, options);
        }
export type GetIncidentReportDetailQueryHookResult = ReturnType<typeof useGetIncidentReportDetailQuery>;
export type GetIncidentReportDetailLazyQueryHookResult = ReturnType<typeof useGetIncidentReportDetailLazyQuery>;
export type GetIncidentReportDetailSuspenseQueryHookResult = ReturnType<typeof useGetIncidentReportDetailSuspenseQuery>;
export type GetIncidentReportDetailQueryResult = Apollo.QueryResult<GetIncidentReportDetailQuery, GetIncidentReportDetailQueryVariables>;
export const GetIncidentsForListDocument = gql`
    query GetIncidentsForList($input: IncidentFilterInput) {
  incidents(filterInput: $input) {
    __typename
    ... on IncidentsPaginatedOutput {
      items {
        id
        incidentTypeOption
        priorityOption
        statusOption
        subject
        startDate
        supplier {
          firstName
          lastName
        }
        tenant {
          firstName
          lastName
          hasDebt
        }
        property {
          name
          address {
            street
            city {
              geonamesId
              name
            }
          }
        }
        unity {
          name
        }
      }
      pagination {
        totalItems
        totalPages
        currentPage
        pageSize
        hasNextPage
        hasPreviousPage
      }
    }
    ... on ActionResponseMessageOutput {
      responseType
      code
      message
    }
  }
}
    `;

/**
 * __useGetIncidentsForListQuery__
 *
 * To run a query within a React component, call `useGetIncidentsForListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncidentsForListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncidentsForListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIncidentsForListQuery(baseOptions?: Apollo.QueryHookOptions<GetIncidentsForListQuery, GetIncidentsForListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncidentsForListQuery, GetIncidentsForListQueryVariables>(GetIncidentsForListDocument, options);
      }
export function useGetIncidentsForListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncidentsForListQuery, GetIncidentsForListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncidentsForListQuery, GetIncidentsForListQueryVariables>(GetIncidentsForListDocument, options);
        }
export function useGetIncidentsForListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIncidentsForListQuery, GetIncidentsForListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIncidentsForListQuery, GetIncidentsForListQueryVariables>(GetIncidentsForListDocument, options);
        }
export type GetIncidentsForListQueryHookResult = ReturnType<typeof useGetIncidentsForListQuery>;
export type GetIncidentsForListLazyQueryHookResult = ReturnType<typeof useGetIncidentsForListLazyQuery>;
export type GetIncidentsForListSuspenseQueryHookResult = ReturnType<typeof useGetIncidentsForListSuspenseQuery>;
export type GetIncidentsForListQueryResult = Apollo.QueryResult<GetIncidentsForListQuery, GetIncidentsForListQueryVariables>;
export const GetInventoryInspectionsDocument = gql`
    query GetInventoryInspections($propertyId: ID!) {
  inventoryInspections(propertyId: $propertyId) {
    id
    type
    inspectionDate
    inspectorName
    receiverName
    generalNotes
    sections {
      id
      key
      title
      order
      isSystem
      items {
        id
        title
        quantity
        status
        notes
        order
        files {
          id
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetInventoryInspectionsQuery__
 *
 * To run a query within a React component, call `useGetInventoryInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryInspectionsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetInventoryInspectionsQuery(baseOptions: Apollo.QueryHookOptions<GetInventoryInspectionsQuery, GetInventoryInspectionsQueryVariables> & ({ variables: GetInventoryInspectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInventoryInspectionsQuery, GetInventoryInspectionsQueryVariables>(GetInventoryInspectionsDocument, options);
      }
export function useGetInventoryInspectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInventoryInspectionsQuery, GetInventoryInspectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInventoryInspectionsQuery, GetInventoryInspectionsQueryVariables>(GetInventoryInspectionsDocument, options);
        }
export function useGetInventoryInspectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInventoryInspectionsQuery, GetInventoryInspectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInventoryInspectionsQuery, GetInventoryInspectionsQueryVariables>(GetInventoryInspectionsDocument, options);
        }
export type GetInventoryInspectionsQueryHookResult = ReturnType<typeof useGetInventoryInspectionsQuery>;
export type GetInventoryInspectionsLazyQueryHookResult = ReturnType<typeof useGetInventoryInspectionsLazyQuery>;
export type GetInventoryInspectionsSuspenseQueryHookResult = ReturnType<typeof useGetInventoryInspectionsSuspenseQuery>;
export type GetInventoryInspectionsQueryResult = Apollo.QueryResult<GetInventoryInspectionsQuery, GetInventoryInspectionsQueryVariables>;
export const GetInventoryDocument = gql`
    query GetInventory($id: String!, $propertyId: String!) {
  inventory(id: $id, propertyId: $propertyId) {
    id
    description
    items {
      id
      description
      quantity
    }
  }
}
    `;

/**
 * __useGetInventoryQuery__
 *
 * To run a query within a React component, call `useGetInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetInventoryQuery(baseOptions: Apollo.QueryHookOptions<GetInventoryQuery, GetInventoryQueryVariables> & ({ variables: GetInventoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInventoryQuery, GetInventoryQueryVariables>(GetInventoryDocument, options);
      }
export function useGetInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInventoryQuery, GetInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInventoryQuery, GetInventoryQueryVariables>(GetInventoryDocument, options);
        }
export function useGetInventorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInventoryQuery, GetInventoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInventoryQuery, GetInventoryQueryVariables>(GetInventoryDocument, options);
        }
export type GetInventoryQueryHookResult = ReturnType<typeof useGetInventoryQuery>;
export type GetInventoryLazyQueryHookResult = ReturnType<typeof useGetInventoryLazyQuery>;
export type GetInventorySuspenseQueryHookResult = ReturnType<typeof useGetInventorySuspenseQuery>;
export type GetInventoryQueryResult = Apollo.QueryResult<GetInventoryQuery, GetInventoryQueryVariables>;
export const GetManagerDocument = gql`
    query GetManager {
  manager {
    firstName
    lastName
    phoneNumber
    user {
      email
    }
  }
}
    `;

/**
 * __useGetManagerQuery__
 *
 * To run a query within a React component, call `useGetManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagerQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerQuery, GetManagerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagerQuery, GetManagerQueryVariables>(GetManagerDocument, options);
      }
export function useGetManagerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerQuery, GetManagerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagerQuery, GetManagerQueryVariables>(GetManagerDocument, options);
        }
export function useGetManagerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManagerQuery, GetManagerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManagerQuery, GetManagerQueryVariables>(GetManagerDocument, options);
        }
export type GetManagerQueryHookResult = ReturnType<typeof useGetManagerQuery>;
export type GetManagerLazyQueryHookResult = ReturnType<typeof useGetManagerLazyQuery>;
export type GetManagerSuspenseQueryHookResult = ReturnType<typeof useGetManagerSuspenseQuery>;
export type GetManagerQueryResult = Apollo.QueryResult<GetManagerQuery, GetManagerQueryVariables>;
export const ManagerIncidentAppointmentSlotsDocument = gql`
    query ManagerIncidentAppointmentSlots($incidentId: ID!) {
  managerIncidentAppointmentSlots(incidentId: $incidentId) {
    id
    status
    startAt
    endAt
    selectedAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useManagerIncidentAppointmentSlotsQuery__
 *
 * To run a query within a React component, call `useManagerIncidentAppointmentSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerIncidentAppointmentSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerIncidentAppointmentSlotsQuery({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *   },
 * });
 */
export function useManagerIncidentAppointmentSlotsQuery(baseOptions: Apollo.QueryHookOptions<ManagerIncidentAppointmentSlotsQuery, ManagerIncidentAppointmentSlotsQueryVariables> & ({ variables: ManagerIncidentAppointmentSlotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerIncidentAppointmentSlotsQuery, ManagerIncidentAppointmentSlotsQueryVariables>(ManagerIncidentAppointmentSlotsDocument, options);
      }
export function useManagerIncidentAppointmentSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerIncidentAppointmentSlotsQuery, ManagerIncidentAppointmentSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerIncidentAppointmentSlotsQuery, ManagerIncidentAppointmentSlotsQueryVariables>(ManagerIncidentAppointmentSlotsDocument, options);
        }
export function useManagerIncidentAppointmentSlotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerIncidentAppointmentSlotsQuery, ManagerIncidentAppointmentSlotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagerIncidentAppointmentSlotsQuery, ManagerIncidentAppointmentSlotsQueryVariables>(ManagerIncidentAppointmentSlotsDocument, options);
        }
export type ManagerIncidentAppointmentSlotsQueryHookResult = ReturnType<typeof useManagerIncidentAppointmentSlotsQuery>;
export type ManagerIncidentAppointmentSlotsLazyQueryHookResult = ReturnType<typeof useManagerIncidentAppointmentSlotsLazyQuery>;
export type ManagerIncidentAppointmentSlotsSuspenseQueryHookResult = ReturnType<typeof useManagerIncidentAppointmentSlotsSuspenseQuery>;
export type ManagerIncidentAppointmentSlotsQueryResult = Apollo.QueryResult<ManagerIncidentAppointmentSlotsQuery, ManagerIncidentAppointmentSlotsQueryVariables>;
export const GetManagerMassiveCommunicationsDocument = gql`
    query GetManagerMassiveCommunications {
  managerMassiveCommunications {
    id
    title
    content
    recipientCount
    createdAt
  }
}
    `;

/**
 * __useGetManagerMassiveCommunicationsQuery__
 *
 * To run a query within a React component, call `useGetManagerMassiveCommunicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerMassiveCommunicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerMassiveCommunicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagerMassiveCommunicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerMassiveCommunicationsQuery, GetManagerMassiveCommunicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagerMassiveCommunicationsQuery, GetManagerMassiveCommunicationsQueryVariables>(GetManagerMassiveCommunicationsDocument, options);
      }
export function useGetManagerMassiveCommunicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerMassiveCommunicationsQuery, GetManagerMassiveCommunicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagerMassiveCommunicationsQuery, GetManagerMassiveCommunicationsQueryVariables>(GetManagerMassiveCommunicationsDocument, options);
        }
export function useGetManagerMassiveCommunicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManagerMassiveCommunicationsQuery, GetManagerMassiveCommunicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManagerMassiveCommunicationsQuery, GetManagerMassiveCommunicationsQueryVariables>(GetManagerMassiveCommunicationsDocument, options);
        }
export type GetManagerMassiveCommunicationsQueryHookResult = ReturnType<typeof useGetManagerMassiveCommunicationsQuery>;
export type GetManagerMassiveCommunicationsLazyQueryHookResult = ReturnType<typeof useGetManagerMassiveCommunicationsLazyQuery>;
export type GetManagerMassiveCommunicationsSuspenseQueryHookResult = ReturnType<typeof useGetManagerMassiveCommunicationsSuspenseQuery>;
export type GetManagerMassiveCommunicationsQueryResult = Apollo.QueryResult<GetManagerMassiveCommunicationsQuery, GetManagerMassiveCommunicationsQueryVariables>;
export const GetManagerRatingsReportDocument = gql`
    query GetManagerRatingsReport($filterInput: ManagerRatingsReportFilterInput) {
  managerRatingsReport(filterInput: $filterInput) {
    items {
      id
      createdAt
      tenantName
      incidentId
      ratingValue
      comment
      propertyName
      unityName
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetManagerRatingsReportQuery__
 *
 * To run a query within a React component, call `useGetManagerRatingsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerRatingsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerRatingsReportQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetManagerRatingsReportQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerRatingsReportQuery, GetManagerRatingsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagerRatingsReportQuery, GetManagerRatingsReportQueryVariables>(GetManagerRatingsReportDocument, options);
      }
export function useGetManagerRatingsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerRatingsReportQuery, GetManagerRatingsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagerRatingsReportQuery, GetManagerRatingsReportQueryVariables>(GetManagerRatingsReportDocument, options);
        }
export function useGetManagerRatingsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManagerRatingsReportQuery, GetManagerRatingsReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManagerRatingsReportQuery, GetManagerRatingsReportQueryVariables>(GetManagerRatingsReportDocument, options);
        }
export type GetManagerRatingsReportQueryHookResult = ReturnType<typeof useGetManagerRatingsReportQuery>;
export type GetManagerRatingsReportLazyQueryHookResult = ReturnType<typeof useGetManagerRatingsReportLazyQuery>;
export type GetManagerRatingsReportSuspenseQueryHookResult = ReturnType<typeof useGetManagerRatingsReportSuspenseQuery>;
export type GetManagerRatingsReportQueryResult = Apollo.QueryResult<GetManagerRatingsReportQuery, GetManagerRatingsReportQueryVariables>;
export const GetManagerRatingsSummaryDocument = gql`
    query GetManagerRatingsSummary($filter: DashboardFilterInput) {
  managerRatingsSummary(filter: $filter) {
    averageRating
    totalRatings
    breakdown {
      ratingValue
      percentage
      count
    }
  }
}
    `;

/**
 * __useGetManagerRatingsSummaryQuery__
 *
 * To run a query within a React component, call `useGetManagerRatingsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerRatingsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerRatingsSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetManagerRatingsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetManagerRatingsSummaryQuery, GetManagerRatingsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagerRatingsSummaryQuery, GetManagerRatingsSummaryQueryVariables>(GetManagerRatingsSummaryDocument, options);
      }
export function useGetManagerRatingsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerRatingsSummaryQuery, GetManagerRatingsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagerRatingsSummaryQuery, GetManagerRatingsSummaryQueryVariables>(GetManagerRatingsSummaryDocument, options);
        }
export function useGetManagerRatingsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManagerRatingsSummaryQuery, GetManagerRatingsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManagerRatingsSummaryQuery, GetManagerRatingsSummaryQueryVariables>(GetManagerRatingsSummaryDocument, options);
        }
export type GetManagerRatingsSummaryQueryHookResult = ReturnType<typeof useGetManagerRatingsSummaryQuery>;
export type GetManagerRatingsSummaryLazyQueryHookResult = ReturnType<typeof useGetManagerRatingsSummaryLazyQuery>;
export type GetManagerRatingsSummarySuspenseQueryHookResult = ReturnType<typeof useGetManagerRatingsSummarySuspenseQuery>;
export type GetManagerRatingsSummaryQueryResult = Apollo.QueryResult<GetManagerRatingsSummaryQuery, GetManagerRatingsSummaryQueryVariables>;
export const GetMassiveCommunicationTemplatesDocument = gql`
    query GetMassiveCommunicationTemplates {
  massiveCommunicationTemplates {
    id
    title
    content
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetMassiveCommunicationTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMassiveCommunicationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMassiveCommunicationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMassiveCommunicationTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMassiveCommunicationTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetMassiveCommunicationTemplatesQuery, GetMassiveCommunicationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMassiveCommunicationTemplatesQuery, GetMassiveCommunicationTemplatesQueryVariables>(GetMassiveCommunicationTemplatesDocument, options);
      }
export function useGetMassiveCommunicationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMassiveCommunicationTemplatesQuery, GetMassiveCommunicationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMassiveCommunicationTemplatesQuery, GetMassiveCommunicationTemplatesQueryVariables>(GetMassiveCommunicationTemplatesDocument, options);
        }
export function useGetMassiveCommunicationTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMassiveCommunicationTemplatesQuery, GetMassiveCommunicationTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMassiveCommunicationTemplatesQuery, GetMassiveCommunicationTemplatesQueryVariables>(GetMassiveCommunicationTemplatesDocument, options);
        }
export type GetMassiveCommunicationTemplatesQueryHookResult = ReturnType<typeof useGetMassiveCommunicationTemplatesQuery>;
export type GetMassiveCommunicationTemplatesLazyQueryHookResult = ReturnType<typeof useGetMassiveCommunicationTemplatesLazyQuery>;
export type GetMassiveCommunicationTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetMassiveCommunicationTemplatesSuspenseQuery>;
export type GetMassiveCommunicationTemplatesQueryResult = Apollo.QueryResult<GetMassiveCommunicationTemplatesQuery, GetMassiveCommunicationTemplatesQueryVariables>;
export const GetMessagesByIncidentDocument = gql`
    query GetMessagesByIncident($incidentId: String!) {
  getMessagesByIncident(incidentId: $incidentId) {
    id
    content
    messageOwnerOption
    messageStatusOption
    senderUserTypeOption
    receiverUserTypeOption
    createdAt
  }
}
    `;

/**
 * __useGetMessagesByIncidentQuery__
 *
 * To run a query within a React component, call `useGetMessagesByIncidentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesByIncidentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesByIncidentQuery({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *   },
 * });
 */
export function useGetMessagesByIncidentQuery(baseOptions: Apollo.QueryHookOptions<GetMessagesByIncidentQuery, GetMessagesByIncidentQueryVariables> & ({ variables: GetMessagesByIncidentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesByIncidentQuery, GetMessagesByIncidentQueryVariables>(GetMessagesByIncidentDocument, options);
      }
export function useGetMessagesByIncidentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesByIncidentQuery, GetMessagesByIncidentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesByIncidentQuery, GetMessagesByIncidentQueryVariables>(GetMessagesByIncidentDocument, options);
        }
export function useGetMessagesByIncidentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagesByIncidentQuery, GetMessagesByIncidentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessagesByIncidentQuery, GetMessagesByIncidentQueryVariables>(GetMessagesByIncidentDocument, options);
        }
export type GetMessagesByIncidentQueryHookResult = ReturnType<typeof useGetMessagesByIncidentQuery>;
export type GetMessagesByIncidentLazyQueryHookResult = ReturnType<typeof useGetMessagesByIncidentLazyQuery>;
export type GetMessagesByIncidentSuspenseQueryHookResult = ReturnType<typeof useGetMessagesByIncidentSuspenseQuery>;
export type GetMessagesByIncidentQueryResult = Apollo.QueryResult<GetMessagesByIncidentQuery, GetMessagesByIncidentQueryVariables>;
export const UserNotificationsDocument = gql`
    query UserNotifications {
  userNotifications {
    id
    type
    message
    read
    createdAt
    additionalData {
      __typename
      ... on PaymentDeadlineNotificationData {
        ownerUserId
        rentCharge {
          id
          amountValue
          description
          dueDate
          executionDate
          rentChargeStatusOption
          rentChargeTypeOption
          currencyOption
        }
      }
      ... on IncidentCreatedNotificationData {
        incidentId
        tenantName
        propertyName
      }
      ... on IncidentAssignedNotificationData {
        incidentId
        incidentSubject
        propertyName
      }
      ... on IncidentReportSubmittedNotificationData {
        incidentId
        incidentReportId
        incidentSubject
        supplierName
      }
      ... on IncidentFollowUpNotificationData {
        incidentId
        incidentSubject
        propertyName
        daysSinceCreation
      }
      ... on MessageCreatedNotificationData {
        messageId
        senderName
        incidentId
      }
      ... on ContractNotificationData {
        contractId
      }
    }
  }
}
    `;

/**
 * __useUserNotificationsQuery__
 *
 * To run a query within a React component, call `useUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
      }
export function useUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
        }
export function useUserNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
        }
export type UserNotificationsQueryHookResult = ReturnType<typeof useUserNotificationsQuery>;
export type UserNotificationsLazyQueryHookResult = ReturnType<typeof useUserNotificationsLazyQuery>;
export type UserNotificationsSuspenseQueryHookResult = ReturnType<typeof useUserNotificationsSuspenseQuery>;
export type UserNotificationsQueryResult = Apollo.QueryResult<UserNotificationsQuery, UserNotificationsQueryVariables>;
export const GetOwnerContractDocument = gql`
    query GetOwnerContract($id: String!) {
  ownerContract(id: $id) {
    id
    startDate
    finishDate
    ownerContractLeaseTypeOption
    paymentFrequencyOption
    contractStatusOption
    contractAmount
    property {
      id
      name
      address {
        street
        buildingNumber
        addressLine
        zipCode
        country {
          name
        }
        state {
          name
        }
        city {
          name
        }
      }
      unities {
        id
        name
      }
    }
    owner {
      firstName
      lastName
      user {
        id
      }
    }
  }
}
    `;

/**
 * __useGetOwnerContractQuery__
 *
 * To run a query within a React component, call `useGetOwnerContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOwnerContractQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerContractQuery, GetOwnerContractQueryVariables> & ({ variables: GetOwnerContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerContractQuery, GetOwnerContractQueryVariables>(GetOwnerContractDocument, options);
      }
export function useGetOwnerContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerContractQuery, GetOwnerContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerContractQuery, GetOwnerContractQueryVariables>(GetOwnerContractDocument, options);
        }
export function useGetOwnerContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnerContractQuery, GetOwnerContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnerContractQuery, GetOwnerContractQueryVariables>(GetOwnerContractDocument, options);
        }
export type GetOwnerContractQueryHookResult = ReturnType<typeof useGetOwnerContractQuery>;
export type GetOwnerContractLazyQueryHookResult = ReturnType<typeof useGetOwnerContractLazyQuery>;
export type GetOwnerContractSuspenseQueryHookResult = ReturnType<typeof useGetOwnerContractSuspenseQuery>;
export type GetOwnerContractQueryResult = Apollo.QueryResult<GetOwnerContractQuery, GetOwnerContractQueryVariables>;
export const GetOwnerContractsForListDocument = gql`
    query GetOwnerContractsForList($filterInput: OwnerContractFilterInput) {
  ownerContracts(filterInput: $filterInput) {
    items {
      id
      createdAt
      startDate
      finishDate
      ownerContractLeaseTypeOption
      contractStatusOption
      contractAmount
      owner {
        firstName
        lastName
      }
      property {
        id
        name
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetOwnerContractsForListQuery__
 *
 * To run a query within a React component, call `useGetOwnerContractsForListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerContractsForListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerContractsForListQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetOwnerContractsForListQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnerContractsForListQuery, GetOwnerContractsForListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerContractsForListQuery, GetOwnerContractsForListQueryVariables>(GetOwnerContractsForListDocument, options);
      }
export function useGetOwnerContractsForListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerContractsForListQuery, GetOwnerContractsForListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerContractsForListQuery, GetOwnerContractsForListQueryVariables>(GetOwnerContractsForListDocument, options);
        }
export function useGetOwnerContractsForListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnerContractsForListQuery, GetOwnerContractsForListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnerContractsForListQuery, GetOwnerContractsForListQueryVariables>(GetOwnerContractsForListDocument, options);
        }
export type GetOwnerContractsForListQueryHookResult = ReturnType<typeof useGetOwnerContractsForListQuery>;
export type GetOwnerContractsForListLazyQueryHookResult = ReturnType<typeof useGetOwnerContractsForListLazyQuery>;
export type GetOwnerContractsForListSuspenseQueryHookResult = ReturnType<typeof useGetOwnerContractsForListSuspenseQuery>;
export type GetOwnerContractsForListQueryResult = Apollo.QueryResult<GetOwnerContractsForListQuery, GetOwnerContractsForListQueryVariables>;
export const GetOwnerDetailDocument = gql`
    query GetOwnerDetail($id: String!) {
  owner(id: $id) {
    firstName
    lastName
    phoneNumber
    phoneNumber2
    documentId
    nationality
    birthDate
    genderOption
    user {
      id
      email
    }
    address {
      street
      buildingNumber
      addressLine
      city {
        geonamesId
        name
      }
      state {
        geonamesAdmin1Code
        name
      }
      country {
        iso2
        name
      }
      zipCode
    }
    bankAccount {
      name
      holderName
      accountNumber
      email
      phone
    }
  }
}
    `;

/**
 * __useGetOwnerDetailQuery__
 *
 * To run a query within a React component, call `useGetOwnerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOwnerDetailQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerDetailQuery, GetOwnerDetailQueryVariables> & ({ variables: GetOwnerDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerDetailQuery, GetOwnerDetailQueryVariables>(GetOwnerDetailDocument, options);
      }
export function useGetOwnerDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerDetailQuery, GetOwnerDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerDetailQuery, GetOwnerDetailQueryVariables>(GetOwnerDetailDocument, options);
        }
export function useGetOwnerDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnerDetailQuery, GetOwnerDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnerDetailQuery, GetOwnerDetailQueryVariables>(GetOwnerDetailDocument, options);
        }
export type GetOwnerDetailQueryHookResult = ReturnType<typeof useGetOwnerDetailQuery>;
export type GetOwnerDetailLazyQueryHookResult = ReturnType<typeof useGetOwnerDetailLazyQuery>;
export type GetOwnerDetailSuspenseQueryHookResult = ReturnType<typeof useGetOwnerDetailSuspenseQuery>;
export type GetOwnerDetailQueryResult = Apollo.QueryResult<GetOwnerDetailQuery, GetOwnerDetailQueryVariables>;
export const GetOwnersDocument = gql`
    query getOwners($filterInput: OwnerFilterInput) {
  owners(filterInput: $filterInput) {
    items {
      id
      firstName
      lastName
      phoneNumber
      isActive
      address {
        street
        city {
          geonamesId
          name
        }
        state {
          geonamesAdmin1Code
          name
        }
      }
      user {
        id
        email
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetOwnersQuery__
 *
 * To run a query within a React component, call `useGetOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnersQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetOwnersQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnersQuery, GetOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnersQuery, GetOwnersQueryVariables>(GetOwnersDocument, options);
      }
export function useGetOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnersQuery, GetOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnersQuery, GetOwnersQueryVariables>(GetOwnersDocument, options);
        }
export function useGetOwnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnersQuery, GetOwnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnersQuery, GetOwnersQueryVariables>(GetOwnersDocument, options);
        }
export type GetOwnersQueryHookResult = ReturnType<typeof useGetOwnersQuery>;
export type GetOwnersLazyQueryHookResult = ReturnType<typeof useGetOwnersLazyQuery>;
export type GetOwnersSuspenseQueryHookResult = ReturnType<typeof useGetOwnersSuspenseQuery>;
export type GetOwnersQueryResult = Apollo.QueryResult<GetOwnersQuery, GetOwnersQueryVariables>;
export const GetOwnersSimpleDocument = gql`
    query getOwnersSimple {
  owners {
    items {
      firstName
      lastName
      isActive
      address {
        city {
          geonamesId
          name
        }
        state {
          geonamesAdmin1Code
          name
        }
      }
      user {
        id
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetOwnersSimpleQuery__
 *
 * To run a query within a React component, call `useGetOwnersSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnersSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnersSimpleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOwnersSimpleQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnersSimpleQuery, GetOwnersSimpleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnersSimpleQuery, GetOwnersSimpleQueryVariables>(GetOwnersSimpleDocument, options);
      }
export function useGetOwnersSimpleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnersSimpleQuery, GetOwnersSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnersSimpleQuery, GetOwnersSimpleQueryVariables>(GetOwnersSimpleDocument, options);
        }
export function useGetOwnersSimpleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnersSimpleQuery, GetOwnersSimpleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnersSimpleQuery, GetOwnersSimpleQueryVariables>(GetOwnersSimpleDocument, options);
        }
export type GetOwnersSimpleQueryHookResult = ReturnType<typeof useGetOwnersSimpleQuery>;
export type GetOwnersSimpleLazyQueryHookResult = ReturnType<typeof useGetOwnersSimpleLazyQuery>;
export type GetOwnersSimpleSuspenseQueryHookResult = ReturnType<typeof useGetOwnersSimpleSuspenseQuery>;
export type GetOwnersSimpleQueryResult = Apollo.QueryResult<GetOwnersSimpleQuery, GetOwnersSimpleQueryVariables>;
export const GetPropertiesDocument = gql`
    query GetProperties($input: PropertyFilterInput) {
  properties(filterInput: $input) {
    items {
      id
      name
      typeOption
      occupancyStatusOption
      balcony
      patio
      commonBathroom
      kitchen
      elevator
      commonAirConditioner
      commonFan
      unities {
        id
        name
        bedSizeOption
        privateBathroom
        fan
        airConditioner
        currentStatusOption
      }
      address {
        city {
          geonamesId
          name
        }
        state {
          geonamesAdmin1Code
          name
        }
      }
      owner {
        firstName
        lastName
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetPropertiesQuery__
 *
 * To run a query within a React component, call `useGetPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertiesQuery, GetPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertiesQuery, GetPropertiesQueryVariables>(GetPropertiesDocument, options);
      }
export function useGetPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertiesQuery, GetPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertiesQuery, GetPropertiesQueryVariables>(GetPropertiesDocument, options);
        }
export function useGetPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertiesQuery, GetPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertiesQuery, GetPropertiesQueryVariables>(GetPropertiesDocument, options);
        }
export type GetPropertiesQueryHookResult = ReturnType<typeof useGetPropertiesQuery>;
export type GetPropertiesLazyQueryHookResult = ReturnType<typeof useGetPropertiesLazyQuery>;
export type GetPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetPropertiesSuspenseQuery>;
export type GetPropertiesQueryResult = Apollo.QueryResult<GetPropertiesQuery, GetPropertiesQueryVariables>;
export const GetPropertiesForContractsDocument = gql`
    query GetPropertiesForContracts($input: PropertyFilterInput) {
  properties(filterInput: $input) {
    items {
      id
      name
      isForRentWhole
      occupancyStatusOption
      address {
        street
        city {
          geonamesId
          name
        }
        state {
          geonamesAdmin1Code
          name
        }
      }
      unities {
        id
        name
        bedSizeOption
        privateBathroom
        fan
        airConditioner
        currentStatusOption
      }
      owner {
        firstName
        lastName
        user {
          id
        }
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetPropertiesForContractsQuery__
 *
 * To run a query within a React component, call `useGetPropertiesForContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesForContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesForContractsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPropertiesForContractsQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertiesForContractsQuery, GetPropertiesForContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertiesForContractsQuery, GetPropertiesForContractsQueryVariables>(GetPropertiesForContractsDocument, options);
      }
export function useGetPropertiesForContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertiesForContractsQuery, GetPropertiesForContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertiesForContractsQuery, GetPropertiesForContractsQueryVariables>(GetPropertiesForContractsDocument, options);
        }
export function useGetPropertiesForContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertiesForContractsQuery, GetPropertiesForContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertiesForContractsQuery, GetPropertiesForContractsQueryVariables>(GetPropertiesForContractsDocument, options);
        }
export type GetPropertiesForContractsQueryHookResult = ReturnType<typeof useGetPropertiesForContractsQuery>;
export type GetPropertiesForContractsLazyQueryHookResult = ReturnType<typeof useGetPropertiesForContractsLazyQuery>;
export type GetPropertiesForContractsSuspenseQueryHookResult = ReturnType<typeof useGetPropertiesForContractsSuspenseQuery>;
export type GetPropertiesForContractsQueryResult = Apollo.QueryResult<GetPropertiesForContractsQuery, GetPropertiesForContractsQueryVariables>;
export const GetPropertiesForOwnerContractCreationDocument = gql`
    query GetPropertiesForOwnerContractCreation($ownerId: String!) {
  propertiesByOwner(ownerId: $ownerId) {
    id
    name
    occupancyStatusOption
    address {
      street
      city {
        name
      }
      state {
        name
      }
    }
  }
}
    `;

/**
 * __useGetPropertiesForOwnerContractCreationQuery__
 *
 * To run a query within a React component, call `useGetPropertiesForOwnerContractCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesForOwnerContractCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesForOwnerContractCreationQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *   },
 * });
 */
export function useGetPropertiesForOwnerContractCreationQuery(baseOptions: Apollo.QueryHookOptions<GetPropertiesForOwnerContractCreationQuery, GetPropertiesForOwnerContractCreationQueryVariables> & ({ variables: GetPropertiesForOwnerContractCreationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertiesForOwnerContractCreationQuery, GetPropertiesForOwnerContractCreationQueryVariables>(GetPropertiesForOwnerContractCreationDocument, options);
      }
export function useGetPropertiesForOwnerContractCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertiesForOwnerContractCreationQuery, GetPropertiesForOwnerContractCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertiesForOwnerContractCreationQuery, GetPropertiesForOwnerContractCreationQueryVariables>(GetPropertiesForOwnerContractCreationDocument, options);
        }
export function useGetPropertiesForOwnerContractCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertiesForOwnerContractCreationQuery, GetPropertiesForOwnerContractCreationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertiesForOwnerContractCreationQuery, GetPropertiesForOwnerContractCreationQueryVariables>(GetPropertiesForOwnerContractCreationDocument, options);
        }
export type GetPropertiesForOwnerContractCreationQueryHookResult = ReturnType<typeof useGetPropertiesForOwnerContractCreationQuery>;
export type GetPropertiesForOwnerContractCreationLazyQueryHookResult = ReturnType<typeof useGetPropertiesForOwnerContractCreationLazyQuery>;
export type GetPropertiesForOwnerContractCreationSuspenseQueryHookResult = ReturnType<typeof useGetPropertiesForOwnerContractCreationSuspenseQuery>;
export type GetPropertiesForOwnerContractCreationQueryResult = Apollo.QueryResult<GetPropertiesForOwnerContractCreationQuery, GetPropertiesForOwnerContractCreationQueryVariables>;
export const GetPropertyDocument = gql`
    query GetProperty($id: String!) {
  property(id: $id) {
    id
    name
    typeOption
    occupancyStatusOption
    isForRentWhole
    balcony
    patio
    commonBathroom
    kitchen
    elevator
    commonAirConditioner
    commonFan
    owner {
      firstName
      lastName
      user {
        id
      }
    }
    unities {
      id
      name
      bedSizeOption
      privateBathroom
      fan
      airConditioner
      currentStatusOption
      contracts {
        id
        createdAt
        finishDate
        statusOption
        rentAmount
        tenant {
          firstName
          lastName
          phoneNumber
          user {
            id
            email
          }
        }
      }
    }
    address {
      street
      buildingNumber
      addressLine
      city {
        geonamesId
        name
      }
      state {
        geonamesAdmin1Code
        name
      }
      country {
        iso2
        name
      }
      zipCode
    }
    notes {
      id
      text
      createdAt
      ownerFirstName
      ownerLastName
    }
    insurances {
      id
      insuranceCompany
      insurancePhone
      policyNumber
      insuranceHolder
      holderDocument
      insuranceBroker
      insuranceBrokerPhone
      insuranceBrokerEmail
      policyPlan
    }
    contacts {
      id
      firstName
      lastName
      phoneNumber
      email
    }
    incidents {
      id
      subject
      incidentTypeOption
      incidentCategoryOption
      priorityOption
      statusOption
      startDate
      endDate
      unity {
        name
      }
      supplier {
        firstName
        lastName
        user {
          id
        }
      }
    }
    fileUploads {
      id
      urlToDownload
      fileTypeOption
    }
  }
}
    `;

/**
 * __useGetPropertyQuery__
 *
 * To run a query within a React component, call `useGetPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables> & ({ variables: GetPropertyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
      }
export function useGetPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
        }
export function useGetPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
        }
export type GetPropertyQueryHookResult = ReturnType<typeof useGetPropertyQuery>;
export type GetPropertyLazyQueryHookResult = ReturnType<typeof useGetPropertyLazyQuery>;
export type GetPropertySuspenseQueryHookResult = ReturnType<typeof useGetPropertySuspenseQuery>;
export type GetPropertyQueryResult = Apollo.QueryResult<GetPropertyQuery, GetPropertyQueryVariables>;
export const GetRedsysConfigurationDocument = gql`
    query GetRedsysConfiguration {
  getRedsysConfiguration {
    __typename
    ... on RedsysUserConfigOutput {
      terminal
      merchantCode
    }
    ... on ActionResponseMessageOutput {
      responseType
      code
      message
    }
  }
}
    `;

/**
 * __useGetRedsysConfigurationQuery__
 *
 * To run a query within a React component, call `useGetRedsysConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedsysConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedsysConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRedsysConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GetRedsysConfigurationQuery, GetRedsysConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRedsysConfigurationQuery, GetRedsysConfigurationQueryVariables>(GetRedsysConfigurationDocument, options);
      }
export function useGetRedsysConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRedsysConfigurationQuery, GetRedsysConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRedsysConfigurationQuery, GetRedsysConfigurationQueryVariables>(GetRedsysConfigurationDocument, options);
        }
export function useGetRedsysConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRedsysConfigurationQuery, GetRedsysConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRedsysConfigurationQuery, GetRedsysConfigurationQueryVariables>(GetRedsysConfigurationDocument, options);
        }
export type GetRedsysConfigurationQueryHookResult = ReturnType<typeof useGetRedsysConfigurationQuery>;
export type GetRedsysConfigurationLazyQueryHookResult = ReturnType<typeof useGetRedsysConfigurationLazyQuery>;
export type GetRedsysConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetRedsysConfigurationSuspenseQuery>;
export type GetRedsysConfigurationQueryResult = Apollo.QueryResult<GetRedsysConfigurationQuery, GetRedsysConfigurationQueryVariables>;
export const GetRentChargeDetailDocument = gql`
    query GetRentChargeDetail($rentChargeId: String!) {
  rentCharge(id: $rentChargeId) {
    id
    rentChargeTypeOption
    description
    amountValue
    rentChargeStatusOption
    currencyOption
    executionDate
    dueDate
  }
}
    `;

/**
 * __useGetRentChargeDetailQuery__
 *
 * To run a query within a React component, call `useGetRentChargeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentChargeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentChargeDetailQuery({
 *   variables: {
 *      rentChargeId: // value for 'rentChargeId'
 *   },
 * });
 */
export function useGetRentChargeDetailQuery(baseOptions: Apollo.QueryHookOptions<GetRentChargeDetailQuery, GetRentChargeDetailQueryVariables> & ({ variables: GetRentChargeDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentChargeDetailQuery, GetRentChargeDetailQueryVariables>(GetRentChargeDetailDocument, options);
      }
export function useGetRentChargeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentChargeDetailQuery, GetRentChargeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentChargeDetailQuery, GetRentChargeDetailQueryVariables>(GetRentChargeDetailDocument, options);
        }
export function useGetRentChargeDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRentChargeDetailQuery, GetRentChargeDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRentChargeDetailQuery, GetRentChargeDetailQueryVariables>(GetRentChargeDetailDocument, options);
        }
export type GetRentChargeDetailQueryHookResult = ReturnType<typeof useGetRentChargeDetailQuery>;
export type GetRentChargeDetailLazyQueryHookResult = ReturnType<typeof useGetRentChargeDetailLazyQuery>;
export type GetRentChargeDetailSuspenseQueryHookResult = ReturnType<typeof useGetRentChargeDetailSuspenseQuery>;
export type GetRentChargeDetailQueryResult = Apollo.QueryResult<GetRentChargeDetailQuery, GetRentChargeDetailQueryVariables>;
export const GetRentChargesReportDocument = gql`
    query GetRentChargesReport($filterInput: RentChargesReportFilterInput) {
  rentChargesReport(filterInput: $filterInput) {
    items {
      id
      rentChargeTypeOption
      description
      executionDate
      dueDate
      amountValue
      rentChargeStatusOption
      currencyOption
      tenant {
        firstName
        lastName
      }
      payments {
        id
        createdAt
        paymentStatusOption
        amountValue
        providerData {
          __typename
          ... on StripePaymentReportOutput {
            operationId
          }
          ... on RedsysPaymentReportOutput {
            order
          }
          ... on DepositPaymentReportOutput {
            ownerAccountName
            reference
          }
        }
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetRentChargesReportQuery__
 *
 * To run a query within a React component, call `useGetRentChargesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentChargesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentChargesReportQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetRentChargesReportQuery(baseOptions?: Apollo.QueryHookOptions<GetRentChargesReportQuery, GetRentChargesReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentChargesReportQuery, GetRentChargesReportQueryVariables>(GetRentChargesReportDocument, options);
      }
export function useGetRentChargesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentChargesReportQuery, GetRentChargesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentChargesReportQuery, GetRentChargesReportQueryVariables>(GetRentChargesReportDocument, options);
        }
export function useGetRentChargesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRentChargesReportQuery, GetRentChargesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRentChargesReportQuery, GetRentChargesReportQueryVariables>(GetRentChargesReportDocument, options);
        }
export type GetRentChargesReportQueryHookResult = ReturnType<typeof useGetRentChargesReportQuery>;
export type GetRentChargesReportLazyQueryHookResult = ReturnType<typeof useGetRentChargesReportLazyQuery>;
export type GetRentChargesReportSuspenseQueryHookResult = ReturnType<typeof useGetRentChargesReportSuspenseQuery>;
export type GetRentChargesReportQueryResult = Apollo.QueryResult<GetRentChargesReportQuery, GetRentChargesReportQueryVariables>;
export const GetStateDocument = gql`
    query GetState($stateCode: String!) {
  state(code: $stateCode) {
    name
  }
}
    `;

/**
 * __useGetStateQuery__
 *
 * To run a query within a React component, call `useGetStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateQuery({
 *   variables: {
 *      stateCode: // value for 'stateCode'
 *   },
 * });
 */
export function useGetStateQuery(baseOptions: Apollo.QueryHookOptions<GetStateQuery, GetStateQueryVariables> & ({ variables: GetStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStateQuery, GetStateQueryVariables>(GetStateDocument, options);
      }
export function useGetStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateQuery, GetStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStateQuery, GetStateQueryVariables>(GetStateDocument, options);
        }
export function useGetStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStateQuery, GetStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStateQuery, GetStateQueryVariables>(GetStateDocument, options);
        }
export type GetStateQueryHookResult = ReturnType<typeof useGetStateQuery>;
export type GetStateLazyQueryHookResult = ReturnType<typeof useGetStateLazyQuery>;
export type GetStateSuspenseQueryHookResult = ReturnType<typeof useGetStateSuspenseQuery>;
export type GetStateQueryResult = Apollo.QueryResult<GetStateQuery, GetStateQueryVariables>;
export const GetAllStatesDocument = gql`
    query GetAllStates($countryCode: String!) {
  states(countryId: $countryCode) {
    name
    geonamesAdmin1Code
  }
}
    `;

/**
 * __useGetAllStatesQuery__
 *
 * To run a query within a React component, call `useGetAllStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStatesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetAllStatesQuery(baseOptions: Apollo.QueryHookOptions<GetAllStatesQuery, GetAllStatesQueryVariables> & ({ variables: GetAllStatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStatesQuery, GetAllStatesQueryVariables>(GetAllStatesDocument, options);
      }
export function useGetAllStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStatesQuery, GetAllStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStatesQuery, GetAllStatesQueryVariables>(GetAllStatesDocument, options);
        }
export function useGetAllStatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStatesQuery, GetAllStatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStatesQuery, GetAllStatesQueryVariables>(GetAllStatesDocument, options);
        }
export type GetAllStatesQueryHookResult = ReturnType<typeof useGetAllStatesQuery>;
export type GetAllStatesLazyQueryHookResult = ReturnType<typeof useGetAllStatesLazyQuery>;
export type GetAllStatesSuspenseQueryHookResult = ReturnType<typeof useGetAllStatesSuspenseQuery>;
export type GetAllStatesQueryResult = Apollo.QueryResult<GetAllStatesQuery, GetAllStatesQueryVariables>;
export const GetSupplierDetailDocument = gql`
    query GetSupplierDetail($id: String!) {
  supplier(id: $id) {
    firstName
    lastName
    phoneNumber
    phoneNumber2
    documentId
    nationality
    birthDate
    genderOption
    user {
      id
      email
    }
    address {
      street
      buildingNumber
      addressLine
      city {
        geonamesId
        name
      }
      state {
        geonamesAdmin1Code
        name
      }
      country {
        iso2
        name
      }
      zipCode
    }
    bankAccount {
      name
      holderName
      accountNumber
      email
      phone
    }
  }
}
    `;

/**
 * __useGetSupplierDetailQuery__
 *
 * To run a query within a React component, call `useGetSupplierDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplierDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplierDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSupplierDetailQuery(baseOptions: Apollo.QueryHookOptions<GetSupplierDetailQuery, GetSupplierDetailQueryVariables> & ({ variables: GetSupplierDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupplierDetailQuery, GetSupplierDetailQueryVariables>(GetSupplierDetailDocument, options);
      }
export function useGetSupplierDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupplierDetailQuery, GetSupplierDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupplierDetailQuery, GetSupplierDetailQueryVariables>(GetSupplierDetailDocument, options);
        }
export function useGetSupplierDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSupplierDetailQuery, GetSupplierDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupplierDetailQuery, GetSupplierDetailQueryVariables>(GetSupplierDetailDocument, options);
        }
export type GetSupplierDetailQueryHookResult = ReturnType<typeof useGetSupplierDetailQuery>;
export type GetSupplierDetailLazyQueryHookResult = ReturnType<typeof useGetSupplierDetailLazyQuery>;
export type GetSupplierDetailSuspenseQueryHookResult = ReturnType<typeof useGetSupplierDetailSuspenseQuery>;
export type GetSupplierDetailQueryResult = Apollo.QueryResult<GetSupplierDetailQuery, GetSupplierDetailQueryVariables>;
export const GetSuppliersDocument = gql`
    query getSuppliers($filterInput: SupplierFilterInput) {
  suppliers(filterInput: $filterInput) {
    items {
      id
      firstName
      lastName
      phoneNumber
      isActive
      user {
        id
      }
      address {
        street
        city {
          geonamesId
          name
        }
        state {
          geonamesAdmin1Code
          name
        }
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetSuppliersQuery__
 *
 * To run a query within a React component, call `useGetSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuppliersQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
      }
export function useGetSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
        }
export function useGetSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
        }
export type GetSuppliersQueryHookResult = ReturnType<typeof useGetSuppliersQuery>;
export type GetSuppliersLazyQueryHookResult = ReturnType<typeof useGetSuppliersLazyQuery>;
export type GetSuppliersSuspenseQueryHookResult = ReturnType<typeof useGetSuppliersSuspenseQuery>;
export type GetSuppliersQueryResult = Apollo.QueryResult<GetSuppliersQuery, GetSuppliersQueryVariables>;
export const GetSuppliersMinimalDocument = gql`
    query getSuppliersMinimal {
  suppliers {
    items {
      firstName
      lastName
      isActive
      user {
        id
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetSuppliersMinimalQuery__
 *
 * To run a query within a React component, call `useGetSuppliersMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuppliersMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuppliersMinimalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuppliersMinimalQuery(baseOptions?: Apollo.QueryHookOptions<GetSuppliersMinimalQuery, GetSuppliersMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuppliersMinimalQuery, GetSuppliersMinimalQueryVariables>(GetSuppliersMinimalDocument, options);
      }
export function useGetSuppliersMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuppliersMinimalQuery, GetSuppliersMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuppliersMinimalQuery, GetSuppliersMinimalQueryVariables>(GetSuppliersMinimalDocument, options);
        }
export function useGetSuppliersMinimalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuppliersMinimalQuery, GetSuppliersMinimalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuppliersMinimalQuery, GetSuppliersMinimalQueryVariables>(GetSuppliersMinimalDocument, options);
        }
export type GetSuppliersMinimalQueryHookResult = ReturnType<typeof useGetSuppliersMinimalQuery>;
export type GetSuppliersMinimalLazyQueryHookResult = ReturnType<typeof useGetSuppliersMinimalLazyQuery>;
export type GetSuppliersMinimalSuspenseQueryHookResult = ReturnType<typeof useGetSuppliersMinimalSuspenseQuery>;
export type GetSuppliersMinimalQueryResult = Apollo.QueryResult<GetSuppliersMinimalQuery, GetSuppliersMinimalQueryVariables>;
export const GetSuppliersSimpleDocument = gql`
    query getSuppliersSimple {
  suppliers {
    items {
      firstName
      lastName
      isActive
      address {
        city {
          geonamesId
          name
        }
        state {
          geonamesAdmin1Code
          name
        }
      }
      user {
        id
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetSuppliersSimpleQuery__
 *
 * To run a query within a React component, call `useGetSuppliersSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuppliersSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuppliersSimpleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuppliersSimpleQuery(baseOptions?: Apollo.QueryHookOptions<GetSuppliersSimpleQuery, GetSuppliersSimpleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuppliersSimpleQuery, GetSuppliersSimpleQueryVariables>(GetSuppliersSimpleDocument, options);
      }
export function useGetSuppliersSimpleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuppliersSimpleQuery, GetSuppliersSimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuppliersSimpleQuery, GetSuppliersSimpleQueryVariables>(GetSuppliersSimpleDocument, options);
        }
export function useGetSuppliersSimpleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuppliersSimpleQuery, GetSuppliersSimpleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuppliersSimpleQuery, GetSuppliersSimpleQueryVariables>(GetSuppliersSimpleDocument, options);
        }
export type GetSuppliersSimpleQueryHookResult = ReturnType<typeof useGetSuppliersSimpleQuery>;
export type GetSuppliersSimpleLazyQueryHookResult = ReturnType<typeof useGetSuppliersSimpleLazyQuery>;
export type GetSuppliersSimpleSuspenseQueryHookResult = ReturnType<typeof useGetSuppliersSimpleSuspenseQuery>;
export type GetSuppliersSimpleQueryResult = Apollo.QueryResult<GetSuppliersSimpleQuery, GetSuppliersSimpleQueryVariables>;
export const GetTenantDetailDocument = gql`
    query GetTenantDetail($id: String) {
  tenant(id: $id) {
    firstName
    lastName
    phoneNumber
    phoneNumber2
    documentId
    nationality
    birthDate
    genderOption
    user {
      id
      email
    }
    address {
      street
      buildingNumber
      addressLine
      city {
        geonamesId
        name
      }
      state {
        geonamesAdmin1Code
        name
      }
      country {
        iso2
        name
      }
      zipCode
    }
    bankAccount {
      name
      holderName
      accountNumber
      email
      phone
    }
  }
}
    `;

/**
 * __useGetTenantDetailQuery__
 *
 * To run a query within a React component, call `useGetTenantDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTenantDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantDetailQuery, GetTenantDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantDetailQuery, GetTenantDetailQueryVariables>(GetTenantDetailDocument, options);
      }
export function useGetTenantDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantDetailQuery, GetTenantDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantDetailQuery, GetTenantDetailQueryVariables>(GetTenantDetailDocument, options);
        }
export function useGetTenantDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantDetailQuery, GetTenantDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantDetailQuery, GetTenantDetailQueryVariables>(GetTenantDetailDocument, options);
        }
export type GetTenantDetailQueryHookResult = ReturnType<typeof useGetTenantDetailQuery>;
export type GetTenantDetailLazyQueryHookResult = ReturnType<typeof useGetTenantDetailLazyQuery>;
export type GetTenantDetailSuspenseQueryHookResult = ReturnType<typeof useGetTenantDetailSuspenseQuery>;
export type GetTenantDetailQueryResult = Apollo.QueryResult<GetTenantDetailQuery, GetTenantDetailQueryVariables>;
export const GetTenantsDocument = gql`
    query getTenants($filterInput: TenantFilterInput) {
  tenants(filterInput: $filterInput) {
    items {
      id
      firstName
      lastName
      phoneNumber
      address {
        street
        city {
          geonamesId
          name
        }
        state {
          geonamesAdmin1Code
          name
        }
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetTenantsQuery__
 *
 * To run a query within a React component, call `useGetTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useGetTenantsQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
      }
export function useGetTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
        }
export function useGetTenantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
        }
export type GetTenantsQueryHookResult = ReturnType<typeof useGetTenantsQuery>;
export type GetTenantsLazyQueryHookResult = ReturnType<typeof useGetTenantsLazyQuery>;
export type GetTenantsSuspenseQueryHookResult = ReturnType<typeof useGetTenantsSuspenseQuery>;
export type GetTenantsQueryResult = Apollo.QueryResult<GetTenantsQuery, GetTenantsQueryVariables>;
export const GetTenantsForContractsDocument = gql`
    query getTenantsForContracts($input: TenantFilterInput) {
  tenants(filterInput: $input) {
    items {
      firstName
      lastName
      genderOption
      user {
        id
        email
      }
      address {
        street
        city {
          geonamesId
          name
        }
        state {
          geonamesAdmin1Code
          name
        }
      }
    }
    pagination {
      totalItems
      totalPages
      currentPage
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetTenantsForContractsQuery__
 *
 * To run a query within a React component, call `useGetTenantsForContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantsForContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantsForContractsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTenantsForContractsQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantsForContractsQuery, GetTenantsForContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantsForContractsQuery, GetTenantsForContractsQueryVariables>(GetTenantsForContractsDocument, options);
      }
export function useGetTenantsForContractsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantsForContractsQuery, GetTenantsForContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantsForContractsQuery, GetTenantsForContractsQueryVariables>(GetTenantsForContractsDocument, options);
        }
export function useGetTenantsForContractsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantsForContractsQuery, GetTenantsForContractsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantsForContractsQuery, GetTenantsForContractsQueryVariables>(GetTenantsForContractsDocument, options);
        }
export type GetTenantsForContractsQueryHookResult = ReturnType<typeof useGetTenantsForContractsQuery>;
export type GetTenantsForContractsLazyQueryHookResult = ReturnType<typeof useGetTenantsForContractsLazyQuery>;
export type GetTenantsForContractsSuspenseQueryHookResult = ReturnType<typeof useGetTenantsForContractsSuspenseQuery>;
export type GetTenantsForContractsQueryResult = Apollo.QueryResult<GetTenantsForContractsQuery, GetTenantsForContractsQueryVariables>;
export const UserConfigurationDocument = gql`
    query UserConfiguration {
  userConfiguration {
    id
    languageOption
    preferredCurrencyOption
  }
}
    `;

/**
 * __useUserConfigurationQuery__
 *
 * To run a query within a React component, call `useUserConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<UserConfigurationQuery, UserConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserConfigurationQuery, UserConfigurationQueryVariables>(UserConfigurationDocument, options);
      }
export function useUserConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserConfigurationQuery, UserConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserConfigurationQuery, UserConfigurationQueryVariables>(UserConfigurationDocument, options);
        }
export function useUserConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserConfigurationQuery, UserConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserConfigurationQuery, UserConfigurationQueryVariables>(UserConfigurationDocument, options);
        }
export type UserConfigurationQueryHookResult = ReturnType<typeof useUserConfigurationQuery>;
export type UserConfigurationLazyQueryHookResult = ReturnType<typeof useUserConfigurationLazyQuery>;
export type UserConfigurationSuspenseQueryHookResult = ReturnType<typeof useUserConfigurationSuspenseQuery>;
export type UserConfigurationQueryResult = Apollo.QueryResult<UserConfigurationQuery, UserConfigurationQueryVariables>;
export const IsLoggedDocument = gql`
    query IsLogged {
  isLogged {
    responseType
    code
    message
  }
}
    `;

/**
 * __useIsLoggedQuery__
 *
 * To run a query within a React component, call `useIsLoggedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsLoggedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsLoggedQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsLoggedQuery(baseOptions?: Apollo.QueryHookOptions<IsLoggedQuery, IsLoggedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsLoggedQuery, IsLoggedQueryVariables>(IsLoggedDocument, options);
      }
export function useIsLoggedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsLoggedQuery, IsLoggedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsLoggedQuery, IsLoggedQueryVariables>(IsLoggedDocument, options);
        }
export function useIsLoggedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsLoggedQuery, IsLoggedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsLoggedQuery, IsLoggedQueryVariables>(IsLoggedDocument, options);
        }
export type IsLoggedQueryHookResult = ReturnType<typeof useIsLoggedQuery>;
export type IsLoggedLazyQueryHookResult = ReturnType<typeof useIsLoggedLazyQuery>;
export type IsLoggedSuspenseQueryHookResult = ReturnType<typeof useIsLoggedSuspenseQuery>;
export type IsLoggedQueryResult = Apollo.QueryResult<IsLoggedQuery, IsLoggedQueryVariables>;
export const TenantDocument = gql`
    query Tenant {
  tenant {
    firstName
    lastName
  }
}
    `;

/**
 * __useTenantQuery__
 *
 * To run a query within a React component, call `useTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantQuery(baseOptions?: Apollo.QueryHookOptions<TenantQuery, TenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
      }
export function useTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantQuery, TenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
        }
export function useTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TenantQuery, TenantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
        }
export type TenantQueryHookResult = ReturnType<typeof useTenantQuery>;
export type TenantLazyQueryHookResult = ReturnType<typeof useTenantLazyQuery>;
export type TenantSuspenseQueryHookResult = ReturnType<typeof useTenantSuspenseQuery>;
export type TenantQueryResult = Apollo.QueryResult<TenantQuery, TenantQueryVariables>;
export const GetOwnManagerDocument = gql`
    query GetOwnManager {
  ownManager {
    firstName
    lastName
  }
}
    `;

/**
 * __useGetOwnManagerQuery__
 *
 * To run a query within a React component, call `useGetOwnManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnManagerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOwnManagerQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnManagerQuery, GetOwnManagerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnManagerQuery, GetOwnManagerQueryVariables>(GetOwnManagerDocument, options);
      }
export function useGetOwnManagerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnManagerQuery, GetOwnManagerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnManagerQuery, GetOwnManagerQueryVariables>(GetOwnManagerDocument, options);
        }
export function useGetOwnManagerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOwnManagerQuery, GetOwnManagerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnManagerQuery, GetOwnManagerQueryVariables>(GetOwnManagerDocument, options);
        }
export type GetOwnManagerQueryHookResult = ReturnType<typeof useGetOwnManagerQuery>;
export type GetOwnManagerLazyQueryHookResult = ReturnType<typeof useGetOwnManagerLazyQuery>;
export type GetOwnManagerSuspenseQueryHookResult = ReturnType<typeof useGetOwnManagerSuspenseQuery>;
export type GetOwnManagerQueryResult = Apollo.QueryResult<GetOwnManagerQuery, GetOwnManagerQueryVariables>;
export const OnNewMessageInIncidentDocument = gql`
    subscription OnNewMessageInIncident($incidentId: String!) {
  newMessageInIncident(incidentId: $incidentId) {
    id
    content
    messageOwnerOption
    messageStatusOption
    senderUserTypeOption
    receiverUserTypeOption
    createdAt
    messageTransactionId
  }
}
    `;

/**
 * __useOnNewMessageInIncidentSubscription__
 *
 * To run a query within a React component, call `useOnNewMessageInIncidentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNewMessageInIncidentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNewMessageInIncidentSubscription({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *   },
 * });
 */
export function useOnNewMessageInIncidentSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnNewMessageInIncidentSubscription, OnNewMessageInIncidentSubscriptionVariables> & ({ variables: OnNewMessageInIncidentSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNewMessageInIncidentSubscription, OnNewMessageInIncidentSubscriptionVariables>(OnNewMessageInIncidentDocument, options);
      }
export type OnNewMessageInIncidentSubscriptionHookResult = ReturnType<typeof useOnNewMessageInIncidentSubscription>;
export type OnNewMessageInIncidentSubscriptionResult = Apollo.SubscriptionResult<OnNewMessageInIncidentSubscription>;
export const NewNotificationDocument = gql`
    subscription NewNotification {
  newNotification {
    id
    type
    message
    read
    createdAt
    additionalData {
      __typename
      ... on PaymentDeadlineNotificationData {
        ownerUserId
        rentCharge {
          id
          amountValue
          description
          dueDate
          executionDate
          rentChargeStatusOption
          rentChargeTypeOption
          currencyOption
        }
      }
      ... on IncidentCreatedNotificationData {
        incidentId
        tenantName
        propertyName
      }
      ... on IncidentAssignedNotificationData {
        incidentId
        incidentSubject
        propertyName
      }
      ... on IncidentReportSubmittedNotificationData {
        incidentId
        incidentReportId
        incidentSubject
        supplierName
      }
      ... on IncidentFollowUpNotificationData {
        incidentId
        incidentSubject
        propertyName
        daysSinceCreation
      }
      ... on MessageCreatedNotificationData {
        messageId
        senderName
        incidentId
      }
      ... on ContractNotificationData {
        contractId
      }
    }
  }
}
    `;

/**
 * __useNewNotificationSubscription__
 *
 * To run a query within a React component, call `useNewNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewNotificationSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewNotificationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewNotificationSubscription, NewNotificationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewNotificationSubscription, NewNotificationSubscriptionVariables>(NewNotificationDocument, options);
      }
export type NewNotificationSubscriptionHookResult = ReturnType<typeof useNewNotificationSubscription>;
export type NewNotificationSubscriptionResult = Apollo.SubscriptionResult<NewNotificationSubscription>;